/* tslint:disable */
/* eslint-disable */
/**
 * Policies
 * An API for managing policies
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@run.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AdvancedFlatFields
 */
export interface AdvancedFlatFields {
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof AdvancedFlatFields
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof AdvancedFlatFields
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof AdvancedFlatFields
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof AdvancedFlatFields
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof AdvancedFlatFields
     */
    'restartPolicy'?: RestartPolicy | null;
}
/**
 * 
 * @export
 * @interface AdvancedFlatFieldsRules
 */
export interface AdvancedFlatFieldsRules {
    /**
     * 
     * @type {BooleanRules}
     * @memberof AdvancedFlatFieldsRules
     */
    'terminateAfterPreemption'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AdvancedFlatFieldsRules
     */
    'autoDeletionTimeAfterCompletionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AdvancedFlatFieldsRules
     */
    'terminationGracePeriodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AdvancedFlatFieldsRules
     */
    'backoffLimit'?: IntegerRules | null;
    /**
     * 
     * @type {RestartPolicyRule}
     * @memberof AdvancedFlatFieldsRules
     */
    'restartPolicy'?: RestartPolicyRule | null;
}
/**
 * 
 * @export
 * @interface AdvancedItemizedDefaults
 */
export interface AdvancedItemizedDefaults {
    /**
     * 
     * @type {AnnotationsDefaults}
     * @memberof AdvancedItemizedDefaults
     */
    'annotations'?: AnnotationsDefaults | null;
    /**
     * 
     * @type {LabelsDefaults}
     * @memberof AdvancedItemizedDefaults
     */
    'labels'?: LabelsDefaults | null;
    /**
     * 
     * @type {TolerationsDefaults}
     * @memberof AdvancedItemizedDefaults
     */
    'tolerations'?: TolerationsDefaults | null;
}
/**
 * 
 * @export
 * @interface AdvancedItemizedRules
 */
export interface AdvancedItemizedRules {
    /**
     * 
     * @type {InstancesRules}
     * @memberof AdvancedItemizedRules
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof AdvancedItemizedRules
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof AdvancedItemizedRules
     */
    'tolerations'?: TolerationsRules | null;
}
/**
 * Annotation details to be populated into the container.
 * @export
 * @interface Annotation
 */
export interface Annotation {
    /**
     * The name of the annotation (mandatory)
     * @type {string}
     * @memberof Annotation
     */
    'name'?: string | null;
    /**
     * The value of the annotation.
     * @type {string}
     * @memberof Annotation
     */
    'value'?: string | null;
    /**
     * Use \'true\' in case the annotation is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof Annotation
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AnnotationsDefaults
 */
export interface AnnotationsDefaults {
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof AnnotationsDefaults
     */
    'instances'?: Array<Annotation> | null;
}
/**
 * 
 * @export
 * @interface AnnotationsFieldDefaults
 */
export interface AnnotationsFieldDefaults {
    /**
     * 
     * @type {AnnotationsDefaults}
     * @memberof AnnotationsFieldDefaults
     */
    'annotations'?: AnnotationsDefaults | null;
}
/**
 * 
 * @export
 * @interface AnnotationsFieldRules
 */
export interface AnnotationsFieldRules {
    /**
     * 
     * @type {InstancesRules}
     * @memberof AnnotationsFieldRules
     */
    'annotations'?: InstancesRules | null;
}
/**
 * 
 * @export
 * @interface ArrayRules
 */
export interface ArrayRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof ArrayRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether this array is mandatory. Mandatory array must include at least one item. default to false.
     * @type {boolean}
     * @memberof ArrayRules
     */
    'required'?: boolean | null;
    /**
     * Set of options that the value of each item of the array must be chosen from.
     * @type {Array<StringOption>}
     * @memberof ArrayRules
     */
    'options'?: Array<StringOption>;
    /**
     * Whether the value of the array, as a whole, is editable. default to false.
     * @type {boolean}
     * @memberof ArrayRules
     */
    'canEdit'?: boolean | null;
}
/**
 * message from assets-service to policy-service about a change in a potentially imposed asset
 * @export
 * @interface AssetChangeNotification
 */
export interface AssetChangeNotification {
    /**
     * 
     * @type {AssetChangeType}
     * @memberof AssetChangeNotification
     */
    'changeType'?: AssetChangeType;
    /**
     * 
     * @type {ScopeType}
     * @memberof AssetChangeNotification
     */
    'scopeType'?: ScopeType;
    /**
     * cluster, department or project id, depending on the scope type
     * @type {string}
     * @memberof AssetChangeNotification
     */
    'scopeId'?: string | null;
}
/**
 * the type of change to report to the policy server
 * @export
 * @enum {string}
 */

export const AssetChangeType = {
    Updated: 'updated',
    Deleted: 'deleted'
} as const;

export type AssetChangeType = typeof AssetChangeType[keyof typeof AssetChangeType];


/**
 * 
 * @export
 * @interface AutoScaling
 */
export interface AutoScaling {
    /**
     * The percentage of metric threshold value to use for autoscaling. Defaults to 70. Applicable only with the \'throughput\' and \'concurrency\' metrics
     * @type {number}
     * @memberof AutoScaling
     */
    'metricThresholdPercentage'?: number | null;
    /**
     * The minimum number of replicas for autoscaling. Defaults to 1. Use 0 to allow scale-to-zero
     * @type {number}
     * @memberof AutoScaling
     */
    'minReplicas'?: number | null;
    /**
     * The maximum number of replicas for autoscaling. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScaling
     */
    'maxReplicas'?: number | null;
    /**
     * The number of replicas to run when initializing the workload for the first time. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScaling
     */
    'initialReplicas'?: number | null;
    /**
     * The number of replicas to run when scaling-up from zero. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScaling
     */
    'activationReplicas'?: number | null;
    /**
     * The maximum number of requests allowed to flow to a single replica at any time. 0 means no limit
     * @type {number}
     * @memberof AutoScaling
     */
    'concurrencyHardLimit'?: number | null;
    /**
     * The minimum amount of time (in seconds) that the last replica will remain active after a scale-to-zero decision. Defaults to 0. Available only if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScaling
     */
    'scaleToZeroRetentionSeconds'?: number | null;
    /**
     * The minimum amount of time (in seconds) that a replica will remain active after a scale-down decision
     * @type {number}
     * @memberof AutoScaling
     */
    'scaleDownDelaySeconds'?: number | null;
    /**
     * The maximum amount of time (in seconds) to wait for the container to become ready
     * @type {number}
     * @memberof AutoScaling
     */
    'initializationTimeoutSeconds'?: number | null;
    /**
     * The metric to use for autoscaling. Mandatory if minReplicas < maxReplicas, except for the special case where minReplicas is set to 0 and maxReplicas is set to 1, as in this case autoscaling decisions are made according to network activity rather than metrics. Use one of the built-in metrics of \'throughput\', \'concurrency\' or \'latency\', or any other available custom metric. Only the \'throughput\' and \'concurrency\' metrics support scale-to-zero
     * @type {string}
     * @memberof AutoScaling
     */
    'metric'?: string | null;
    /**
     * The threshold to use with the specified metric for autoscaling. Mandatory if metric is specified
     * @type {number}
     * @memberof AutoScaling
     */
    'metricThreshold'?: number | null;
}
/**
 * Auto scaling common fields
 * @export
 * @interface AutoScalingCommonFields
 */
export interface AutoScalingCommonFields {
    /**
     * The percentage of metric threshold value to use for autoscaling. Defaults to 70. Applicable only with the \'throughput\' and \'concurrency\' metrics
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'metricThresholdPercentage'?: number | null;
    /**
     * The minimum number of replicas for autoscaling. Defaults to 1. Use 0 to allow scale-to-zero
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'minReplicas'?: number | null;
    /**
     * The maximum number of replicas for autoscaling. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'maxReplicas'?: number | null;
    /**
     * The number of replicas to run when initializing the workload for the first time. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'initialReplicas'?: number | null;
    /**
     * The number of replicas to run when scaling-up from zero. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'activationReplicas'?: number | null;
    /**
     * The maximum number of requests allowed to flow to a single replica at any time. 0 means no limit
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'concurrencyHardLimit'?: number | null;
    /**
     * The minimum amount of time (in seconds) that the last replica will remain active after a scale-to-zero decision. Defaults to 0. Available only if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'scaleToZeroRetentionSeconds'?: number | null;
    /**
     * The minimum amount of time (in seconds) that a replica will remain active after a scale-down decision
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'scaleDownDelaySeconds'?: number | null;
    /**
     * The maximum amount of time (in seconds) to wait for the container to become ready
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'initializationTimeoutSeconds'?: number | null;
}
/**
 * Auto scaling metric fields
 * @export
 * @interface AutoScalingMetricFields
 */
export interface AutoScalingMetricFields {
    /**
     * The metric to use for autoscaling. Mandatory if minReplicas < maxReplicas, except for the special case where minReplicas is set to 0 and maxReplicas is set to 1, as in this case autoscaling decisions are made according to network activity rather than metrics. Use one of the built-in metrics of \'throughput\', \'concurrency\' or \'latency\', or any other available custom metric. Only the \'throughput\' and \'concurrency\' metrics support scale-to-zero
     * @type {string}
     * @memberof AutoScalingMetricFields
     */
    'metric'?: string | null;
    /**
     * The threshold to use with the specified metric for autoscaling. Mandatory if metric is specified
     * @type {number}
     * @memberof AutoScalingMetricFields
     */
    'metricThreshold'?: number | null;
}
/**
 * 
 * @export
 * @interface AutoScalingMetricOptions
 */
export interface AutoScalingMetricOptions {
    /**
     * 
     * @type {Array<AutoScalingMetricOptionsOptionsInner>}
     * @memberof AutoScalingMetricOptions
     */
    'options'?: Array<AutoScalingMetricOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface AutoScalingMetricOptionsOptionsInner
 */
export interface AutoScalingMetricOptionsOptionsInner {
    /**
     * The metric to use for autoscaling. Mandatory if minReplicas < maxReplicas, except for the special case where minReplicas is set to 0 and maxReplicas is set to 1, as in this case autoscaling decisions are made according to network activity rather than metrics. Use one of the built-in metrics of \'throughput\', \'concurrency\' or \'latency\', or any other available custom metric. Only the \'throughput\' and \'concurrency\' metrics support scale-to-zero
     * @type {string}
     * @memberof AutoScalingMetricOptionsOptionsInner
     */
    'value': string | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof AutoScalingMetricOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface AutoScalingMetricRules
 */
export interface AutoScalingMetricRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof AutoScalingMetricRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof AutoScalingMetricRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof AutoScalingMetricRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<AutoScalingMetricOptionsOptionsInner>}
     * @memberof AutoScalingMetricRules
     */
    'options'?: Array<AutoScalingMetricOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface AutoScalingRules
 */
export interface AutoScalingRules {
    /**
     * 
     * @type {NumberRules}
     * @memberof AutoScalingRules
     */
    'metricThresholdPercentage'?: NumberRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'minReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'maxReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'initialReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'activationReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {AutoScalingMetricRules}
     * @memberof AutoScalingRules
     */
    'metric'?: AutoScalingMetricRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'metricThreshold'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'concurrencyHardLimit'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'scaleToZeroRetentionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'scaleDownDelaySeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'initializationTimeoutSeconds'?: IntegerRules | null;
}
/**
 * 
 * @export
 * @interface BooleanRules
 */
export interface BooleanRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof BooleanRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory. default to false.
     * @type {boolean}
     * @memberof BooleanRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable. default to true
     * @type {boolean}
     * @memberof BooleanRules
     */
    'canEdit'?: boolean | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Capability = {
    AuditControl: 'AUDIT_CONTROL',
    AuditRead: 'AUDIT_READ',
    AuditWrite: 'AUDIT_WRITE',
    BlockSuspend: 'BLOCK_SUSPEND',
    Chown: 'CHOWN',
    DacOverride: 'DAC_OVERRIDE',
    DacReadSearch: 'DAC_READ_SEARCH',
    Fowner: 'FOWNER',
    Fsetid: 'FSETID',
    IpcLock: 'IPC_LOCK',
    IpcOwner: 'IPC_OWNER',
    Kill: 'KILL',
    Lease: 'LEASE',
    LinuxImmutable: 'LINUX_IMMUTABLE',
    MacAdmin: 'MAC_ADMIN',
    MacOverride: 'MAC_OVERRIDE',
    Mknod: 'MKNOD',
    NetAdmin: 'NET_ADMIN',
    NetBindService: 'NET_BIND_SERVICE',
    NetBroadcast: 'NET_BROADCAST',
    NetRaw: 'NET_RAW',
    Setgid: 'SETGID',
    Setfcap: 'SETFCAP',
    Setpcap: 'SETPCAP',
    Setuid: 'SETUID',
    SysAdmin: 'SYS_ADMIN',
    SysBoot: 'SYS_BOOT',
    SysChroot: 'SYS_CHROOT',
    SysModule: 'SYS_MODULE',
    SysNice: 'SYS_NICE',
    SysPacct: 'SYS_PACCT',
    SysPtrace: 'SYS_PTRACE',
    SysRawio: 'SYS_RAWIO',
    SysResource: 'SYS_RESOURCE',
    SysTime: 'SYS_TIME',
    SysTtyConfig: 'SYS_TTY_CONFIG',
    Syslog: 'SYSLOG',
    WakeAlarm: 'WAKE_ALARM'
} as const;

export type Capability = typeof Capability[keyof typeof Capability];


/**
 * Claim information for the newly created PVC. The information should not be provided when attempting to use existing PVC.
 * @export
 * @interface ClaimInfo
 */
export interface ClaimInfo {
    /**
     * Requested size for the PVC. Mandatory when existingPvc is false. Recommended sizes: TB/GB/MB/TIB/GIB/MIB
     * @type {string}
     * @memberof ClaimInfo
     */
    'size'?: string | null;
    /**
     * Storage class name to associate with the PVC. This parameter may be omitted if there is a single storage class in the system, or you are using the default storage class. For more information, see [Storage class](https://kubernetes.io/docs/concepts/storage/storage-classes).
     * @type {string}
     * @memberof ClaimInfo
     */
    'storageClass'?: string | null;
    /**
     * 
     * @type {PvcAccessModes}
     * @memberof ClaimInfo
     */
    'accessModes'?: PvcAccessModes | null;
    /**
     * 
     * @type {PvcVolumeMode}
     * @memberof ClaimInfo
     */
    'volumeMode'?: PvcVolumeMode | null;
    /**
     * an optional array of key-values pairs that are written as annotations on the created PVC. the allowed attributes are determined according to the storage class configuration (see k8s-objects-tracker for further info).
     * @type {Array<PvcAddedAttrValue>}
     * @memberof ClaimInfo
     */
    'addedAttrValues'?: Array<PvcAddedAttrValue>;
}
/**
 * 
 * @export
 * @interface ClaimInfoRules
 */
export interface ClaimInfoRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ClaimInfoRules
     */
    'size'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ClaimInfoRules
     */
    'storageClass'?: StringRules | null;
    /**
     * 
     * @type {PvcAccessModesRules}
     * @memberof ClaimInfoRules
     */
    'accessModes'?: PvcAccessModesRules | null;
}
/**
 * Claim information updatable fields.
 * @export
 * @interface ClaimInfoUpdatable
 */
export interface ClaimInfoUpdatable {
    /**
     * Requested size for the PVC. Mandatory when existingPvc is false. Recommended sizes: TB/GB/MB/TIB/GIB/MIB
     * @type {string}
     * @memberof ClaimInfoUpdatable
     */
    'size'?: string | null;
    /**
     * an optional array of key-values pairs that are written as annotations on the created PVC. the allowed attributes are determined according to the storage class configuration (see k8s-objects-tracker for further info).
     * @type {Array<PvcAddedAttrValue>}
     * @memberof ClaimInfoUpdatable
     */
    'addedAttrValues'?: Array<PvcAddedAttrValue>;
}
/**
 * allow cluster to report about success/failures of sync updates
 * @export
 * @interface ClusterSyncReport
 */
export interface ClusterSyncReport {
    /**
     * 
     * @type {Array<ClusterSyncReportUpdate>}
     * @memberof ClusterSyncReport
     */
    'updates'?: Array<ClusterSyncReportUpdate>;
}
/**
 * success/failure report of a single update attempt of the cluster
 * @export
 * @interface ClusterSyncReportUpdate
 */
export interface ClusterSyncReportUpdate {
    /**
     * a unique id of the entity being updated (asset, workload, policy, etc).
     * @type {string}
     * @memberof ClusterSyncReportUpdate
     */
    'id'?: string;
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof ClusterSyncReportUpdate
     */
    'updateCount'?: number;
    /**
     * the time in which the cluster attempted the update.
     * @type {string}
     * @memberof ClusterSyncReportUpdate
     */
    'updateAttemptTime'?: string;
    /**
     * optional failure message for the case that the update has failed. should be sent null if the update was successful.
     * @type {string}
     * @memberof ClusterSyncReportUpdate
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface CommonFlatFields
 */
export interface CommonFlatFields {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof CommonFlatFields
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof CommonFlatFields
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof CommonFlatFields
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof CommonFlatFields
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof CommonFlatFields
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof CommonFlatFields
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof CommonFlatFields
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof CommonFlatFields
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof CommonFlatFields
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof CommonFlatFields
     */
    'podAffinity'?: PodAffinity | null;
}
/**
 * 
 * @export
 * @interface CommonFlatFieldsRules
 */
export interface CommonFlatFieldsRules {
    /**
     * 
     * @type {StringRules}
     * @memberof CommonFlatFieldsRules
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof CommonFlatFieldsRules
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof CommonFlatFieldsRules
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof CommonFlatFieldsRules
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof CommonFlatFieldsRules
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof CommonFlatFieldsRules
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof CommonFlatFieldsRules
     */
    'probes'?: ProbesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof CommonFlatFieldsRules
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof CommonFlatFieldsRules
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof CommonFlatFieldsRules
     */
    'podAffinity'?: PodAffinityRules | null;
}
/**
 * 
 * @export
 * @interface CommonItemizedDefaults
 */
export interface CommonItemizedDefaults {
    /**
     * 
     * @type {EnvironmentVariablesDefaults}
     * @memberof CommonItemizedDefaults
     */
    'environmentVariables'?: EnvironmentVariablesDefaults | null;
    /**
     * 
     * @type {AnnotationsDefaults}
     * @memberof CommonItemizedDefaults
     */
    'annotations'?: AnnotationsDefaults | null;
    /**
     * 
     * @type {LabelsDefaults}
     * @memberof CommonItemizedDefaults
     */
    'labels'?: LabelsDefaults | null;
    /**
     * 
     * @type {TolerationsDefaults}
     * @memberof CommonItemizedDefaults
     */
    'tolerations'?: TolerationsDefaults | null;
}
/**
 * 
 * @export
 * @interface CommonItemizedFieldsRules
 */
export interface CommonItemizedFieldsRules {
    /**
     * 
     * @type {InstancesRules}
     * @memberof CommonItemizedFieldsRules
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof CommonItemizedFieldsRules
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof CommonItemizedFieldsRules
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof CommonItemizedFieldsRules
     */
    'tolerations'?: TolerationsRules | null;
}
/**
 * 
 * @export
 * @interface CommonSecurity
 */
export interface CommonSecurity {
    /**
     * 
     * @type {CommonSecurityFlatFields}
     * @memberof CommonSecurity
     */
    'security'?: CommonSecurityFlatFields | null;
}
/**
 * 
 * @export
 * @interface CommonSecurityFlatFields
 */
export interface CommonSecurityFlatFields {
    /**
     * 
     * @type {UidGidSource}
     * @memberof CommonSecurityFlatFields
     */
    'uidGidSource'?: UidGidSource | null;
    /**
     * Add POSIX capabilities to running containers. Defaults to the default set of capabilities granted by the container runtime.
     * @type {Array<Capability>}
     * @memberof CommonSecurityFlatFields
     */
    'capabilities'?: Array<Capability> | null;
    /**
     * 
     * @type {SeccompProfileType}
     * @memberof CommonSecurityFlatFields
     */
    'seccompProfileType'?: SeccompProfileType | null;
    /**
     * Force the container to run as a non-root user.
     * @type {boolean}
     * @memberof CommonSecurityFlatFields
     */
    'runAsNonRoot'?: boolean | null;
    /**
     * If true, mounts the container\'s root filesystem as read-only.
     * @type {boolean}
     * @memberof CommonSecurityFlatFields
     */
    'readOnlyRootFilesystem'?: boolean | null;
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof CommonSecurityFlatFields
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof CommonSecurityFlatFields
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof CommonSecurityFlatFields
     */
    'supplementalGroups'?: string | null;
}
/**
 * 
 * @export
 * @interface CommonSecurityFlatFieldsRules
 */
export interface CommonSecurityFlatFieldsRules {
    /**
     * 
     * @type {UidGidSourceRules}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'uidGidSource'?: UidGidSourceRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'capabilities'?: ArrayRules | null;
    /**
     * 
     * @type {SeccompProfileTypeRules}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'seccompProfileType'?: SeccompProfileTypeRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'runAsNonRoot'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'readOnlyRootFilesystem'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'runAsUid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'runAsGid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {StringRules}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'supplementalGroups'?: StringRules | null;
}
/**
 * Security non overrideable fields. In the context of assets,these are environment asset fields that cannot be overriden in the submit workload request.
 * @export
 * @interface CommonSecurityNonOverridable
 */
export interface CommonSecurityNonOverridable {
    /**
     * 
     * @type {UidGidSource}
     * @memberof CommonSecurityNonOverridable
     */
    'uidGidSource'?: UidGidSource | null;
    /**
     * Add POSIX capabilities to running containers. Defaults to the default set of capabilities granted by the container runtime.
     * @type {Array<Capability>}
     * @memberof CommonSecurityNonOverridable
     */
    'capabilities'?: Array<Capability> | null;
    /**
     * 
     * @type {SeccompProfileType}
     * @memberof CommonSecurityNonOverridable
     */
    'seccompProfileType'?: SeccompProfileType | null;
    /**
     * Force the container to run as a non-root user.
     * @type {boolean}
     * @memberof CommonSecurityNonOverridable
     */
    'runAsNonRoot'?: boolean | null;
    /**
     * If true, mounts the container\'s root filesystem as read-only.
     * @type {boolean}
     * @memberof CommonSecurityNonOverridable
     */
    'readOnlyRootFilesystem'?: boolean | null;
}
/**
 * 
 * @export
 * @interface CommonSecurityNonOverridableRules
 */
export interface CommonSecurityNonOverridableRules {
    /**
     * 
     * @type {UidGidSourceRules}
     * @memberof CommonSecurityNonOverridableRules
     */
    'uidGidSource'?: UidGidSourceRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof CommonSecurityNonOverridableRules
     */
    'capabilities'?: ArrayRules | null;
    /**
     * 
     * @type {SeccompProfileTypeRules}
     * @memberof CommonSecurityNonOverridableRules
     */
    'seccompProfileType'?: SeccompProfileTypeRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof CommonSecurityNonOverridableRules
     */
    'runAsNonRoot'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof CommonSecurityNonOverridableRules
     */
    'readOnlyRootFilesystem'?: BooleanRules | null;
}
/**
 * Security overrideable fields. In the context of assets,these are environment asset fields that can be overriden in the submit workload request.
 * @export
 * @interface CommonSecurityOverridable
 */
export interface CommonSecurityOverridable {
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof CommonSecurityOverridable
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof CommonSecurityOverridable
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof CommonSecurityOverridable
     */
    'supplementalGroups'?: string | null;
}
/**
 * Security related fields. When used in assets context, those are environment asset fields that can be override in the submit workload request.
 * @export
 * @interface CommonSecurityOverridableRules
 */
export interface CommonSecurityOverridableRules {
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof CommonSecurityOverridableRules
     */
    'runAsUid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof CommonSecurityOverridableRules
     */
    'runAsGid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {StringRules}
     * @memberof CommonSecurityOverridableRules
     */
    'supplementalGroups'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface CommonStorageDefaults
 */
export interface CommonStorageDefaults {
    /**
     * 
     * @type {CommonStorageFieldsDefaults}
     * @memberof CommonStorageDefaults
     */
    'storage'?: CommonStorageFieldsDefaults | null;
}
/**
 * 
 * @export
 * @interface CommonStorageFieldsDefaults
 */
export interface CommonStorageFieldsDefaults {
    /**
     * 
     * @type {DataVolumesDefaults}
     * @memberof CommonStorageFieldsDefaults
     */
    'dataVolume'?: DataVolumesDefaults | null;
    /**
     * 
     * @type {PvcsDefaults}
     * @memberof CommonStorageFieldsDefaults
     */
    'pvc'?: PvcsDefaults | null;
    /**
     * 
     * @type {HostPathsDefaults}
     * @memberof CommonStorageFieldsDefaults
     */
    'hostPath'?: HostPathsDefaults | null;
    /**
     * 
     * @type {NfssDefaults}
     * @memberof CommonStorageFieldsDefaults
     */
    'nfs'?: NfssDefaults | null;
    /**
     * 
     * @type {GitsDefaults}
     * @memberof CommonStorageFieldsDefaults
     */
    'git'?: GitsDefaults | null;
    /**
     * 
     * @type {ConfigMapsDefaults}
     * @memberof CommonStorageFieldsDefaults
     */
    'configMapVolume'?: ConfigMapsDefaults | null;
    /**
     * 
     * @type {SecretsDefaults}
     * @memberof CommonStorageFieldsDefaults
     */
    'secretVolume'?: SecretsDefaults | null;
}
/**
 * 
 * @export
 * @interface CommonStorageFieldsRules
 */
export interface CommonStorageFieldsRules {
    /**
     * 
     * @type {DataVolumesRules}
     * @memberof CommonStorageFieldsRules
     */
    'dataVolume'?: DataVolumesRules | null;
    /**
     * 
     * @type {PvcsRules}
     * @memberof CommonStorageFieldsRules
     */
    'pvc'?: PvcsRules | null;
    /**
     * 
     * @type {HostPathsRules}
     * @memberof CommonStorageFieldsRules
     */
    'hostPath'?: HostPathsRules | null;
    /**
     * 
     * @type {NfssRules}
     * @memberof CommonStorageFieldsRules
     */
    'nfs'?: NfssRules | null;
    /**
     * 
     * @type {GitsRules}
     * @memberof CommonStorageFieldsRules
     */
    'git'?: GitsRules | null;
    /**
     * 
     * @type {ConfigMapsRules}
     * @memberof CommonStorageFieldsRules
     */
    'configMapVolume'?: ConfigMapsRules | null;
    /**
     * 
     * @type {SecretsRules}
     * @memberof CommonStorageFieldsRules
     */
    'secretVolume'?: SecretsRules | null;
}
/**
 * 
 * @export
 * @interface CommonStorageRules
 */
export interface CommonStorageRules {
    /**
     * 
     * @type {CommonStorageFieldsRules}
     * @memberof CommonStorageRules
     */
    'storage'?: CommonStorageFieldsRules | null;
}
/**
 * 
 * @export
 * @interface CompletionsField
 */
export interface CompletionsField {
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof CompletionsField
     */
    'completions'?: number | null;
}
/**
 * 
 * @export
 * @interface ComputeDefaults
 */
export interface ComputeDefaults {
    /**
     * 
     * @type {ComputeFieldsDefaults}
     * @memberof ComputeDefaults
     */
    'compute'?: ComputeFieldsDefaults | null;
}
/**
 * 
 * @export
 * @interface ComputeFieldsDefaults
 */
export interface ComputeFieldsDefaults {
    /**
     * Requested number of GPU devices. Currently if more than one device is requested, it is not possible to provide values for gpuMemory, gpuPortion or migProfile [deprecated].
     * @type {number}
     * @memberof ComputeFieldsDefaults
     */
    'gpuDevicesRequest'?: number | null;
    /**
     * 
     * @type {GpuRequestType}
     * @memberof ComputeFieldsDefaults
     */
    'gpuRequestType'?: GpuRequestType | null;
    /**
     * Required if and only if gpuRequestType is portion. States the portion of the GPU to allocate for the created workload, per GPU device, between 0 and 1. The default is no allocated GPUs.
     * @type {number}
     * @memberof ComputeFieldsDefaults
     */
    'gpuPortionRequest'?: number | null;
    /**
     * Limitations on the portion consumed by the workload, per GPU device. The system guarantees The gpuPotionLimit must be no less than the gpuPortionRequest.
     * @type {number}
     * @memberof ComputeFieldsDefaults
     */
    'gpuPortionLimit'?: number | null;
    /**
     * Required if and only if gpuRequestType is memory. States the GPU memory to allocate for the created workload, per GPU device. Note that the workload will not be scheduled unless the system can guarantee this amount of GPU memory to the workload.
     * @type {string}
     * @memberof ComputeFieldsDefaults
     */
    'gpuMemoryRequest'?: string | null;
    /**
     * Limitation on the memory consumed by the workload, per GPU device. The system guarantees The gpuMemoryLimit must be no less than gpuMemoryRequest.
     * @type {string}
     * @memberof ComputeFieldsDefaults
     */
    'gpuMemoryLimit'?: string | null;
    /**
     * 
     * @type {MigProfile}
     * @memberof ComputeFieldsDefaults
     * @deprecated
     */
    'migProfile'?: MigProfile | null;
    /**
     * CPU units to allocate for the created workload (0.5, 1, .etc). The workload will receive at least this amount of CPU. Note that the workload will not be scheduled unless the system can guarantee this amount of CPUs to the workload.
     * @type {number}
     * @memberof ComputeFieldsDefaults
     */
    'cpuCoreRequest'?: number | null;
    /**
     * Limitations on the number of CPUs consumed by the workload (0.5, 1, .etc). The system guarantees that this workload will not be able to consume more than this amount of CPUs.
     * @type {number}
     * @memberof ComputeFieldsDefaults
     */
    'cpuCoreLimit'?: number | null;
    /**
     * The amount of CPU memory to allocate for this workload (1G, 20M, .etc). The workload will receive at least this amount of memory. Note that the workload will not be scheduled unless the system can guarantee this amount of memory to the workload
     * @type {string}
     * @memberof ComputeFieldsDefaults
     */
    'cpuMemoryRequest'?: string | null;
    /**
     * Limitations on the CPU memory to allocate for this workload (1G, 20M, .etc). The system guarantees that this workload will not be able to consume more than this amount of memory. The workload will receive an error when trying to allocate more memory than this limit.
     * @type {string}
     * @memberof ComputeFieldsDefaults
     */
    'cpuMemoryLimit'?: string | null;
    /**
     * A large /dev/shm device to mount into a container running the created workload. An shm is a shared file system mounted on RAM.
     * @type {boolean}
     * @memberof ComputeFieldsDefaults
     */
    'largeShmRequest'?: boolean | null;
    /**
     * 
     * @type {ExtendedResourcesDefaults}
     * @memberof ComputeFieldsDefaults
     */
    'extendedResources'?: ExtendedResourcesDefaults | null;
}
/**
 * 
 * @export
 * @interface ComputeFieldsRules
 */
export interface ComputeFieldsRules {
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFieldsRules
     */
    'cpuCoreRequest'?: NumberRules | null;
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFieldsRules
     */
    'cpuCoreLimit'?: NumberRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFieldsRules
     */
    'cpuMemoryRequest'?: QuantityRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFieldsRules
     */
    'cpuMemoryLimit'?: QuantityRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof ComputeFieldsRules
     */
    'largeShmRequest'?: BooleanRules | null;
    /**
     * 
     * @type {GpuRequestRules}
     * @memberof ComputeFieldsRules
     */
    'gpuRequestType'?: GpuRequestRules | null;
    /**
     * 
     * @type {MigProfileRules}
     * @memberof ComputeFieldsRules
     */
    'migProfile'?: MigProfileRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ComputeFieldsRules
     */
    'gpuDevicesRequest'?: IntegerRules | null;
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFieldsRules
     */
    'gpuPortionRequest'?: NumberRules | null;
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFieldsRules
     */
    'gpuPortionLimit'?: NumberRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFieldsRules
     */
    'gpuMemoryRequest'?: QuantityRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFieldsRules
     */
    'gpuMemoryLimit'?: QuantityRules | null;
    /**
     * 
     * @type {ExtendedResourcesRules}
     * @memberof ComputeFieldsRules
     */
    'extendedResources'?: ExtendedResourcesRules | null;
}
/**
 * 
 * @export
 * @interface ComputeFlatFields
 */
export interface ComputeFlatFields {
    /**
     * Requested number of GPU devices. Currently if more than one device is requested, it is not possible to provide values for gpuMemory, gpuPortion or migProfile [deprecated].
     * @type {number}
     * @memberof ComputeFlatFields
     */
    'gpuDevicesRequest'?: number | null;
    /**
     * 
     * @type {GpuRequestType}
     * @memberof ComputeFlatFields
     */
    'gpuRequestType'?: GpuRequestType | null;
    /**
     * Required if and only if gpuRequestType is portion. States the portion of the GPU to allocate for the created workload, per GPU device, between 0 and 1. The default is no allocated GPUs.
     * @type {number}
     * @memberof ComputeFlatFields
     */
    'gpuPortionRequest'?: number | null;
    /**
     * Limitations on the portion consumed by the workload, per GPU device. The system guarantees The gpuPotionLimit must be no less than the gpuPortionRequest.
     * @type {number}
     * @memberof ComputeFlatFields
     */
    'gpuPortionLimit'?: number | null;
    /**
     * Required if and only if gpuRequestType is memory. States the GPU memory to allocate for the created workload, per GPU device. Note that the workload will not be scheduled unless the system can guarantee this amount of GPU memory to the workload.
     * @type {string}
     * @memberof ComputeFlatFields
     */
    'gpuMemoryRequest'?: string | null;
    /**
     * Limitation on the memory consumed by the workload, per GPU device. The system guarantees The gpuMemoryLimit must be no less than gpuMemoryRequest.
     * @type {string}
     * @memberof ComputeFlatFields
     */
    'gpuMemoryLimit'?: string | null;
    /**
     * 
     * @type {MigProfile}
     * @memberof ComputeFlatFields
     * @deprecated
     */
    'migProfile'?: MigProfile | null;
    /**
     * CPU units to allocate for the created workload (0.5, 1, .etc). The workload will receive at least this amount of CPU. Note that the workload will not be scheduled unless the system can guarantee this amount of CPUs to the workload.
     * @type {number}
     * @memberof ComputeFlatFields
     */
    'cpuCoreRequest'?: number | null;
    /**
     * Limitations on the number of CPUs consumed by the workload (0.5, 1, .etc). The system guarantees that this workload will not be able to consume more than this amount of CPUs.
     * @type {number}
     * @memberof ComputeFlatFields
     */
    'cpuCoreLimit'?: number | null;
    /**
     * The amount of CPU memory to allocate for this workload (1G, 20M, .etc). The workload will receive at least this amount of memory. Note that the workload will not be scheduled unless the system can guarantee this amount of memory to the workload
     * @type {string}
     * @memberof ComputeFlatFields
     */
    'cpuMemoryRequest'?: string | null;
    /**
     * Limitations on the CPU memory to allocate for this workload (1G, 20M, .etc). The system guarantees that this workload will not be able to consume more than this amount of memory. The workload will receive an error when trying to allocate more memory than this limit.
     * @type {string}
     * @memberof ComputeFlatFields
     */
    'cpuMemoryLimit'?: string | null;
    /**
     * A large /dev/shm device to mount into a container running the created workload. An shm is a shared file system mounted on RAM.
     * @type {boolean}
     * @memberof ComputeFlatFields
     */
    'largeShmRequest'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ComputeFlatFieldsRules
 */
export interface ComputeFlatFieldsRules {
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFlatFieldsRules
     */
    'cpuCoreRequest'?: NumberRules | null;
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFlatFieldsRules
     */
    'cpuCoreLimit'?: NumberRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFlatFieldsRules
     */
    'cpuMemoryRequest'?: QuantityRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFlatFieldsRules
     */
    'cpuMemoryLimit'?: QuantityRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof ComputeFlatFieldsRules
     */
    'largeShmRequest'?: BooleanRules | null;
    /**
     * 
     * @type {GpuRequestRules}
     * @memberof ComputeFlatFieldsRules
     */
    'gpuRequestType'?: GpuRequestRules | null;
    /**
     * 
     * @type {MigProfileRules}
     * @memberof ComputeFlatFieldsRules
     */
    'migProfile'?: MigProfileRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ComputeFlatFieldsRules
     */
    'gpuDevicesRequest'?: IntegerRules | null;
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFlatFieldsRules
     */
    'gpuPortionRequest'?: NumberRules | null;
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFlatFieldsRules
     */
    'gpuPortionLimit'?: NumberRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFlatFieldsRules
     */
    'gpuMemoryRequest'?: QuantityRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFlatFieldsRules
     */
    'gpuMemoryLimit'?: QuantityRules | null;
}
/**
 * 
 * @export
 * @interface ComputeItemizedFieldsDefaults
 */
export interface ComputeItemizedFieldsDefaults {
    /**
     * 
     * @type {ExtendedResourcesDefaults}
     * @memberof ComputeItemizedFieldsDefaults
     */
    'extendedResources'?: ExtendedResourcesDefaults | null;
}
/**
 * 
 * @export
 * @interface ComputeItemizedFieldsRules
 */
export interface ComputeItemizedFieldsRules {
    /**
     * 
     * @type {ExtendedResourcesRules}
     * @memberof ComputeItemizedFieldsRules
     */
    'extendedResources'?: ExtendedResourcesRules | null;
}
/**
 * 
 * @export
 * @interface ComputeRules
 */
export interface ComputeRules {
    /**
     * 
     * @type {ComputeFieldsRules}
     * @memberof ComputeRules
     */
    'compute'?: ComputeFieldsRules | null;
}
/**
 * 
 * @export
 * @interface ConfigMap
 */
export interface ConfigMap {
    /**
     * The name of the ConfigMap resource. (mandatory)
     * @type {string}
     * @memberof ConfigMap
     */
    'configMap'?: string | null;
    /**
     * Local path within the workspace to which the ConfigMap will be mapped to. (mandatory)
     * @type {string}
     * @memberof ConfigMap
     */
    'mountPath'?: string | null;
    /**
     * Path within the volume from which the container\'s volume should be mounted.
     * @type {string}
     * @memberof ConfigMap
     */
    'subPath'?: string | null;
}
/**
 * 
 * @export
 * @interface ConfigMapInstance
 */
export interface ConfigMapInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof ConfigMapInstance
     */
    'name'?: string | null;
    /**
     * The name of the ConfigMap resource. (mandatory)
     * @type {string}
     * @memberof ConfigMapInstance
     */
    'configMap'?: string | null;
    /**
     * Local path within the workspace to which the ConfigMap will be mapped to. (mandatory)
     * @type {string}
     * @memberof ConfigMapInstance
     */
    'mountPath'?: string | null;
    /**
     * Path within the volume from which the container\'s volume should be mounted.
     * @type {string}
     * @memberof ConfigMapInstance
     */
    'subPath'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof ConfigMapInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ConfigMapRules
 */
export interface ConfigMapRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ConfigMapRules
     */
    'configMap'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ConfigMapRules
     */
    'mountPath'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ConfigMapRules
     */
    'subPath'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface ConfigMapsDefaults
 */
export interface ConfigMapsDefaults {
    /**
     * 
     * @type {ConfigMapInstance}
     * @memberof ConfigMapsDefaults
     */
    'attributes'?: ConfigMapInstance | null;
    /**
     * Set of config map volumes to use in the workload
     * @type {Array<ConfigMapInstance>}
     * @memberof ConfigMapsDefaults
     */
    'instances'?: Array<ConfigMapInstance> | null;
}
/**
 * 
 * @export
 * @interface ConfigMapsRules
 */
export interface ConfigMapsRules {
    /**
     * 
     * @type {ConfigMapRules}
     * @memberof ConfigMapsRules
     */
    'attributes'?: ConfigMapRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof ConfigMapsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface ConnectivityDefaults
 */
export interface ConnectivityDefaults {
    /**
     * 
     * @type {PortsDefaults}
     * @memberof ConnectivityDefaults
     */
    'ports'?: PortsDefaults | null;
    /**
     * 
     * @type {ExposedUrlsDefaults}
     * @memberof ConnectivityDefaults
     */
    'exposedUrls'?: ExposedUrlsDefaults | null;
    /**
     * 
     * @type {RelatedUrlsDefaults}
     * @memberof ConnectivityDefaults
     */
    'relatedUrls'?: RelatedUrlsDefaults | null;
}
/**
 * 
 * @export
 * @interface ConnectivityRules
 */
export interface ConnectivityRules {
    /**
     * 
     * @type {PortsRules}
     * @memberof ConnectivityRules
     */
    'ports'?: PortsRules | null;
    /**
     * 
     * @type {ExposedUrlsRules}
     * @memberof ConnectivityRules
     */
    'exposedUrls'?: ExposedUrlsRules | null;
    /**
     * 
     * @type {RelatedUrlsRules}
     * @memberof ConnectivityRules
     */
    'relatedUrls'?: RelatedUrlsRules | null;
}
/**
 * Container non Inference overrideable fields. It adds properties which are not allowed for Inference containers
 * @export
 * @interface ContainerNonInferenceNonOverridable
 */
export interface ContainerNonInferenceNonOverridable {
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof ContainerNonInferenceNonOverridable
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof ContainerNonInferenceNonOverridable
     */
    'stdin'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ContainerNonInferenceNonOverridableRules
 */
export interface ContainerNonInferenceNonOverridableRules {
    /**
     * 
     * @type {BooleanRules}
     * @memberof ContainerNonInferenceNonOverridableRules
     */
    'tty'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof ContainerNonInferenceNonOverridableRules
     */
    'stdin'?: BooleanRules | null;
}
/**
 * Container non overrideable fields. In the context of assets,these are environment asset fields that cannot be overriden in the submit workload request.
 * @export
 * @interface ContainerNonOverridable
 */
export interface ContainerNonOverridable {
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof ContainerNonOverridable
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof ContainerNonOverridable
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof ContainerNonOverridable
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof ContainerNonOverridable
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof ContainerNonOverridable
     */
    'probes'?: Probes | null;
}
/**
 * 
 * @export
 * @interface ContainerNonOverridableRules
 */
export interface ContainerNonOverridableRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ContainerNonOverridableRules
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof ContainerNonOverridableRules
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ContainerNonOverridableRules
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof ContainerNonOverridableRules
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof ContainerNonOverridableRules
     */
    'probes'?: ProbesRules | null;
}
/**
 * Container overrideable fields. In the context of assets,these are environment asset fields that can be overriden in the submit workload request.
 * @export
 * @interface ContainerOverridable
 */
export interface ContainerOverridable {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof ContainerOverridable
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof ContainerOverridable
     */
    'args'?: string | null;
}
/**
 * Container related fields. When used in assets context, those are environment asset fields that can be override in the submit workload request.
 * @export
 * @interface ContainerOverridableRules
 */
export interface ContainerOverridableRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ContainerOverridableRules
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ContainerOverridableRules
     */
    'args'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface DataVolume
 */
export interface DataVolume {
    /**
     * The unique identifier of the data volume. (mandatory)
     * @type {string}
     * @memberof DataVolume
     */
    'id'?: string | null;
    /**
     * The path where the data volume will be mounted. (mandatory)
     * @type {string}
     * @memberof DataVolume
     */
    'mountPath'?: string | null;
}
/**
 * 
 * @export
 * @interface DataVolumeInstance
 */
export interface DataVolumeInstance {
    /**
     * The unique identifier of the data volume. (mandatory)
     * @type {string}
     * @memberof DataVolumeInstance
     */
    'id'?: string | null;
    /**
     * The path where the data volume will be mounted. (mandatory)
     * @type {string}
     * @memberof DataVolumeInstance
     */
    'mountPath'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof DataVolumeInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DataVolumeRules
 */
export interface DataVolumeRules {
    /**
     * 
     * @type {StringRules}
     * @memberof DataVolumeRules
     */
    'id'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof DataVolumeRules
     */
    'mountPath'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface DataVolumesDefaults
 */
export interface DataVolumesDefaults {
    /**
     * 
     * @type {DataVolumeInstance}
     * @memberof DataVolumesDefaults
     */
    'attributes'?: DataVolumeInstance | null;
    /**
     * Set of data volumes to use in the workload.
     * @type {Array<DataVolumeInstance>}
     * @memberof DataVolumesDefaults
     */
    'instances'?: Array<DataVolumeInstance> | null;
}
/**
 * 
 * @export
 * @interface DataVolumesRules
 */
export interface DataVolumesRules {
    /**
     * 
     * @type {DataVolumeRules}
     * @memberof DataVolumesRules
     */
    'attributes'?: DataVolumeRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof DataVolumesRules
     */
    'instances'?: ItemRules | null;
}
/**
 * internal information about the order of calculating defaultFrom rules
 * @export
 * @interface DefaultFromOrder
 */
export interface DefaultFromOrder {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof DefaultFromOrder
     */
    'worker'?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof DefaultFromOrder
     */
    'master'?: { [key: string]: Array<string>; };
}
/**
 * 
 * @export
 * @interface DefaultFromRule
 */
export interface DefaultFromRule {
    /**
     * The default of this field is taken from another field, with optional factor. The specified field must belong to the same workload section (compute, security, etc). For itemized field, the value of the field will be taken from the same instance.
     * @type {string}
     * @memberof DefaultFromRule
     */
    'field'?: string | null;
    /**
     * Multiple the value of the fromField by this factor to get the value for this field For example, if factor is 2 and defaultFrom field has value of 8, the calculated default will be determined to be 16.
     * @type {number}
     * @memberof DefaultFromRule
     */
    'factor'?: number | null;
}
/**
 * The policy describes how to deal with pods when the job is finished.
 * @export
 * @enum {string}
 */

export const DistributedCleanPodPolicy = {
    None: 'None',
    All: 'All',
    Running: 'Running'
} as const;

export type DistributedCleanPodPolicy = typeof DistributedCleanPodPolicy[keyof typeof DistributedCleanPodPolicy];


/**
 * 
 * @export
 * @interface DistributedCleanPodPolicyOptions
 */
export interface DistributedCleanPodPolicyOptions {
    /**
     * 
     * @type {Array<DistributedCleanPodPolicyOptionsOptionsInner>}
     * @memberof DistributedCleanPodPolicyOptions
     */
    'options'?: Array<DistributedCleanPodPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface DistributedCleanPodPolicyOptionsOptionsInner
 */
export interface DistributedCleanPodPolicyOptionsOptionsInner {
    /**
     * 
     * @type {DistributedCleanPodPolicy}
     * @memberof DistributedCleanPodPolicyOptionsOptionsInner
     */
    'value': DistributedCleanPodPolicy | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof DistributedCleanPodPolicyOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface DistributedCleanPodPolicyRules
 */
export interface DistributedCleanPodPolicyRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof DistributedCleanPodPolicyRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof DistributedCleanPodPolicyRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof DistributedCleanPodPolicyRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<DistributedCleanPodPolicyOptionsOptionsInner>}
     * @memberof DistributedCleanPodPolicyRules
     */
    'options'?: Array<DistributedCleanPodPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface DistributedFields
 */
export interface DistributedFields {
    /**
     * the number of workers that will be allocated for running the workload.
     * @type {number}
     * @memberof DistributedFields
     */
    'numWorkers'?: number | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof DistributedFields
     */
    'distributedFramework'?: DistributedFramework | null;
    /**
     * Specifies the number of slots per worker used in hostfile. Defaults to 1. (applicable only for MPI)
     * @type {number}
     * @memberof DistributedFields
     */
    'slotsPerWorker'?: number | null;
    /**
     * Specifies the directory where SSH keys are mounted. (applicable only for MPI)
     * @type {string}
     * @memberof DistributedFields
     */
    'sshAuthMountPath'?: string | null;
    /**
     * 
     * @type {DistributedMpiLauncherCreationPolicy}
     * @memberof DistributedFields
     */
    'mpiLauncherCreationPolicy'?: DistributedMpiLauncherCreationPolicy | null;
    /**
     * the lower limit for the number of worker pods to which the training job can scale down. (applicable only for PyTorch)
     * @type {number}
     * @memberof DistributedFields
     */
    'minReplicas'?: number | null;
    /**
     * the upper limit for the number of worker pods that can be set by the autoscaler. Cannot be smaller than MinReplicas. (applicable only for PyTorch)
     * @type {number}
     * @memberof DistributedFields
     */
    'maxReplicas'?: number | null;
    /**
     * 
     * @type {DistributedCleanPodPolicy}
     * @memberof DistributedFields
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicy | null;
}
/**
 * 
 * @export
 * @interface DistributedFieldsRules
 */
export interface DistributedFieldsRules {
    /**
     * 
     * @type {IntegerRules}
     * @memberof DistributedFieldsRules
     */
    'numWorkers'?: IntegerRules | null;
    /**
     * 
     * @type {DistributedFrameworkRules}
     * @memberof DistributedFieldsRules
     */
    'distributedFramework'?: DistributedFrameworkRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof DistributedFieldsRules
     */
    'slotsPerWorker'?: IntegerRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof DistributedFieldsRules
     */
    'sshAuthMountPath'?: StringRules | null;
    /**
     * 
     * @type {DistributedMpiLauncherCreationPolicyRules}
     * @memberof DistributedFieldsRules
     */
    'mpiLauncherCreationPolicy'?: DistributedMpiLauncherCreationPolicyRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof DistributedFieldsRules
     */
    'minReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof DistributedFieldsRules
     */
    'maxReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {DistributedCleanPodPolicyRules}
     * @memberof DistributedFieldsRules
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicyRules | null;
}
/**
 * The distributed training framework used in the workload.
 * @export
 * @enum {string}
 */

export const DistributedFramework = {
    Mpi: 'MPI',
    PyTorch: 'PyTorch',
    Tf: 'TF',
    XgBoost: 'XGBoost',
    Jax: 'JAX'
} as const;

export type DistributedFramework = typeof DistributedFramework[keyof typeof DistributedFramework];


/**
 * 
 * @export
 * @interface DistributedFrameworkOptions
 */
export interface DistributedFrameworkOptions {
    /**
     * 
     * @type {Array<DistributedFrameworkOptionsOptionsInner>}
     * @memberof DistributedFrameworkOptions
     */
    'options'?: Array<DistributedFrameworkOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface DistributedFrameworkOptionsOptionsInner
 */
export interface DistributedFrameworkOptionsOptionsInner {
    /**
     * 
     * @type {DistributedFramework}
     * @memberof DistributedFrameworkOptionsOptionsInner
     */
    'value': DistributedFramework | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof DistributedFrameworkOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface DistributedFrameworkRules
 */
export interface DistributedFrameworkRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof DistributedFrameworkRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof DistributedFrameworkRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof DistributedFrameworkRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<DistributedFrameworkOptionsOptionsInner>}
     * @memberof DistributedFrameworkRules
     */
    'options'?: Array<DistributedFrameworkOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface DistributedImposedAssets
 */
export interface DistributedImposedAssets {
    /**
     * a list of datasource assets to import into the policy. these datasources will be included in any workload that will be created in the scope of the policy.
     * @type {Array<string>}
     * @memberof DistributedImposedAssets
     */
    'worker'?: Array<string> | null;
    /**
     * a list of datasource assets to import into the policy. these datasources will be included in any workload that will be created in the scope of the policy.
     * @type {Array<string>}
     * @memberof DistributedImposedAssets
     */
    'master'?: Array<string> | null;
}
/**
 * Define whether the MPI Launcher is created in parallel with the workers, or if its creation is postponed until all workers are in  Ready state. This prevents failures when the launcher attempts to connect to workers that are not yet ready.
 * @export
 * @enum {string}
 */

export const DistributedMpiLauncherCreationPolicy = {
    AtStartup: 'AtStartup',
    WaitForWorkersReady: 'WaitForWorkersReady'
} as const;

export type DistributedMpiLauncherCreationPolicy = typeof DistributedMpiLauncherCreationPolicy[keyof typeof DistributedMpiLauncherCreationPolicy];


/**
 * 
 * @export
 * @interface DistributedMpiLauncherCreationPolicyOptions
 */
export interface DistributedMpiLauncherCreationPolicyOptions {
    /**
     * 
     * @type {Array<DistributedMpiLauncherCreationPolicyOptionsOptionsInner>}
     * @memberof DistributedMpiLauncherCreationPolicyOptions
     */
    'options'?: Array<DistributedMpiLauncherCreationPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface DistributedMpiLauncherCreationPolicyOptionsOptionsInner
 */
export interface DistributedMpiLauncherCreationPolicyOptionsOptionsInner {
    /**
     * 
     * @type {DistributedMpiLauncherCreationPolicy}
     * @memberof DistributedMpiLauncherCreationPolicyOptionsOptionsInner
     */
    'value': DistributedMpiLauncherCreationPolicy | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof DistributedMpiLauncherCreationPolicyOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface DistributedMpiLauncherCreationPolicyRules
 */
export interface DistributedMpiLauncherCreationPolicyRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof DistributedMpiLauncherCreationPolicyRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof DistributedMpiLauncherCreationPolicyRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof DistributedMpiLauncherCreationPolicyRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<DistributedMpiLauncherCreationPolicyOptionsOptionsInner>}
     * @memberof DistributedMpiLauncherCreationPolicyRules
     */
    'options'?: Array<DistributedMpiLauncherCreationPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface DistributedPolicyChangeRequestV2
 */
export interface DistributedPolicyChangeRequestV2 {
    /**
     * 
     * @type {PolicyCreationFields}
     * @memberof DistributedPolicyChangeRequestV2
     */
    'meta'?: PolicyCreationFields;
    /**
     * 
     * @type {DistributedPolicyDefaultsAndRulesV2}
     * @memberof DistributedPolicyChangeRequestV2
     */
    'policy'?: DistributedPolicyDefaultsAndRulesV2 | null;
    /**
     * set of fields in jsonpath format that is requested to clear their policy (default and rules)
     * @type {Array<string>}
     * @memberof DistributedPolicyChangeRequestV2
     */
    'reset'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DistributedPolicyDefaultsAndRulesV2
 */
export interface DistributedPolicyDefaultsAndRulesV2 {
    /**
     * 
     * @type {DistributedPolicyDefaultsV2}
     * @memberof DistributedPolicyDefaultsAndRulesV2
     */
    'defaults'?: DistributedPolicyDefaultsV2 | null;
    /**
     * 
     * @type {DistributedPolicyRulesV2}
     * @memberof DistributedPolicyDefaultsAndRulesV2
     */
    'rules'?: DistributedPolicyRulesV2 | null;
    /**
     * 
     * @type {DistributedImposedAssets}
     * @memberof DistributedPolicyDefaultsAndRulesV2
     */
    'imposedAssets'?: DistributedImposedAssets | null;
    /**
     * 
     * @type {PolicyValidationStatus}
     * @memberof DistributedPolicyDefaultsAndRulesV2
     */
    'status'?: PolicyValidationStatus | null;
    /**
     * 
     * @type {DefaultFromOrder}
     * @memberof DistributedPolicyDefaultsAndRulesV2
     */
    'defaultFromOrder'?: DefaultFromOrder | null;
}
/**
 * 
 * @export
 * @interface DistributedPolicyDefaultsV2
 */
export interface DistributedPolicyDefaultsV2 {
    /**
     * 
     * @type {DistributedPolicyDefaultsV2Worker}
     * @memberof DistributedPolicyDefaultsV2
     */
    'worker'?: DistributedPolicyDefaultsV2Worker | null;
    /**
     * 
     * @type {ReplicaDefaultsV2}
     * @memberof DistributedPolicyDefaultsV2
     */
    'master'?: ReplicaDefaultsV2 | null;
}
/**
 * 
 * @export
 * @interface DistributedPolicyDefaultsV2Worker
 */
export interface DistributedPolicyDefaultsV2Worker {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * 
     * @type {EnvironmentVariablesDefaults}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'environmentVariables'?: EnvironmentVariablesDefaults | null;
    /**
     * 
     * @type {AnnotationsDefaults}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'annotations'?: AnnotationsDefaults | null;
    /**
     * 
     * @type {LabelsDefaults}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'labels'?: LabelsDefaults | null;
    /**
     * 
     * @type {TolerationsDefaults}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'tolerations'?: TolerationsDefaults | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * 
     * @type {PortsDefaults}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'ports'?: PortsDefaults | null;
    /**
     * 
     * @type {ExposedUrlsDefaults}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'exposedUrls'?: ExposedUrlsDefaults | null;
    /**
     * 
     * @type {RelatedUrlsDefaults}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'relatedUrls'?: RelatedUrlsDefaults | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'security'?: SecurityFlatFields | null;
    /**
     * 
     * @type {ComputeFieldsDefaults}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'compute'?: ComputeFieldsDefaults | null;
    /**
     * 
     * @type {StorageFieldsDefaults}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'storage'?: StorageFieldsDefaults | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'stdin'?: boolean | null;
    /**
     * the number of workers that will be allocated for running the workload.
     * @type {number}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'numWorkers'?: number | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'distributedFramework'?: DistributedFramework | null;
    /**
     * Specifies the number of slots per worker used in hostfile. Defaults to 1. (applicable only for MPI)
     * @type {number}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'slotsPerWorker'?: number | null;
    /**
     * Specifies the directory where SSH keys are mounted. (applicable only for MPI)
     * @type {string}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'sshAuthMountPath'?: string | null;
    /**
     * 
     * @type {DistributedMpiLauncherCreationPolicy}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'mpiLauncherCreationPolicy'?: DistributedMpiLauncherCreationPolicy | null;
    /**
     * the lower limit for the number of worker pods to which the training job can scale down. (applicable only for PyTorch)
     * @type {number}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'minReplicas'?: number | null;
    /**
     * the upper limit for the number of worker pods that can be set by the autoscaler. Cannot be smaller than MinReplicas. (applicable only for PyTorch)
     * @type {number}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'maxReplicas'?: number | null;
    /**
     * 
     * @type {DistributedCleanPodPolicy}
     * @memberof DistributedPolicyDefaultsV2Worker
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicy | null;
}
/**
 * 
 * @export
 * @interface DistributedPolicyOverwriteRequestV2
 */
export interface DistributedPolicyOverwriteRequestV2 {
    /**
     * 
     * @type {PolicyCreationFields}
     * @memberof DistributedPolicyOverwriteRequestV2
     */
    'meta'?: PolicyCreationFields;
    /**
     * 
     * @type {DistributedPolicyDefaultsAndRulesV2}
     * @memberof DistributedPolicyOverwriteRequestV2
     */
    'policy'?: DistributedPolicyDefaultsAndRulesV2 | null;
}
/**
 * 
 * @export
 * @interface DistributedPolicyRulesV2
 */
export interface DistributedPolicyRulesV2 {
    /**
     * 
     * @type {DistributedPolicyRulesV2Worker}
     * @memberof DistributedPolicyRulesV2
     */
    'worker'?: DistributedPolicyRulesV2Worker | null;
    /**
     * 
     * @type {ReplicaRulesV2}
     * @memberof DistributedPolicyRulesV2
     */
    'master'?: ReplicaRulesV2 | null;
}
/**
 * 
 * @export
 * @interface DistributedPolicyRulesV2Worker
 */
export interface DistributedPolicyRulesV2Worker {
    /**
     * 
     * @type {StringRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'probes'?: ProbesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'podAffinity'?: PodAffinityRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'tolerations'?: TolerationsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'terminateAfterPreemption'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'autoDeletionTimeAfterCompletionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'terminationGracePeriodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'backoffLimit'?: IntegerRules | null;
    /**
     * 
     * @type {RestartPolicyRule}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'restartPolicy'?: RestartPolicyRule | null;
    /**
     * 
     * @type {PortsRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'ports'?: PortsRules | null;
    /**
     * 
     * @type {ExposedUrlsRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'exposedUrls'?: ExposedUrlsRules | null;
    /**
     * 
     * @type {RelatedUrlsRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'relatedUrls'?: RelatedUrlsRules | null;
    /**
     * 
     * @type {SecurityFlatFieldsRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'security'?: SecurityFlatFieldsRules | null;
    /**
     * 
     * @type {ComputeFieldsRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'compute'?: ComputeFieldsRules | null;
    /**
     * 
     * @type {StorageFieldsRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'storage'?: StorageFieldsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'tty'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'stdin'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'numWorkers'?: IntegerRules | null;
    /**
     * 
     * @type {DistributedFrameworkRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'distributedFramework'?: DistributedFrameworkRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'slotsPerWorker'?: IntegerRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'sshAuthMountPath'?: StringRules | null;
    /**
     * 
     * @type {DistributedMpiLauncherCreationPolicyRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'mpiLauncherCreationPolicy'?: DistributedMpiLauncherCreationPolicyRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'minReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'maxReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {DistributedCleanPodPolicyRules}
     * @memberof DistributedPolicyRulesV2Worker
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicyRules | null;
}
/**
 * 
 * @export
 * @interface DistributedPolicyV2
 */
export interface DistributedPolicyV2 {
    /**
     * 
     * @type {PolicyMeta}
     * @memberof DistributedPolicyV2
     */
    'meta'?: PolicyMeta;
    /**
     * 
     * @type {DistributedPolicyDefaultsAndRulesV2}
     * @memberof DistributedPolicyV2
     */
    'policy'?: DistributedPolicyDefaultsAndRulesV2 | null;
    /**
     * 
     * @type {DistributedPolicyDefaultsAndRulesV2}
     * @memberof DistributedPolicyV2
     */
    'effective'?: DistributedPolicyDefaultsAndRulesV2 | null;
    /**
     * The time at which an event occurred. e.g. the time an effective policy has been updated
     * @type {string}
     * @memberof DistributedPolicyV2
     */
    'effectiveUpdatedAt'?: string;
}
/**
 * Details of an environment variable which is populated into the container.
 * @export
 * @interface EnvironmentVariable
 */
export interface EnvironmentVariable {
    /**
     * The name of the environment variable. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariable
     */
    'name'?: string | null;
    /**
     * The value of the environment variable. (mutually exclusive with secret, configMap and podFieldRef)
     * @type {string}
     * @memberof EnvironmentVariable
     */
    'value'?: string | null;
    /**
     * 
     * @type {EnvironmentVariableSecret}
     * @memberof EnvironmentVariable
     */
    'secret'?: EnvironmentVariableSecret | null;
    /**
     * 
     * @type {EnvironmentVariableConfigMap}
     * @memberof EnvironmentVariable
     */
    'configMap'?: EnvironmentVariableConfigMap | null;
    /**
     * 
     * @type {EnvironmentVariablePodFieldReference}
     * @memberof EnvironmentVariable
     */
    'podFieldRef'?: EnvironmentVariablePodFieldReference | null;
    /**
     * Use \'true\' in case the environment variable is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof EnvironmentVariable
     */
    'exclude'?: boolean | null;
    /**
     * Description of the environment variable.
     * @type {string}
     * @memberof EnvironmentVariable
     */
    'description'?: string | null;
}
/**
 * Details of the configMap and key use to populated the environment variable
 * @export
 * @interface EnvironmentVariableConfigMap
 */
export interface EnvironmentVariableConfigMap {
    /**
     * The name of the config-map resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariableConfigMap
     */
    'name'?: string | null;
    /**
     * The key in the config-map resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariableConfigMap
     */
    'key'?: string | null;
}
/**
 * Details of the filed-reference and key use to populated the environment variable
 * @export
 * @interface EnvironmentVariablePodFieldReference
 */
export interface EnvironmentVariablePodFieldReference {
    /**
     * The field path resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariablePodFieldReference
     */
    'path'?: string | null;
}
/**
 * Details of the secret and key use to populated the environment variable
 * @export
 * @interface EnvironmentVariableSecret
 */
export interface EnvironmentVariableSecret {
    /**
     * The name of the secret resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariableSecret
     */
    'name'?: string | null;
    /**
     * The key in the secret resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariableSecret
     */
    'key'?: string | null;
}
/**
 * 
 * @export
 * @interface EnvironmentVariablesDefaults
 */
export interface EnvironmentVariablesDefaults {
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof EnvironmentVariablesDefaults
     */
    'instances'?: Array<EnvironmentVariable> | null;
}
/**
 * 
 * @export
 * @interface EnvironmentVariablesFieldDefaults
 */
export interface EnvironmentVariablesFieldDefaults {
    /**
     * 
     * @type {EnvironmentVariablesDefaults}
     * @memberof EnvironmentVariablesFieldDefaults
     */
    'environmentVariables'?: EnvironmentVariablesDefaults | null;
}
/**
 * 
 * @export
 * @interface EnvironmentVariablesFieldRules
 */
export interface EnvironmentVariablesFieldRules {
    /**
     * 
     * @type {InstancesRules}
     * @memberof EnvironmentVariablesFieldRules
     */
    'environmentVariables'?: InstancesRules | null;
}
/**
 * 
 * @export
 * @interface ExcludeField
 */
export interface ExcludeField {
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof ExcludeField
     */
    'exclude'?: boolean | null;
}
/**
 * A URL for accessing the workload.
 * @export
 * @interface ExposedUrl
 */
export interface ExposedUrl {
    /**
     * The port that the container running the workload exposes. (mandatory)
     * @type {number}
     * @memberof ExposedUrl
     */
    'container'?: number | null;
    /**
     * The URL for connecting to the container port. If not specified, the URL will be auto-generated by the system..
     * @type {string}
     * @memberof ExposedUrl
     */
    'url'?: string | null;
    /**
     * List of users that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ExposedUrl
     */
    'authorizedUsers'?: Array<string> | null;
    /**
     * List of groups that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ExposedUrl
     */
    'authorizedGroups'?: Array<string> | null;
    /**
     * The tool type that runs on this container port.
     * @type {string}
     * @memberof ExposedUrl
     */
    'toolType'?: string | null;
    /**
     * A name describing the tool that runs on this url.
     * @type {string}
     * @memberof ExposedUrl
     */
    'toolName'?: string | null;
    /**
     * Unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof ExposedUrl
     */
    'name'?: string | null;
    /**
     * Use \'true\' in case the instance is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof ExposedUrl
     */
    'exclude'?: boolean | null;
}
/**
 * Rules for the attributed of exposedUrls
 * @export
 * @interface ExposedUrlRules
 */
export interface ExposedUrlRules {
    /**
     * 
     * @type {IntegerRules}
     * @memberof ExposedUrlRules
     */
    'container'?: IntegerRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof ExposedUrlRules
     */
    'customUrl'?: BooleanRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ExposedUrlRules
     */
    'url'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof ExposedUrlRules
     */
    'authorizedUsers'?: ArrayRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ExposedUrlRules
     */
    'toolType'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ExposedUrlRules
     */
    'toolName'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface ExposedUrlsDefaults
 */
export interface ExposedUrlsDefaults {
    /**
     * 
     * @type {ExposedUrl}
     * @memberof ExposedUrlsDefaults
     */
    'attributes'?: ExposedUrl | null;
    /**
     * Set of container ports that the workload exposes via URLs.
     * @type {Array<ExposedUrl>}
     * @memberof ExposedUrlsDefaults
     */
    'instances'?: Array<ExposedUrl> | null;
}
/**
 * 
 * @export
 * @interface ExposedUrlsRules
 */
export interface ExposedUrlsRules {
    /**
     * 
     * @type {ExposedUrlRules}
     * @memberof ExposedUrlsRules
     */
    'attributes'?: ExposedUrlRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof ExposedUrlsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * Quantity of an extended resource.
 * @export
 * @interface ExtendedResource
 */
export interface ExtendedResource {
    /**
     * The name of the extended resource (mandatory)
     * @type {string}
     * @memberof ExtendedResource
     */
    'resource'?: string | null;
    /**
     * The requested quantity for the resource.
     * @type {string}
     * @memberof ExtendedResource
     */
    'quantity'?: string | null;
    /**
     * Use \'true\' in case the extended resource is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof ExtendedResource
     */
    'exclude'?: boolean | null;
}
/**
 * Rules for the attributes of extendedResources
 * @export
 * @interface ExtendedResourceRules
 */
export interface ExtendedResourceRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ExtendedResourceRules
     */
    'quantity'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface ExtendedResourcesDefaults
 */
export interface ExtendedResourcesDefaults {
    /**
     * 
     * @type {ExtendedResource}
     * @memberof ExtendedResourcesDefaults
     */
    'attributes'?: ExtendedResource | null;
    /**
     * Extended resources and their quantity.
     * @type {Array<ExtendedResource>}
     * @memberof ExtendedResourcesDefaults
     */
    'instances'?: Array<ExtendedResource> | null;
}
/**
 * 
 * @export
 * @interface ExtendedResourcesRules
 */
export interface ExtendedResourcesRules {
    /**
     * 
     * @type {ExtendedResourceRules}
     * @memberof ExtendedResourcesRules
     */
    'attributes'?: ExtendedResourceRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof ExtendedResourcesRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface FallbackPolicy
 */
export interface FallbackPolicy {
    /**
     * 
     * @type {PolicyMeta}
     * @memberof FallbackPolicy
     */
    'meta'?: PolicyMeta;
    /**
     * 
     * @type {FallbackPolicyDefaultsAndRules}
     * @memberof FallbackPolicy
     */
    'policy'?: FallbackPolicyDefaultsAndRules | null;
    /**
     * 
     * @type {FallbackPolicyDefaultsAndRules}
     * @memberof FallbackPolicy
     */
    'effective'?: FallbackPolicyDefaultsAndRules | null;
    /**
     * The time at which an event occurred. e.g. the time an effective policy has been updated
     * @type {string}
     * @memberof FallbackPolicy
     */
    'effectiveUpdatedAt'?: string;
}
/**
 * 
 * @export
 * @interface FallbackPolicyChangeRequest
 */
export interface FallbackPolicyChangeRequest {
    /**
     * 
     * @type {PolicyCreationFields}
     * @memberof FallbackPolicyChangeRequest
     */
    'meta'?: PolicyCreationFields;
    /**
     * 
     * @type {FallbackPolicyDefaultsAndRules}
     * @memberof FallbackPolicyChangeRequest
     */
    'policy'?: FallbackPolicyDefaultsAndRules | null;
    /**
     * set of fields in jsonpath format that is requested to clear their policy (default and rules)
     * @type {Array<string>}
     * @memberof FallbackPolicyChangeRequest
     */
    'reset'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FallbackPolicyDefaultsAndRules
 */
export interface FallbackPolicyDefaultsAndRules {
    /**
     * 
     * @type {FallbackPolicyDefaultsAndRulesDefaults}
     * @memberof FallbackPolicyDefaultsAndRules
     */
    'defaults'?: FallbackPolicyDefaultsAndRulesDefaults | null;
    /**
     * 
     * @type {FallbackPolicyDefaultsAndRulesRules}
     * @memberof FallbackPolicyDefaultsAndRules
     */
    'rules'?: FallbackPolicyDefaultsAndRulesRules | null;
    /**
     * a list of datasource assets to import into the policy. these datasources will be included in any workload that will be created in the scope of the policy.
     * @type {Array<string>}
     * @memberof FallbackPolicyDefaultsAndRules
     */
    'imposedAssets'?: Array<string> | null;
    /**
     * 
     * @type {PolicyValidationStatus}
     * @memberof FallbackPolicyDefaultsAndRules
     */
    'status'?: PolicyValidationStatus | null;
    /**
     * 
     * @type {DefaultFromOrder}
     * @memberof FallbackPolicyDefaultsAndRules
     */
    'defaultFromOrder'?: DefaultFromOrder | null;
}
/**
 * 
 * @export
 * @interface FallbackPolicyDefaultsAndRulesDefaults
 */
export interface FallbackPolicyDefaultsAndRulesDefaults {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'stdin'?: boolean | null;
    /**
     * 
     * @type {EnvironmentVariablesDefaults}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'environmentVariables'?: EnvironmentVariablesDefaults | null;
    /**
     * 
     * @type {AnnotationsDefaults}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'annotations'?: AnnotationsDefaults | null;
    /**
     * 
     * @type {LabelsDefaults}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'labels'?: LabelsDefaults | null;
    /**
     * 
     * @type {TolerationsDefaults}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'tolerations'?: TolerationsDefaults | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * 
     * @type {PortsDefaults}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'ports'?: PortsDefaults | null;
    /**
     * 
     * @type {ExposedUrlsDefaults}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'exposedUrls'?: ExposedUrlsDefaults | null;
    /**
     * 
     * @type {RelatedUrlsDefaults}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'relatedUrls'?: RelatedUrlsDefaults | null;
    /**
     * 
     * @type {PriorityClass}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'priorityClass'?: PriorityClass | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'parallelism'?: number | null;
    /**
     * the number of workers that will be allocated for running the workload.
     * @type {number}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'numWorkers'?: number | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'distributedFramework'?: DistributedFramework | null;
    /**
     * Specifies the number of slots per worker used in hostfile. Defaults to 1. (applicable only for MPI)
     * @type {number}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'slotsPerWorker'?: number | null;
    /**
     * Specifies the directory where SSH keys are mounted. (applicable only for MPI)
     * @type {string}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'sshAuthMountPath'?: string | null;
    /**
     * 
     * @type {DistributedMpiLauncherCreationPolicy}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'mpiLauncherCreationPolicy'?: DistributedMpiLauncherCreationPolicy | null;
    /**
     * the lower limit for the number of worker pods to which the training job can scale down. (applicable only for PyTorch)
     * @type {number}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'minReplicas'?: number | null;
    /**
     * the upper limit for the number of worker pods that can be set by the autoscaler. Cannot be smaller than MinReplicas. (applicable only for PyTorch)
     * @type {number}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'maxReplicas'?: number | null;
    /**
     * 
     * @type {DistributedCleanPodPolicy}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicy | null;
    /**
     * 
     * @type {ServingPort}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'servingPort'?: ServingPort | null;
    /**
     * 
     * @type {AutoScaling}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'autoscaling'?: AutoScaling | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'security'?: SecurityFlatFields | null;
    /**
     * 
     * @type {ComputeFieldsDefaults}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'compute'?: ComputeFieldsDefaults | null;
    /**
     * 
     * @type {StorageFieldsDefaults}
     * @memberof FallbackPolicyDefaultsAndRulesDefaults
     */
    'storage'?: StorageFieldsDefaults | null;
}
/**
 * 
 * @export
 * @interface FallbackPolicyDefaultsAndRulesRules
 */
export interface FallbackPolicyDefaultsAndRulesRules {
    /**
     * 
     * @type {StringRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'probes'?: ProbesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'podAffinity'?: PodAffinityRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'tty'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'stdin'?: BooleanRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'tolerations'?: TolerationsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'terminateAfterPreemption'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'autoDeletionTimeAfterCompletionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'terminationGracePeriodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'backoffLimit'?: IntegerRules | null;
    /**
     * 
     * @type {RestartPolicyRule}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'restartPolicy'?: RestartPolicyRule | null;
    /**
     * 
     * @type {PortsRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'ports'?: PortsRules | null;
    /**
     * 
     * @type {ExposedUrlsRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'exposedUrls'?: ExposedUrlsRules | null;
    /**
     * 
     * @type {RelatedUrlsRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'relatedUrls'?: RelatedUrlsRules | null;
    /**
     * 
     * @type {PriorityClassRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'priorityClass'?: PriorityClassRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'completions'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'parallelism'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'numWorkers'?: IntegerRules | null;
    /**
     * 
     * @type {DistributedFrameworkRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'distributedFramework'?: DistributedFrameworkRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'slotsPerWorker'?: IntegerRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'sshAuthMountPath'?: StringRules | null;
    /**
     * 
     * @type {DistributedMpiLauncherCreationPolicyRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'mpiLauncherCreationPolicy'?: DistributedMpiLauncherCreationPolicyRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'minReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'maxReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {DistributedCleanPodPolicyRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicyRules | null;
    /**
     * 
     * @type {ServingPortRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'servingPort'?: ServingPortRules | null;
    /**
     * 
     * @type {AutoScalingRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'autoscaling'?: AutoScalingRules | null;
    /**
     * 
     * @type {SecurityFlatFieldsRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'security'?: SecurityFlatFieldsRules | null;
    /**
     * 
     * @type {ComputeFieldsRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'compute'?: ComputeFieldsRules | null;
    /**
     * 
     * @type {StorageFieldsRules}
     * @memberof FallbackPolicyDefaultsAndRulesRules
     */
    'storage'?: StorageFieldsRules | null;
}
/**
 * 
 * @export
 * @interface FallbackPolicyOverwriteRequest
 */
export interface FallbackPolicyOverwriteRequest {
    /**
     * 
     * @type {PolicyCreationFields}
     * @memberof FallbackPolicyOverwriteRequest
     */
    'meta'?: PolicyCreationFields;
    /**
     * 
     * @type {FallbackPolicyDefaultsAndRules}
     * @memberof FallbackPolicyOverwriteRequest
     */
    'policy'?: FallbackPolicyDefaultsAndRules | null;
}
/**
 * 
 * @export
 * @interface GitCommon
 */
export interface GitCommon {
    /**
     * URL to a remote Git repository. The content of this repository will be mapped to the container running the workload. (mandatory)
     * @type {string}
     * @memberof GitCommon
     */
    'repository'?: string | null;
    /**
     * Specific branch to synchronize the repository from.
     * @type {string}
     * @memberof GitCommon
     */
    'branch'?: string | null;
    /**
     * Specific revision to synchronize the repository from.
     * @type {string}
     * @memberof GitCommon
     */
    'revision'?: string | null;
    /**
     * Local path within the workspace to which the Git repository will be mapped (mandatory).
     * @type {string}
     * @memberof GitCommon
     */
    'path'?: string | null;
}
/**
 * 
 * @export
 * @interface GitInstance
 */
export interface GitInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof GitInstance
     */
    'name'?: string | null;
    /**
     * URL to a remote Git repository. The content of this repository will be mapped to the container running the workload. (mandatory)
     * @type {string}
     * @memberof GitInstance
     */
    'repository'?: string | null;
    /**
     * Specific branch to synchronize the repository from.
     * @type {string}
     * @memberof GitInstance
     */
    'branch'?: string | null;
    /**
     * Specific revision to synchronize the repository from.
     * @type {string}
     * @memberof GitInstance
     */
    'revision'?: string | null;
    /**
     * Local path within the workspace to which the Git repository will be mapped (mandatory).
     * @type {string}
     * @memberof GitInstance
     */
    'path'?: string | null;
    /**
     * Secret containing the credentials of the repository (needed for non public repository which requires authentication).
     * @type {string}
     * @memberof GitInstance
     */
    'passwordSecret'?: string | null;
    /**
     * The key to use for loading the user name from the secret. The default is `User`.
     * @type {string}
     * @memberof GitInstance
     */
    'secretKeyOfUser'?: string | null;
    /**
     * The key to use for loading the password from the secret. The default is `Password`.
     * @type {string}
     * @memberof GitInstance
     */
    'secretKeyOfPassword'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof GitInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface GitPassword
 */
export interface GitPassword {
    /**
     * Secret containing the credentials of the repository (needed for non public repository which requires authentication).
     * @type {string}
     * @memberof GitPassword
     */
    'passwordSecret'?: string | null;
    /**
     * The key to use for loading the user name from the secret. The default is `User`.
     * @type {string}
     * @memberof GitPassword
     */
    'secretKeyOfUser'?: string | null;
    /**
     * The key to use for loading the password from the secret. The default is `Password`.
     * @type {string}
     * @memberof GitPassword
     */
    'secretKeyOfPassword'?: string | null;
}
/**
 * 
 * @export
 * @interface GitRules
 */
export interface GitRules {
    /**
     * 
     * @type {StringRules}
     * @memberof GitRules
     */
    'repository'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof GitRules
     */
    'branch'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof GitRules
     */
    'revision'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof GitRules
     */
    'path'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface GitsDefaults
 */
export interface GitsDefaults {
    /**
     * 
     * @type {GitInstance}
     * @memberof GitsDefaults
     */
    'attributes'?: GitInstance | null;
    /**
     * Set of git repositories to use in the workload.
     * @type {Array<GitInstance>}
     * @memberof GitsDefaults
     */
    'instances'?: Array<GitInstance> | null;
}
/**
 * 
 * @export
 * @interface GitsRules
 */
export interface GitsRules {
    /**
     * 
     * @type {GitRules}
     * @memberof GitsRules
     */
    'attributes'?: GitRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof GitsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface GpuRequestOptions
 */
export interface GpuRequestOptions {
    /**
     * Limit the permitted values for gpuRequest to a given set of values.
     * @type {Array<GpuRequestOptionsOptionsInner>}
     * @memberof GpuRequestOptions
     */
    'options'?: Array<GpuRequestOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface GpuRequestOptionsOptionsInner
 */
export interface GpuRequestOptionsOptionsInner {
    /**
     * 
     * @type {GpuRequestType}
     * @memberof GpuRequestOptionsOptionsInner
     */
    'value': GpuRequestType | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof GpuRequestOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface GpuRequestRules
 */
export interface GpuRequestRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof GpuRequestRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof GpuRequestRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof GpuRequestRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for gpuRequest to a given set of values.
     * @type {Array<GpuRequestOptionsOptionsInner>}
     * @memberof GpuRequestRules
     */
    'options'?: Array<GpuRequestOptionsOptionsInner> | null;
}
/**
 * Sets the unit type for GPU resources requests. Stated in terms of portion, memory or  mig profile [deprecated]. Sets the unit type for other GPU request fields. If `gpuDevicesRequest > 1`, only `portion` is supported. If `gpuDeviceRequest = 1`, the request type can be stated as `portion`, `memory` or `migProfile` [deprecated].
 * @export
 * @enum {string}
 */

export const GpuRequestType = {
    Portion: 'portion',
    Memory: 'memory',
    MigProfile: 'migProfile'
} as const;

export type GpuRequestType = typeof GpuRequestType[keyof typeof GpuRequestType];


/**
 * 
 * @export
 * @interface HostPath
 */
export interface HostPath {
    /**
     * Local path within the controller to which the host volume will be mapped. (mandatory)
     * @type {string}
     * @memberof HostPath
     */
    'path'?: string | null;
    /**
     * Force the volume to be mounted with read-only permissions. Defaults to false.
     * @type {boolean}
     * @memberof HostPath
     */
    'readOnly'?: boolean | null;
    /**
     * The path that the host volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof HostPath
     */
    'mountPath'?: string | null;
    /**
     * 
     * @type {HostPathMountPropagation}
     * @memberof HostPath
     */
    'mountPropagation'?: HostPathMountPropagation | null;
}
/**
 * 
 * @export
 * @interface HostPathInstance
 */
export interface HostPathInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof HostPathInstance
     */
    'name'?: string | null;
    /**
     * Local path within the controller to which the host volume will be mapped. (mandatory)
     * @type {string}
     * @memberof HostPathInstance
     */
    'path'?: string | null;
    /**
     * Force the volume to be mounted with read-only permissions. Defaults to false.
     * @type {boolean}
     * @memberof HostPathInstance
     */
    'readOnly'?: boolean | null;
    /**
     * The path that the host volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof HostPathInstance
     */
    'mountPath'?: string | null;
    /**
     * 
     * @type {HostPathMountPropagation}
     * @memberof HostPathInstance
     */
    'mountPropagation'?: HostPathMountPropagation | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof HostPathInstance
     */
    'exclude'?: boolean | null;
}
/**
 * Share this volumes mount with other containers. If set to HostToContainer, this volume mount will receive all subsequent mounts that are mounted to this volume or any of its subdirectories. In case of multiple hostPath entries, this field should have the same value for all of them.
 * @export
 * @enum {string}
 */

export const HostPathMountPropagation = {
    None: 'None',
    HostToContainer: 'HostToContainer'
} as const;

export type HostPathMountPropagation = typeof HostPathMountPropagation[keyof typeof HostPathMountPropagation];


/**
 * 
 * @export
 * @interface HostPathMountPropagationOptions
 */
export interface HostPathMountPropagationOptions {
    /**
     * 
     * @type {Array<HostPathMountPropagationOptionsOptionsInner>}
     * @memberof HostPathMountPropagationOptions
     */
    'options'?: Array<HostPathMountPropagationOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface HostPathMountPropagationOptionsOptionsInner
 */
export interface HostPathMountPropagationOptionsOptionsInner {
    /**
     * 
     * @type {HostPathMountPropagation}
     * @memberof HostPathMountPropagationOptionsOptionsInner
     */
    'value': HostPathMountPropagation | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof HostPathMountPropagationOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface HostPathMountPropagationRules
 */
export interface HostPathMountPropagationRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof HostPathMountPropagationRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof HostPathMountPropagationRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof HostPathMountPropagationRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<HostPathMountPropagationOptionsOptionsInner>}
     * @memberof HostPathMountPropagationRules
     */
    'options'?: Array<HostPathMountPropagationOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface HostPathRules
 */
export interface HostPathRules {
    /**
     * 
     * @type {StringRules}
     * @memberof HostPathRules
     */
    'path'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof HostPathRules
     */
    'readOnly'?: BooleanRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof HostPathRules
     */
    'mountPath'?: StringRules | null;
    /**
     * 
     * @type {HostPathMountPropagationRules}
     * @memberof HostPathRules
     */
    'mountPropagation'?: HostPathMountPropagationRules | null;
}
/**
 * 
 * @export
 * @interface HostPathsDefaults
 */
export interface HostPathsDefaults {
    /**
     * 
     * @type {HostPathInstance}
     * @memberof HostPathsDefaults
     */
    'attributes'?: HostPathInstance | null;
    /**
     * Set of host paths to use in the workload.
     * @type {Array<HostPathInstance>}
     * @memberof HostPathsDefaults
     */
    'instances'?: Array<HostPathInstance> | null;
}
/**
 * 
 * @export
 * @interface HostPathsRules
 */
export interface HostPathsRules {
    /**
     * 
     * @type {HostPathRules}
     * @memberof HostPathsRules
     */
    'attributes'?: HostPathRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof HostPathsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * Image pull policy. Defaults to `Always` if `:latest` tag is specified, otherwise it is `IfNotPresent`.
 * @export
 * @enum {string}
 */

export const ImagePullPolicy = {
    Always: 'Always',
    Never: 'Never',
    IfNotPresent: 'IfNotPresent'
} as const;

export type ImagePullPolicy = typeof ImagePullPolicy[keyof typeof ImagePullPolicy];


/**
 * 
 * @export
 * @interface ImagePullPolicyOptions
 */
export interface ImagePullPolicyOptions {
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<ImagePullPolicyOptionsOptionsInner>}
     * @memberof ImagePullPolicyOptions
     */
    'options'?: Array<ImagePullPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface ImagePullPolicyOptionsOptionsInner
 */
export interface ImagePullPolicyOptionsOptionsInner {
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof ImagePullPolicyOptionsOptionsInner
     */
    'value': ImagePullPolicy | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof ImagePullPolicyOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface ImagePullPolicyRules
 */
export interface ImagePullPolicyRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof ImagePullPolicyRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof ImagePullPolicyRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof ImagePullPolicyRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<ImagePullPolicyOptionsOptionsInner>}
     * @memberof ImagePullPolicyRules
     */
    'options'?: Array<ImagePullPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface InferenceFields
 */
export interface InferenceFields {
    /**
     * 
     * @type {ServingPort}
     * @memberof InferenceFields
     */
    'servingPort'?: ServingPort | null;
    /**
     * 
     * @type {AutoScaling}
     * @memberof InferenceFields
     */
    'autoscaling'?: AutoScaling | null;
}
/**
 * 
 * @export
 * @interface InferenceFieldsRules
 */
export interface InferenceFieldsRules {
    /**
     * 
     * @type {ServingPortRules}
     * @memberof InferenceFieldsRules
     */
    'servingPort'?: ServingPortRules | null;
    /**
     * 
     * @type {AutoScalingRules}
     * @memberof InferenceFieldsRules
     */
    'autoscaling'?: AutoScalingRules | null;
}
/**
 * 
 * @export
 * @interface InferenceFlatFields
 */
export interface InferenceFlatFields {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof InferenceFlatFields
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof InferenceFlatFields
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof InferenceFlatFields
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof InferenceFlatFields
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof InferenceFlatFields
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof InferenceFlatFields
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof InferenceFlatFields
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof InferenceFlatFields
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof InferenceFlatFields
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof InferenceFlatFields
     */
    'podAffinity'?: PodAffinity | null;
}
/**
 * 
 * @export
 * @interface InferenceFlatFieldsRules
 */
export interface InferenceFlatFieldsRules {
    /**
     * 
     * @type {StringRules}
     * @memberof InferenceFlatFieldsRules
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof InferenceFlatFieldsRules
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof InferenceFlatFieldsRules
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof InferenceFlatFieldsRules
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof InferenceFlatFieldsRules
     */
    'probes'?: ProbesRules | null;
}
/**
 * 
 * @export
 * @interface InferencePolicyChangeRequestV2
 */
export interface InferencePolicyChangeRequestV2 {
    /**
     * 
     * @type {PolicyCreationFields}
     * @memberof InferencePolicyChangeRequestV2
     */
    'meta'?: PolicyCreationFields;
    /**
     * 
     * @type {InferencePolicyDefaultsAndRulesV2}
     * @memberof InferencePolicyChangeRequestV2
     */
    'policy'?: InferencePolicyDefaultsAndRulesV2 | null;
    /**
     * set of fields in jsonpath format that is requested to clear their policy (default and rules)
     * @type {Array<string>}
     * @memberof InferencePolicyChangeRequestV2
     */
    'reset'?: Array<string>;
}
/**
 * 
 * @export
 * @interface InferencePolicyDefaultsAndRulesV2
 */
export interface InferencePolicyDefaultsAndRulesV2 {
    /**
     * 
     * @type {InferencePolicyDefaultsAndRulesV2Defaults}
     * @memberof InferencePolicyDefaultsAndRulesV2
     */
    'defaults'?: InferencePolicyDefaultsAndRulesV2Defaults | null;
    /**
     * 
     * @type {InferencePolicyDefaultsAndRulesV2Rules}
     * @memberof InferencePolicyDefaultsAndRulesV2
     */
    'rules'?: InferencePolicyDefaultsAndRulesV2Rules | null;
    /**
     * a list of datasource assets to import into the policy. these datasources will be included in any workload that will be created in the scope of the policy.
     * @type {Array<string>}
     * @memberof InferencePolicyDefaultsAndRulesV2
     */
    'imposedAssets'?: Array<string> | null;
    /**
     * 
     * @type {PolicyValidationStatus}
     * @memberof InferencePolicyDefaultsAndRulesV2
     */
    'status'?: PolicyValidationStatus | null;
    /**
     * 
     * @type {DefaultFromOrder}
     * @memberof InferencePolicyDefaultsAndRulesV2
     */
    'defaultFromOrder'?: DefaultFromOrder | null;
}
/**
 * 
 * @export
 * @interface InferencePolicyDefaultsAndRulesV2Defaults
 */
export interface InferencePolicyDefaultsAndRulesV2Defaults {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * 
     * @type {EnvironmentVariablesDefaults}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'environmentVariables'?: EnvironmentVariablesDefaults | null;
    /**
     * 
     * @type {AnnotationsDefaults}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'annotations'?: AnnotationsDefaults | null;
    /**
     * 
     * @type {LabelsDefaults}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'labels'?: LabelsDefaults | null;
    /**
     * 
     * @type {TolerationsDefaults}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'tolerations'?: TolerationsDefaults | null;
    /**
     * 
     * @type {PortsDefaults}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'ports'?: PortsDefaults | null;
    /**
     * 
     * @type {ExposedUrlsDefaults}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'exposedUrls'?: ExposedUrlsDefaults | null;
    /**
     * 
     * @type {RelatedUrlsDefaults}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'relatedUrls'?: RelatedUrlsDefaults | null;
    /**
     * 
     * @type {ComputeFieldsDefaults}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'compute'?: ComputeFieldsDefaults | null;
    /**
     * 
     * @type {CommonStorageFieldsDefaults}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'storage'?: CommonStorageFieldsDefaults | null;
    /**
     * 
     * @type {CommonSecurityFlatFields}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'security'?: CommonSecurityFlatFields | null;
    /**
     * 
     * @type {ServingPort}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'servingPort'?: ServingPort | null;
    /**
     * 
     * @type {AutoScaling}
     * @memberof InferencePolicyDefaultsAndRulesV2Defaults
     */
    'autoscaling'?: AutoScaling | null;
}
/**
 * 
 * @export
 * @interface InferencePolicyDefaultsAndRulesV2Rules
 */
export interface InferencePolicyDefaultsAndRulesV2Rules {
    /**
     * 
     * @type {StringRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'probes'?: ProbesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'podAffinity'?: PodAffinityRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'tolerations'?: TolerationsRules | null;
    /**
     * 
     * @type {PortsRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'ports'?: PortsRules | null;
    /**
     * 
     * @type {ExposedUrlsRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'exposedUrls'?: ExposedUrlsRules | null;
    /**
     * 
     * @type {RelatedUrlsRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'relatedUrls'?: RelatedUrlsRules | null;
    /**
     * 
     * @type {ComputeFieldsRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'compute'?: ComputeFieldsRules | null;
    /**
     * 
     * @type {CommonSecurityFlatFieldsRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'security'?: CommonSecurityFlatFieldsRules | null;
    /**
     * 
     * @type {CommonStorageFieldsRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'storage'?: CommonStorageFieldsRules | null;
    /**
     * 
     * @type {ServingPortRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'servingPort'?: ServingPortRules | null;
    /**
     * 
     * @type {AutoScalingRules}
     * @memberof InferencePolicyDefaultsAndRulesV2Rules
     */
    'autoscaling'?: AutoScalingRules | null;
}
/**
 * 
 * @export
 * @interface InferencePolicyOverwriteRequestV2
 */
export interface InferencePolicyOverwriteRequestV2 {
    /**
     * 
     * @type {PolicyCreationFields}
     * @memberof InferencePolicyOverwriteRequestV2
     */
    'meta'?: PolicyCreationFields;
    /**
     * 
     * @type {InferencePolicyDefaultsAndRulesV2}
     * @memberof InferencePolicyOverwriteRequestV2
     */
    'policy'?: InferencePolicyDefaultsAndRulesV2 | null;
}
/**
 * 
 * @export
 * @interface InferencePolicyRulesV2
 */
export interface InferencePolicyRulesV2 {
    /**
     * 
     * @type {StringRules}
     * @memberof InferencePolicyRulesV2
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof InferencePolicyRulesV2
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof InferencePolicyRulesV2
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof InferencePolicyRulesV2
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof InferencePolicyRulesV2
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof InferencePolicyRulesV2
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof InferencePolicyRulesV2
     */
    'probes'?: ProbesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof InferencePolicyRulesV2
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof InferencePolicyRulesV2
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof InferencePolicyRulesV2
     */
    'podAffinity'?: PodAffinityRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof InferencePolicyRulesV2
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof InferencePolicyRulesV2
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof InferencePolicyRulesV2
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof InferencePolicyRulesV2
     */
    'tolerations'?: TolerationsRules | null;
    /**
     * 
     * @type {PortsRules}
     * @memberof InferencePolicyRulesV2
     */
    'ports'?: PortsRules | null;
    /**
     * 
     * @type {ExposedUrlsRules}
     * @memberof InferencePolicyRulesV2
     */
    'exposedUrls'?: ExposedUrlsRules | null;
    /**
     * 
     * @type {RelatedUrlsRules}
     * @memberof InferencePolicyRulesV2
     */
    'relatedUrls'?: RelatedUrlsRules | null;
    /**
     * 
     * @type {ComputeFieldsRules}
     * @memberof InferencePolicyRulesV2
     */
    'compute'?: ComputeFieldsRules | null;
    /**
     * 
     * @type {CommonSecurityFlatFieldsRules}
     * @memberof InferencePolicyRulesV2
     */
    'security'?: CommonSecurityFlatFieldsRules | null;
    /**
     * 
     * @type {CommonStorageFieldsRules}
     * @memberof InferencePolicyRulesV2
     */
    'storage'?: CommonStorageFieldsRules | null;
    /**
     * 
     * @type {ServingPortRules}
     * @memberof InferencePolicyRulesV2
     */
    'servingPort'?: ServingPortRules | null;
    /**
     * 
     * @type {AutoScalingRules}
     * @memberof InferencePolicyRulesV2
     */
    'autoscaling'?: AutoScalingRules | null;
}
/**
 * 
 * @export
 * @interface InferencePolicyV2
 */
export interface InferencePolicyV2 {
    /**
     * 
     * @type {PolicyMeta}
     * @memberof InferencePolicyV2
     */
    'meta'?: PolicyMeta;
    /**
     * 
     * @type {InferencePolicyDefaultsAndRulesV2}
     * @memberof InferencePolicyV2
     */
    'policy'?: InferencePolicyDefaultsAndRulesV2 | null;
    /**
     * 
     * @type {InferencePolicyDefaultsAndRulesV2}
     * @memberof InferencePolicyV2
     */
    'effective'?: InferencePolicyDefaultsAndRulesV2 | null;
    /**
     * The time at which an event occurred. e.g. the time an effective policy has been updated
     * @type {string}
     * @memberof InferencePolicyV2
     */
    'effectiveUpdatedAt'?: string;
}
/**
 * 
 * @export
 * @interface InferenceSecurityRules
 */
export interface InferenceSecurityRules {
    /**
     * 
     * @type {CommonSecurityFlatFieldsRules}
     * @memberof InferenceSecurityRules
     */
    'security'?: CommonSecurityFlatFieldsRules | null;
}
/**
 * 
 * @export
 * @interface InstancesRules
 */
export interface InstancesRules {
    /**
     * 
     * @type {ItemRules}
     * @memberof InstancesRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface IntegerRules
 */
export interface IntegerRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof IntegerRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory. default to false.
     * @type {boolean}
     * @memberof IntegerRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable. default to true
     * @type {boolean}
     * @memberof IntegerRules
     */
    'canEdit'?: boolean | null;
    /**
     * The minimum value that the field can be assigned to.
     * @type {number}
     * @memberof IntegerRules
     */
    'min'?: number | null;
    /**
     * The maximum value that the field can be assigned to.
     * @type {number}
     * @memberof IntegerRules
     */
    'max'?: number | null;
    /**
     * The minimal difference between two values the field can be assigned to. For example, min=2, max=10, step=2 implies that the values the field can hold are 2, 4, 6, 8 and 10.
     * @type {number}
     * @memberof IntegerRules
     */
    'step'?: number | null;
    /**
     * 
     * @type {DefaultFromRule}
     * @memberof IntegerRules
     */
    'defaultFrom'?: DefaultFromRule | null;
}
/**
 * 
 * @export
 * @interface IntegerRulesOptional
 */
export interface IntegerRulesOptional {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof IntegerRulesOptional
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the value of the field is editable. default to true
     * @type {boolean}
     * @memberof IntegerRulesOptional
     */
    'canEdit'?: boolean | null;
    /**
     * The minimum value that the field can be assigned to.
     * @type {number}
     * @memberof IntegerRulesOptional
     */
    'min'?: number | null;
    /**
     * The maximum value that the field can be assigned to.
     * @type {number}
     * @memberof IntegerRulesOptional
     */
    'max'?: number | null;
    /**
     * The minimal difference between two values the field can be assigned to. For example, min=2, max=10, step=2 implies that the values the field can hold are 2, 4, 6, 8 and 10.
     * @type {number}
     * @memberof IntegerRulesOptional
     */
    'step'?: number | null;
    /**
     * 
     * @type {DefaultFromRule}
     * @memberof IntegerRulesOptional
     */
    'defaultFrom'?: DefaultFromRule | null;
}
/**
 * 
 * @export
 * @interface ItemRules
 */
export interface ItemRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof ItemRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether it is permitted to add items. Default to true.
     * @type {boolean}
     * @memberof ItemRules
     */
    'canAdd'?: boolean | null;
    /**
     * Set of keys for items that are \"locked\", i.e. cannot be removed or deleted.
     * @type {Array<string>}
     * @memberof ItemRules
     */
    'locked'?: Array<string>;
}
/**
 * Label details to be populated into the container.
 * @export
 * @interface Label
 */
export interface Label {
    /**
     * The name of the label (mandatory)
     * @type {string}
     * @memberof Label
     */
    'name'?: string | null;
    /**
     * The value of the label.
     * @type {string}
     * @memberof Label
     */
    'value'?: string | null;
    /**
     * Use \'true\' in case the label is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof Label
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface LabelsDefaults
 */
export interface LabelsDefaults {
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof LabelsDefaults
     */
    'instances'?: Array<Label> | null;
}
/**
 * 
 * @export
 * @interface LabelsFieldDefaults
 */
export interface LabelsFieldDefaults {
    /**
     * 
     * @type {LabelsDefaults}
     * @memberof LabelsFieldDefaults
     */
    'labels'?: LabelsDefaults | null;
}
/**
 * 
 * @export
 * @interface LabelsFieldRules
 */
export interface LabelsFieldRules {
    /**
     * 
     * @type {InstancesRules}
     * @memberof LabelsFieldRules
     */
    'labels'?: InstancesRules | null;
}
/**
 * Required only if `gpuRequestType` is `migProfile`. This states the memory profile to be used for the workload running NVIDIA Multi-Instance GPU (MIG) technology.
 * @export
 * @enum {string}
 */

export const MigProfile = {
    _1g5gb: '1g.5gb',
    _1g10gb: '1g.10gb',
    _2g10gb: '2g.10gb',
    _2g20gb: '2g.20gb',
    _3g20gb: '3g.20gb',
    _3g40gb: '3g.40gb',
    _4g20gb: '4g.20gb',
    _4g40gb: '4g.40gb',
    _7g40gb: '7g.40gb',
    _7g80gb: '7g.80gb'
} as const;

export type MigProfile = typeof MigProfile[keyof typeof MigProfile];


/**
 * 
 * @export
 * @interface MigProfileOptions
 */
export interface MigProfileOptions {
    /**
     * Limit the permitted values for migProfile to a given set of values.
     * @type {Array<MigProfileOptionsOptionsInner>}
     * @memberof MigProfileOptions
     */
    'options'?: Array<MigProfileOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface MigProfileOptionsOptionsInner
 */
export interface MigProfileOptionsOptionsInner {
    /**
     * 
     * @type {MigProfile}
     * @memberof MigProfileOptionsOptionsInner
     * @deprecated
     */
    'value': MigProfile | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof MigProfileOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface MigProfileRules
 */
export interface MigProfileRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof MigProfileRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof MigProfileRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof MigProfileRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for migProfile to a given set of values.
     * @type {Array<MigProfileOptionsOptionsInner>}
     * @memberof MigProfileRules
     */
    'options'?: Array<MigProfileOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {number}
     * @memberof ModelError
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'details'?: string;
}
/**
 * 
 * @export
 * @interface Nfs
 */
export interface Nfs {
    /**
     * Path that is exported by the NFS server (mandatory). For more information, see [NFS](https://kubernetes.io/docs/concepts/storage/volumes#nfs).
     * @type {string}
     * @memberof Nfs
     */
    'path'?: string | null;
    /**
     * Force the NFS export to be mounted with read-only permissions.
     * @type {boolean}
     * @memberof Nfs
     */
    'readOnly'?: boolean | null;
    /**
     * The hostname or IP address of the NFS server. (mandatory)
     * @type {string}
     * @memberof Nfs
     */
    'server'?: string | null;
    /**
     * The path that the NFS volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof Nfs
     */
    'mountPath'?: string | null;
}
/**
 * 
 * @export
 * @interface NfsInstance
 */
export interface NfsInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof NfsInstance
     */
    'name'?: string | null;
    /**
     * Path that is exported by the NFS server (mandatory). For more information, see [NFS](https://kubernetes.io/docs/concepts/storage/volumes#nfs).
     * @type {string}
     * @memberof NfsInstance
     */
    'path'?: string | null;
    /**
     * Force the NFS export to be mounted with read-only permissions.
     * @type {boolean}
     * @memberof NfsInstance
     */
    'readOnly'?: boolean | null;
    /**
     * The hostname or IP address of the NFS server. (mandatory)
     * @type {string}
     * @memberof NfsInstance
     */
    'server'?: string | null;
    /**
     * The path that the NFS volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof NfsInstance
     */
    'mountPath'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof NfsInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NfsRules
 */
export interface NfsRules {
    /**
     * 
     * @type {StringRules}
     * @memberof NfsRules
     */
    'path'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof NfsRules
     */
    'readOnly'?: BooleanRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof NfsRules
     */
    'server'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof NfsRules
     */
    'mountPath'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface NfssDefaults
 */
export interface NfssDefaults {
    /**
     * 
     * @type {NfsInstance}
     * @memberof NfssDefaults
     */
    'attributes'?: NfsInstance | null;
    /**
     * Set of nfs volumes to use in the workload.
     * @type {Array<NfsInstance>}
     * @memberof NfssDefaults
     */
    'instances'?: Array<NfsInstance> | null;
}
/**
 * 
 * @export
 * @interface NfssRules
 */
export interface NfssRules {
    /**
     * 
     * @type {NfsRules}
     * @memberof NfssRules
     */
    'attributes'?: NfsRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof NfssRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface NonInferenceFlatFields
 */
export interface NonInferenceFlatFields {
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof NonInferenceFlatFields
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof NonInferenceFlatFields
     */
    'stdin'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NonInferenceFlatFieldsRules
 */
export interface NonInferenceFlatFieldsRules {
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceFlatFieldsRules
     */
    'tty'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceFlatFieldsRules
     */
    'stdin'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface NonInferenceSecurityFlatFields
 */
export interface NonInferenceSecurityFlatFields {
    /**
     * Allow the container running the workload and all launched processes to gain additional privileges after the workload starts. For more information consult the User Identity in Container guide at https://docs.run.ai/admin/runai-setup/config/non-root-containers/
     * @type {boolean}
     * @memberof NonInferenceSecurityFlatFields
     */
    'allowPrivilegeEscalation'?: boolean | null;
    /**
     * Whether to enable host IPC. Defaults to false.
     * @type {boolean}
     * @memberof NonInferenceSecurityFlatFields
     */
    'hostIpc'?: boolean | null;
    /**
     * Whether to enable host networking. Default to false.
     * @type {boolean}
     * @memberof NonInferenceSecurityFlatFields
     */
    'hostNetwork'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NonInferenceSecurityFlatFieldsRules
 */
export interface NonInferenceSecurityFlatFieldsRules {
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceSecurityFlatFieldsRules
     */
    'allowPrivilegeEscalation'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceSecurityFlatFieldsRules
     */
    'hostIpc'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceSecurityFlatFieldsRules
     */
    'hostNetwork'?: BooleanRules | null;
}
/**
 * Security related fields. When used in assets context, those are environment asset fields that cannot be override in the submit workload request.
 * @export
 * @interface NonInferenceSecurityNonOverridable
 */
export interface NonInferenceSecurityNonOverridable {
    /**
     * Allow the container running the workload and all launched processes to gain additional privileges after the workload starts. For more information consult the User Identity in Container guide at https://docs.run.ai/admin/runai-setup/config/non-root-containers/
     * @type {boolean}
     * @memberof NonInferenceSecurityNonOverridable
     */
    'allowPrivilegeEscalation'?: boolean | null;
    /**
     * Whether to enable host IPC. Defaults to false.
     * @type {boolean}
     * @memberof NonInferenceSecurityNonOverridable
     */
    'hostIpc'?: boolean | null;
    /**
     * Whether to enable host networking. Default to false.
     * @type {boolean}
     * @memberof NonInferenceSecurityNonOverridable
     */
    'hostNetwork'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NonInferenceSecurityNonOverridableRules
 */
export interface NonInferenceSecurityNonOverridableRules {
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceSecurityNonOverridableRules
     */
    'allowPrivilegeEscalation'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceSecurityNonOverridableRules
     */
    'hostIpc'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceSecurityNonOverridableRules
     */
    'hostNetwork'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface NonInferenceStorageFieldsDefaults
 */
export interface NonInferenceStorageFieldsDefaults {
    /**
     * 
     * @type {S3sDefaults}
     * @memberof NonInferenceStorageFieldsDefaults
     */
    's3'?: S3sDefaults | null;
}
/**
 * 
 * @export
 * @interface NonInferenceStorageFieldsRules
 */
export interface NonInferenceStorageFieldsRules {
    /**
     * 
     * @type {S3sRules}
     * @memberof NonInferenceStorageFieldsRules
     */
    's3'?: S3sRules | null;
}
/**
 * 
 * @export
 * @interface NumberRules
 */
export interface NumberRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof NumberRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory. default to false.
     * @type {boolean}
     * @memberof NumberRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable. default to true
     * @type {boolean}
     * @memberof NumberRules
     */
    'canEdit'?: boolean | null;
    /**
     * The minimum value that the field can be assigned to.
     * @type {number}
     * @memberof NumberRules
     */
    'min'?: number | null;
    /**
     * The maximum value that the field can be assigned to.
     * @type {number}
     * @memberof NumberRules
     */
    'max'?: number | null;
    /**
     * The minimal difference between two values the field can be assigned to. For example, min=2, max=3, step=0.25 implies that the values the field can hold are 2, 2.25, 2.5 and 3.
     * @type {number}
     * @memberof NumberRules
     */
    'step'?: number | null;
    /**
     * 
     * @type {DefaultFromRule}
     * @memberof NumberRules
     */
    'defaultFrom'?: DefaultFromRule | null;
}
/**
 * 
 * @export
 * @interface ParallelismField
 */
export interface ParallelismField {
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof ParallelismField
     */
    'parallelism'?: number | null;
}
/**
 * Pod affinity scheduling rules (e.g. co-locate this workload in the same node, zone, etc. as some other workloads).
 * @export
 * @interface PodAffinity
 */
export interface PodAffinity {
    /**
     * 
     * @type {PodAffinityType}
     * @memberof PodAffinity
     */
    'type'?: PodAffinityType | null;
    /**
     * The label key to use. (mandatory)
     * @type {string}
     * @memberof PodAffinity
     */
    'key'?: string | null;
}
/**
 * 
 * @export
 * @interface PodAffinityRules
 */
export interface PodAffinityRules {
    /**
     * 
     * @type {PodAffinityTypeRules}
     * @memberof PodAffinityRules
     */
    'type'?: PodAffinityTypeRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof PodAffinityRules
     */
    'key'?: StringRules | null;
}
/**
 * The affinity type, required or preferred. (mandatory)
 * @export
 * @enum {string}
 */

export const PodAffinityType = {
    Required: 'Required',
    Preferred: 'Preferred'
} as const;

export type PodAffinityType = typeof PodAffinityType[keyof typeof PodAffinityType];


/**
 * 
 * @export
 * @interface PodAffinityTypeOptions
 */
export interface PodAffinityTypeOptions {
    /**
     * 
     * @type {Array<PodAffinityTypeOptionsOptionsInner>}
     * @memberof PodAffinityTypeOptions
     */
    'options'?: Array<PodAffinityTypeOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface PodAffinityTypeOptionsOptionsInner
 */
export interface PodAffinityTypeOptionsOptionsInner {
    /**
     * 
     * @type {PodAffinityType}
     * @memberof PodAffinityTypeOptionsOptionsInner
     */
    'value': PodAffinityType | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof PodAffinityTypeOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface PodAffinityTypeRules
 */
export interface PodAffinityTypeRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof PodAffinityTypeRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof PodAffinityTypeRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof PodAffinityTypeRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<PodAffinityTypeOptionsOptionsInner>}
     * @memberof PodAffinityTypeRules
     */
    'options'?: Array<PodAffinityTypeOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface PolicyCreationFields
 */
export interface PolicyCreationFields {
    /**
     * 
     * @type {ScopeType}
     * @memberof PolicyCreationFields
     */
    'scope': ScopeType;
    /**
     * The id of the project.
     * @type {number}
     * @memberof PolicyCreationFields
     */
    'projectId'?: number | null;
    /**
     * The id of the department.
     * @type {string}
     * @memberof PolicyCreationFields
     */
    'departmentId'?: string | null;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof PolicyCreationFields
     */
    'clusterId'?: string | null;
    /**
     * A chosen name for the policy.
     * @type {string}
     * @memberof PolicyCreationFields
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PolicyListEntry
 */
export interface PolicyListEntry {
    /**
     * 
     * @type {PolicyType}
     * @memberof PolicyListEntry
     */
    'type'?: PolicyType;
    /**
     * 
     * @type {PolicyMeta}
     * @memberof PolicyListEntry
     */
    'meta'?: PolicyMeta;
    /**
     * 
     * @type {PolicyListEntryStatus}
     * @memberof PolicyListEntry
     */
    'status'?: PolicyListEntryStatus;
}
/**
 * 
 * @export
 * @interface PolicyListEntryStatus
 */
export interface PolicyListEntryStatus {
    /**
     * 
     * @type {Array<PolicySyncStatusOfCluster>}
     * @memberof PolicyListEntryStatus
     */
    'clusters'?: Array<PolicySyncStatusOfCluster>;
    /**
     * 
     * @type {PolicyValidationStatusValidation}
     * @memberof PolicyListEntryStatus
     */
    'validation'?: PolicyValidationStatusValidation | null;
}
/**
 * 
 * @export
 * @interface PolicyListResponse
 */
export interface PolicyListResponse {
    /**
     * 
     * @type {Array<PolicyListEntry>}
     * @memberof PolicyListResponse
     */
    'policies'?: Array<PolicyListEntry>;
}
/**
 * 
 * @export
 * @interface PolicyMeta
 */
export interface PolicyMeta {
    /**
     * The unique id of the policy.
     * @type {string}
     * @memberof PolicyMeta
     */
    'id': string;
    /**
     * The id of the tenant.
     * @type {number}
     * @memberof PolicyMeta
     */
    'tenantId'?: number;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof PolicyMeta
     */
    'clusterId'?: string | null;
    /**
     * The user who created the policy.
     * @type {string}
     * @memberof PolicyMeta
     */
    'createdBy': string;
    /**
     * The time at which the policy wes created
     * @type {string}
     * @memberof PolicyMeta
     */
    'createdAt': string;
    /**
     * The user who updated the policy.
     * @type {string}
     * @memberof PolicyMeta
     */
    'updatedBy': string;
    /**
     * The time at which the policy has been updated
     * @type {string}
     * @memberof PolicyMeta
     */
    'updatedAt': string;
    /**
     * 
     * @type {ScopeType}
     * @memberof PolicyMeta
     */
    'scope': ScopeType;
    /**
     * The id of the project.
     * @type {number}
     * @memberof PolicyMeta
     */
    'projectId'?: number | null;
    /**
     * The id of the department.
     * @type {string}
     * @memberof PolicyMeta
     */
    'departmentId'?: string | null;
    /**
     * A chosen name for the policy.
     * @type {string}
     * @memberof PolicyMeta
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PolicyReadOnlyFields
 */
export interface PolicyReadOnlyFields {
    /**
     * The unique id of the policy.
     * @type {string}
     * @memberof PolicyReadOnlyFields
     */
    'id': string;
    /**
     * The id of the tenant.
     * @type {number}
     * @memberof PolicyReadOnlyFields
     */
    'tenantId'?: number;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof PolicyReadOnlyFields
     */
    'clusterId'?: string | null;
    /**
     * The user who created the policy.
     * @type {string}
     * @memberof PolicyReadOnlyFields
     */
    'createdBy': string;
    /**
     * The time at which the policy wes created
     * @type {string}
     * @memberof PolicyReadOnlyFields
     */
    'createdAt': string;
    /**
     * The user who updated the policy.
     * @type {string}
     * @memberof PolicyReadOnlyFields
     */
    'updatedBy': string;
    /**
     * The time at which the policy has been updated
     * @type {string}
     * @memberof PolicyReadOnlyFields
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface PolicySyncResponse
 */
export interface PolicySyncResponse {
    /**
     * 
     * @type {PolicySyncResponseRequestInfo}
     * @memberof PolicySyncResponse
     */
    'requestInfo'?: PolicySyncResponseRequestInfo;
    /**
     * 
     * @type {PolicySyncResponseResponseInfo}
     * @memberof PolicySyncResponse
     */
    'responseInfo'?: PolicySyncResponseResponseInfo;
    /**
     * 
     * @type {PolicySyncResponseSystemInfo}
     * @memberof PolicySyncResponse
     */
    'systemInfo'?: PolicySyncResponseSystemInfo;
    /**
     * 
     * @type {Array<PolicySyncResponsePoliciesInner>}
     * @memberof PolicySyncResponse
     */
    'policies'?: Array<PolicySyncResponsePoliciesInner>;
}
/**
 * 
 * @export
 * @interface PolicySyncResponsePoliciesInner
 */
export interface PolicySyncResponsePoliciesInner {
    /**
     * 
     * @type {PolicyCreationFields}
     * @memberof PolicySyncResponsePoliciesInner
     */
    'meta': PolicyCreationFields;
    /**
     * 
     * @type {SupersetPolicy}
     * @memberof PolicySyncResponsePoliciesInner
     */
    'effective'?: SupersetPolicy | null;
    /**
     * 
     * @type {DistributedPolicyDefaultsAndRulesV2}
     * @memberof PolicySyncResponsePoliciesInner
     */
    'distributed'?: DistributedPolicyDefaultsAndRulesV2 | null;
    /**
     * 
     * @type {boolean}
     * @memberof PolicySyncResponsePoliciesInner
     */
    'isDeleted'?: boolean | null;
    /**
     * number which uniquely identifies each update.
     * @type {number}
     * @memberof PolicySyncResponsePoliciesInner
     */
    'updateCounter'?: number;
}
/**
 * 
 * @export
 * @interface PolicySyncResponseRequestInfo
 */
export interface PolicySyncResponseRequestInfo {
    /**
     * after parameter as requested by the agent
     * @type {number}
     * @memberof PolicySyncResponseRequestInfo
     */
    'after'?: number;
}
/**
 * 
 * @export
 * @interface PolicySyncResponseResponseInfo
 */
export interface PolicySyncResponseResponseInfo {
    /**
     * lowest update count included in this bulk. zero if the bulk is empty.
     * @type {number}
     * @memberof PolicySyncResponseResponseInfo
     */
    'lowestUpdate'?: number;
    /**
     * highest update count included in this bulk. zero if the bulk is empty.
     * @type {number}
     * @memberof PolicySyncResponseResponseInfo
     */
    'highestUpdate'?: number;
}
/**
 * 
 * @export
 * @interface PolicySyncResponseSystemInfo
 */
export interface PolicySyncResponseSystemInfo {
    /**
     * the highest update count in the system.
     * @type {number}
     * @memberof PolicySyncResponseSystemInfo
     */
    'highestUpdate'?: number;
    /**
     * number of policy updates the system is configured to include in every bulk.
     * @type {number}
     * @memberof PolicySyncResponseSystemInfo
     */
    'updatesPerBulk'?: number;
}
/**
 * 
 * @export
 * @interface PolicySyncStatus
 */
export interface PolicySyncStatus {
    /**
     * 
     * @type {Array<PolicySyncStatusOfCluster>}
     * @memberof PolicySyncStatus
     */
    'clusters'?: Array<PolicySyncStatusOfCluster>;
}
/**
 * 
 * @export
 * @interface PolicySyncStatusOfCluster
 */
export interface PolicySyncStatusOfCluster {
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof PolicySyncStatusOfCluster
     */
    'clusterId': string;
    /**
     * Policy sync status of the cluster
     * @type {string}
     * @memberof PolicySyncStatusOfCluster
     */
    'status': PolicySyncStatusOfClusterStatusEnum;
    /**
     * In case sync failed, holds the error message received from the cluster
     * @type {string}
     * @memberof PolicySyncStatusOfCluster
     */
    'errorMessage'?: string | null;
}

export const PolicySyncStatusOfClusterStatusEnum = {
    NotReady: 'Not ready',
    Applying: 'Applying',
    Failed: 'Failed',
    Ready: 'Ready',
    PendingDeletion: 'Pending deletion',
    Deleting: 'Deleting',
    Deleted: 'Deleted',
    DeletionFailed: 'Deletion failed'
} as const;

export type PolicySyncStatusOfClusterStatusEnum = typeof PolicySyncStatusOfClusterStatusEnum[keyof typeof PolicySyncStatusOfClusterStatusEnum];

/**
 * The type of policy which determines the kind of workloads it is affecting
 * @export
 * @enum {string}
 */

export const PolicyType = {
    Workspace: 'workspace',
    Training: 'training',
    Distributed: 'distributed',
    Inference: 'inference',
    Fallback: 'fallback'
} as const;

export type PolicyType = typeof PolicyType[keyof typeof PolicyType];


/**
 * 
 * @export
 * @interface PolicyValidationStatus
 */
export interface PolicyValidationStatus {
    /**
     * 
     * @type {PolicyValidationStatusValidation}
     * @memberof PolicyValidationStatus
     */
    'validation'?: PolicyValidationStatusValidation | null;
}
/**
 * 
 * @export
 * @interface PolicyValidationStatusValidation
 */
export interface PolicyValidationStatusValidation {
    /**
     * In case validation failed, holds the error message explaining the issue
     * @type {string}
     * @memberof PolicyValidationStatusValidation
     */
    'errorMessage'?: string;
}
/**
 * A port for accessing the workload.
 * @export
 * @interface Port
 */
export interface Port {
    /**
     * The port that the container running the workload exposes. (mandatory)
     * @type {number}
     * @memberof Port
     */
    'container'?: number | null;
    /**
     * 
     * @type {PortServiceType}
     * @memberof Port
     */
    'serviceType'?: PortServiceType | null;
    /**
     * The external port which allows a connection to the container port. If not specified, the port will be auto-generated by the system..
     * @type {number}
     * @memberof Port
     */
    'external'?: number | null;
    /**
     * The tool type that runs on this port.
     * @type {string}
     * @memberof Port
     */
    'toolType'?: string | null;
    /**
     * A name describing the tool that runs on this port.
     * @type {string}
     * @memberof Port
     */
    'toolName'?: string | null;
    /**
     * Unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof Port
     */
    'name'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof Port
     */
    'exclude'?: boolean | null;
}
/**
 * Rules for port attributes
 * @export
 * @interface PortRules
 */
export interface PortRules {
    /**
     * 
     * @type {IntegerRules}
     * @memberof PortRules
     */
    'container'?: IntegerRules | null;
    /**
     * 
     * @type {PortServiceTypeRules}
     * @memberof PortRules
     */
    'serviceType'?: PortServiceTypeRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof PortRules
     */
    'customExternalPort'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof PortRules
     */
    'external'?: IntegerRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof PortRules
     */
    'toolType'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof PortRules
     */
    'toolName'?: StringRules | null;
}
/**
 * The service type of the port (mandatory).
 * @export
 * @enum {string}
 */

export const PortServiceType = {
    LoadBalancer: 'LoadBalancer',
    NodePort: 'NodePort',
    ClusterIp: 'ClusterIP'
} as const;

export type PortServiceType = typeof PortServiceType[keyof typeof PortServiceType];


/**
 * 
 * @export
 * @interface PortServiceTypeOptions
 */
export interface PortServiceTypeOptions {
    /**
     * 
     * @type {Array<PortServiceTypeOptionsOptionsInner>}
     * @memberof PortServiceTypeOptions
     */
    'options'?: Array<PortServiceTypeOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface PortServiceTypeOptionsOptionsInner
 */
export interface PortServiceTypeOptionsOptionsInner {
    /**
     * 
     * @type {PortServiceType}
     * @memberof PortServiceTypeOptionsOptionsInner
     */
    'value': PortServiceType | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof PortServiceTypeOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface PortServiceTypeRules
 */
export interface PortServiceTypeRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof PortServiceTypeRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof PortServiceTypeRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof PortServiceTypeRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<PortServiceTypeOptionsOptionsInner>}
     * @memberof PortServiceTypeRules
     */
    'options'?: Array<PortServiceTypeOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface PortsDefaults
 */
export interface PortsDefaults {
    /**
     * 
     * @type {Port}
     * @memberof PortsDefaults
     */
    'attributes'?: Port | null;
    /**
     * Set of container ports that the workload exposes.
     * @type {Array<Port>}
     * @memberof PortsDefaults
     */
    'instances'?: Array<Port> | null;
}
/**
 * 
 * @export
 * @interface PortsRules
 */
export interface PortsRules {
    /**
     * 
     * @type {PortRules}
     * @memberof PortsRules
     */
    'attributes'?: PortRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof PortsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * Priority class of the workload. The default value for workspace is \'build\' and it can be changed to \'interactive-preemptible\' to allow the workload to use over-quota resources. The default value for training is \'train\' and it can be changed to \'build\' to allow the training workload to have a higher priority for in-queue scheduling and also become non-preemptive (if it\'s in deserved quota)..
 * @export
 * @enum {string}
 */

export const PriorityClass = {
    Build: 'build',
    Train: 'train',
    InteractivePreemptible: 'interactive-preemptible'
} as const;

export type PriorityClass = typeof PriorityClass[keyof typeof PriorityClass];


/**
 * 
 * @export
 * @interface PriorityClassFields
 */
export interface PriorityClassFields {
    /**
     * 
     * @type {PriorityClass}
     * @memberof PriorityClassFields
     */
    'priorityClass'?: PriorityClass | null;
}
/**
 * 
 * @export
 * @interface PriorityClassFieldsRules
 */
export interface PriorityClassFieldsRules {
    /**
     * 
     * @type {PriorityClassRules}
     * @memberof PriorityClassFieldsRules
     */
    'priorityClass'?: PriorityClassRules | null;
}
/**
 * 
 * @export
 * @interface PriorityClassOptions
 */
export interface PriorityClassOptions {
    /**
     * 
     * @type {Array<PriorityClassOptionsOptionsInner>}
     * @memberof PriorityClassOptions
     */
    'options'?: Array<PriorityClassOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface PriorityClassOptionsOptionsInner
 */
export interface PriorityClassOptionsOptionsInner {
    /**
     * 
     * @type {PriorityClass}
     * @memberof PriorityClassOptionsOptionsInner
     */
    'value': PriorityClass | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof PriorityClassOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface PriorityClassRules
 */
export interface PriorityClassRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof PriorityClassRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof PriorityClassRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof PriorityClassRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<PriorityClassOptionsOptionsInner>}
     * @memberof PriorityClassRules
     */
    'options'?: Array<PriorityClassOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface Probe
 */
export interface Probe {
    /**
     * Number of seconds after the container has started before liveness or readiness probes are initiated.
     * @type {number}
     * @memberof Probe
     */
    'initialDelaySeconds'?: number | null;
    /**
     * How often (in seconds) to perform the probe.
     * @type {number}
     * @memberof Probe
     */
    'periodSeconds'?: number | null;
    /**
     * Number of seconds after which the probe times out.
     * @type {number}
     * @memberof Probe
     */
    'timeoutSeconds'?: number | null;
    /**
     * Minimum consecutive successes for the probe to be considered successful after having failed.
     * @type {number}
     * @memberof Probe
     */
    'successThreshold'?: number | null;
    /**
     * When a probe fails, the number of times to try before giving up.
     * @type {number}
     * @memberof Probe
     */
    'failureThreshold'?: number | null;
    /**
     * 
     * @type {ProbeHandler}
     * @memberof Probe
     */
    'handler'?: ProbeHandler | null;
}
/**
 * The action taken to determine the health of the container. (mandatory)
 * @export
 * @interface ProbeHandler
 */
export interface ProbeHandler {
    /**
     * 
     * @type {ProbeHandlerHttpGet}
     * @memberof ProbeHandler
     */
    'httpGet'?: ProbeHandlerHttpGet;
}
/**
 * An action based on HTTP Get requests.
 * @export
 * @interface ProbeHandlerHttpGet
 */
export interface ProbeHandlerHttpGet {
    /**
     * Path to access on the HTTP server, defaults to /.
     * @type {string}
     * @memberof ProbeHandlerHttpGet
     */
    'path'?: string | null;
    /**
     * Number of the port to access on the container.
     * @type {number}
     * @memberof ProbeHandlerHttpGet
     */
    'port'?: number | null;
    /**
     * Host name to connect to, defaults to the pod IP.
     * @type {string}
     * @memberof ProbeHandlerHttpGet
     */
    'host'?: string | null;
    /**
     * 
     * @type {ProbeHandlerScheme}
     * @memberof ProbeHandlerHttpGet
     */
    'scheme'?: ProbeHandlerScheme | null;
}
/**
 * 
 * @export
 * @interface ProbeHandlerRules
 */
export interface ProbeHandlerRules {
    /**
     * 
     * @type {ProbeHandlerRulesHttpGet}
     * @memberof ProbeHandlerRules
     */
    'httpGet'?: ProbeHandlerRulesHttpGet;
}
/**
 * 
 * @export
 * @interface ProbeHandlerRulesHttpGet
 */
export interface ProbeHandlerRulesHttpGet {
    /**
     * 
     * @type {StringRules}
     * @memberof ProbeHandlerRulesHttpGet
     */
    'path'?: StringRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ProbeHandlerRulesHttpGet
     */
    'port'?: IntegerRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ProbeHandlerRulesHttpGet
     */
    'host'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ProbeHandlerRulesHttpGet
     */
    'scheme'?: StringRules | null;
}
/**
 * Scheme to use for connecting to the host, defaults to HTTP.
 * @export
 * @enum {string}
 */

export const ProbeHandlerScheme = {
    Http: 'HTTP',
    Https: 'HTTPS'
} as const;

export type ProbeHandlerScheme = typeof ProbeHandlerScheme[keyof typeof ProbeHandlerScheme];


/**
 * 
 * @export
 * @interface ProbeRules
 */
export interface ProbeRules {
    /**
     * 
     * @type {IntegerRules}
     * @memberof ProbeRules
     */
    'initialDelaySeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ProbeRules
     */
    'periodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ProbeRules
     */
    'timeoutSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ProbeRules
     */
    'successThreshold'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ProbeRules
     */
    'failureThreshold'?: IntegerRules | null;
    /**
     * 
     * @type {ProbeHandlerRules}
     * @memberof ProbeRules
     */
    'handler'?: ProbeHandlerRules | null;
}
/**
 * Probes are used to determine if the container is healthy and ready to accept traffic.
 * @export
 * @interface Probes
 */
export interface Probes {
    /**
     * 
     * @type {Probe}
     * @memberof Probes
     */
    'readiness'?: Probe | null;
}
/**
 * 
 * @export
 * @interface ProbesRules
 */
export interface ProbesRules {
    /**
     * 
     * @type {ProbeRules}
     * @memberof ProbesRules
     */
    'readiness'?: ProbeRules | null;
}
/**
 * 
 * @export
 * @interface Pvc
 */
export interface Pvc {
    /**
     * Local path within the workspace to which the PVC bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof Pvc
     */
    'path'?: string | null;
    /**
     * 
     * @type {ClaimInfo}
     * @memberof Pvc
     */
    'claimInfo'?: ClaimInfo | null;
    /**
     * Verify existing PVC. PVC is assumed to exist when set to `true`. If set to `false`, the PVC will be created, if it does not exist.
     * @type {boolean}
     * @memberof Pvc
     */
    'existingPvc'?: boolean | null;
    /**
     * Name for the PVC. Allow referencing it across workloads. If not provided, a name based on the workload name and scope will be auto-generated.
     * @type {string}
     * @memberof Pvc
     */
    'claimName'?: string | null;
    /**
     * Permit only read access to PVC.
     * @type {boolean}
     * @memberof Pvc
     */
    'readOnly'?: boolean | null;
    /**
     * Use `true` to set PVC to ephemeral. If set to `true`, the PVC will be deleted when the workload is stopped. Not supported for inference workloads.
     * @type {boolean}
     * @memberof Pvc
     */
    'ephemeral'?: boolean | null;
    /**
     * use `true` to share the PVC data to all projects under the selected scope.
     * @type {boolean}
     * @memberof Pvc
     */
    'dataSharing'?: boolean | null;
}
/**
 * Requested access mode(s) for the newly created PVC.
 * @export
 * @interface PvcAccessModes
 */
export interface PvcAccessModes {
    /**
     * Requesting claim that can be mounted in read/write mode to exactly one host. This is the default access mode.
     * @type {boolean}
     * @memberof PvcAccessModes
     */
    'readWriteOnce'?: boolean | null;
    /**
     * Requesting claim that can be mounted in read-only mode to many hosts.
     * @type {boolean}
     * @memberof PvcAccessModes
     */
    'readOnlyMany'?: boolean | null;
    /**
     * Requesting claim that can be mounted in read/write mode to many hosts.
     * @type {boolean}
     * @memberof PvcAccessModes
     */
    'readWriteMany'?: boolean | null;
}
/**
 * Rules for access mode(s) for a newly created PVC.
 * @export
 * @interface PvcAccessModesRules
 */
export interface PvcAccessModesRules {
    /**
     * 
     * @type {BooleanRules}
     * @memberof PvcAccessModesRules
     */
    'readWriteOnce'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof PvcAccessModesRules
     */
    'readOnlyMany'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof PvcAccessModesRules
     */
    'readWriteMany'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface PvcAddedAttrValue
 */
export interface PvcAddedAttrValue {
    /**
     * 
     * @type {string}
     * @memberof PvcAddedAttrValue
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof PvcAddedAttrValue
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface PvcFieldsNonUpdatable
 */
export interface PvcFieldsNonUpdatable {
    /**
     * Verify existing PVC. PVC is assumed to exist when set to `true`. If set to `false`, the PVC will be created, if it does not exist.
     * @type {boolean}
     * @memberof PvcFieldsNonUpdatable
     */
    'existingPvc'?: boolean | null;
    /**
     * Name for the PVC. Allow referencing it across workloads. If not provided, a name based on the workload name and scope will be auto-generated.
     * @type {string}
     * @memberof PvcFieldsNonUpdatable
     */
    'claimName'?: string | null;
    /**
     * Permit only read access to PVC.
     * @type {boolean}
     * @memberof PvcFieldsNonUpdatable
     */
    'readOnly'?: boolean | null;
    /**
     * Use `true` to set PVC to ephemeral. If set to `true`, the PVC will be deleted when the workload is stopped. Not supported for inference workloads.
     * @type {boolean}
     * @memberof PvcFieldsNonUpdatable
     */
    'ephemeral'?: boolean | null;
    /**
     * 
     * @type {ClaimInfo}
     * @memberof PvcFieldsNonUpdatable
     */
    'claimInfo'?: ClaimInfo | null;
    /**
     * use `true` to share the PVC data to all projects under the selected scope.
     * @type {boolean}
     * @memberof PvcFieldsNonUpdatable
     */
    'dataSharing'?: boolean | null;
}
/**
 * 
 * @export
 * @interface PvcFieldsUpdatable
 */
export interface PvcFieldsUpdatable {
    /**
     * Local path within the workspace to which the PVC bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof PvcFieldsUpdatable
     */
    'path'?: string | null;
    /**
     * 
     * @type {ClaimInfoUpdatable}
     * @memberof PvcFieldsUpdatable
     */
    'claimInfo'?: ClaimInfoUpdatable | null;
}
/**
 * 
 * @export
 * @interface PvcInstance
 */
export interface PvcInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof PvcInstance
     */
    'name'?: string | null;
    /**
     * Local path within the workspace to which the PVC bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof PvcInstance
     */
    'path'?: string | null;
    /**
     * 
     * @type {ClaimInfo}
     * @memberof PvcInstance
     */
    'claimInfo'?: ClaimInfo | null;
    /**
     * Verify existing PVC. PVC is assumed to exist when set to `true`. If set to `false`, the PVC will be created, if it does not exist.
     * @type {boolean}
     * @memberof PvcInstance
     */
    'existingPvc'?: boolean | null;
    /**
     * Name for the PVC. Allow referencing it across workloads. If not provided, a name based on the workload name and scope will be auto-generated.
     * @type {string}
     * @memberof PvcInstance
     */
    'claimName'?: string | null;
    /**
     * Permit only read access to PVC.
     * @type {boolean}
     * @memberof PvcInstance
     */
    'readOnly'?: boolean | null;
    /**
     * Use `true` to set PVC to ephemeral. If set to `true`, the PVC will be deleted when the workload is stopped. Not supported for inference workloads.
     * @type {boolean}
     * @memberof PvcInstance
     */
    'ephemeral'?: boolean | null;
    /**
     * use `true` to share the PVC data to all projects under the selected scope.
     * @type {boolean}
     * @memberof PvcInstance
     */
    'dataSharing'?: boolean | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof PvcInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface PvcRules
 */
export interface PvcRules {
    /**
     * 
     * @type {StringRules}
     * @memberof PvcRules
     */
    'claimName'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof PvcRules
     */
    'path'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof PvcRules
     */
    'readOnly'?: BooleanRules | null;
    /**
     * 
     * @type {ClaimInfoRules}
     * @memberof PvcRules
     */
    'claimInfo'?: ClaimInfoRules | null;
}
/**
 * The volume mode required by the claim. Choose Filesystem (default) or Block.
 * @export
 * @enum {string}
 */

export const PvcVolumeMode = {
    Filesystem: 'Filesystem',
    Block: 'Block'
} as const;

export type PvcVolumeMode = typeof PvcVolumeMode[keyof typeof PvcVolumeMode];


/**
 * 
 * @export
 * @interface PvcsDefaults
 */
export interface PvcsDefaults {
    /**
     * 
     * @type {PvcInstance}
     * @memberof PvcsDefaults
     */
    'attributes'?: PvcInstance | null;
    /**
     * Set of pvc persistent volume claims to use in the workload.
     * @type {Array<PvcInstance>}
     * @memberof PvcsDefaults
     */
    'instances'?: Array<PvcInstance> | null;
}
/**
 * 
 * @export
 * @interface PvcsRules
 */
export interface PvcsRules {
    /**
     * 
     * @type {PvcRules}
     * @memberof PvcsRules
     */
    'attributes'?: PvcRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof PvcsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface QuantityRules
 */
export interface QuantityRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof QuantityRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof QuantityRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof QuantityRules
     */
    'canEdit'?: boolean | null;
    /**
     * The minimum value that the field can be assigned to.
     * @type {string}
     * @memberof QuantityRules
     */
    'min'?: string | null;
    /**
     * The maximum value that the field can be assigned to.
     * @type {string}
     * @memberof QuantityRules
     */
    'max'?: string | null;
    /**
     * 
     * @type {DefaultFromRule}
     * @memberof QuantityRules
     */
    'defaultFrom'?: DefaultFromRule | null;
}
/**
 * A URL that is related to the workload. For example, a URL to an external server providing statistics or logging about the workload.
 * @export
 * @interface RelatedUrl
 */
export interface RelatedUrl {
    /**
     * The URL for connecting an external service related to the workload. (mandatory)
     * @type {string}
     * @memberof RelatedUrl
     */
    'url'?: string | null;
    /**
     * The type of service that the url provides. For example, wandb (Weights & Biases). (mandatory)
     * @type {string}
     * @memberof RelatedUrl
     */
    'type'?: string | null;
    /**
     * Unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof RelatedUrl
     */
    'name'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof RelatedUrl
     */
    'exclude'?: boolean | null;
}
/**
 * Rules for the attributes of relatedUrls
 * @export
 * @interface RelatedUrlRules
 */
export interface RelatedUrlRules {
    /**
     * 
     * @type {StringRules}
     * @memberof RelatedUrlRules
     */
    'url'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof RelatedUrlRules
     */
    'type'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof RelatedUrlRules
     */
    'name'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface RelatedUrlsDefaults
 */
export interface RelatedUrlsDefaults {
    /**
     * 
     * @type {RelatedUrl}
     * @memberof RelatedUrlsDefaults
     */
    'attributes'?: RelatedUrl | null;
    /**
     * Set of URLs that are related to the workload.
     * @type {Array<RelatedUrl>}
     * @memberof RelatedUrlsDefaults
     */
    'instances'?: Array<RelatedUrl> | null;
}
/**
 * 
 * @export
 * @interface RelatedUrlsRules
 */
export interface RelatedUrlsRules {
    /**
     * 
     * @type {RelatedUrlRules}
     * @memberof RelatedUrlsRules
     */
    'attributes'?: RelatedUrlRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof RelatedUrlsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface ReplicaDefaultsV2
 */
export interface ReplicaDefaultsV2 {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof ReplicaDefaultsV2
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof ReplicaDefaultsV2
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof ReplicaDefaultsV2
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof ReplicaDefaultsV2
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof ReplicaDefaultsV2
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof ReplicaDefaultsV2
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof ReplicaDefaultsV2
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof ReplicaDefaultsV2
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof ReplicaDefaultsV2
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof ReplicaDefaultsV2
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * 
     * @type {EnvironmentVariablesDefaults}
     * @memberof ReplicaDefaultsV2
     */
    'environmentVariables'?: EnvironmentVariablesDefaults | null;
    /**
     * 
     * @type {AnnotationsDefaults}
     * @memberof ReplicaDefaultsV2
     */
    'annotations'?: AnnotationsDefaults | null;
    /**
     * 
     * @type {LabelsDefaults}
     * @memberof ReplicaDefaultsV2
     */
    'labels'?: LabelsDefaults | null;
    /**
     * 
     * @type {TolerationsDefaults}
     * @memberof ReplicaDefaultsV2
     */
    'tolerations'?: TolerationsDefaults | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof ReplicaDefaultsV2
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof ReplicaDefaultsV2
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof ReplicaDefaultsV2
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof ReplicaDefaultsV2
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof ReplicaDefaultsV2
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * 
     * @type {PortsDefaults}
     * @memberof ReplicaDefaultsV2
     */
    'ports'?: PortsDefaults | null;
    /**
     * 
     * @type {ExposedUrlsDefaults}
     * @memberof ReplicaDefaultsV2
     */
    'exposedUrls'?: ExposedUrlsDefaults | null;
    /**
     * 
     * @type {RelatedUrlsDefaults}
     * @memberof ReplicaDefaultsV2
     */
    'relatedUrls'?: RelatedUrlsDefaults | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof ReplicaDefaultsV2
     */
    'security'?: SecurityFlatFields | null;
    /**
     * 
     * @type {ComputeFieldsDefaults}
     * @memberof ReplicaDefaultsV2
     */
    'compute'?: ComputeFieldsDefaults | null;
    /**
     * 
     * @type {StorageFieldsDefaults}
     * @memberof ReplicaDefaultsV2
     */
    'storage'?: StorageFieldsDefaults | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof ReplicaDefaultsV2
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof ReplicaDefaultsV2
     */
    'stdin'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ReplicaRulesV2
 */
export interface ReplicaRulesV2 {
    /**
     * 
     * @type {StringRules}
     * @memberof ReplicaRulesV2
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ReplicaRulesV2
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ReplicaRulesV2
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof ReplicaRulesV2
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ReplicaRulesV2
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof ReplicaRulesV2
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof ReplicaRulesV2
     */
    'probes'?: ProbesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ReplicaRulesV2
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof ReplicaRulesV2
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof ReplicaRulesV2
     */
    'podAffinity'?: PodAffinityRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof ReplicaRulesV2
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof ReplicaRulesV2
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof ReplicaRulesV2
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof ReplicaRulesV2
     */
    'tolerations'?: TolerationsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof ReplicaRulesV2
     */
    'terminateAfterPreemption'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ReplicaRulesV2
     */
    'autoDeletionTimeAfterCompletionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ReplicaRulesV2
     */
    'terminationGracePeriodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ReplicaRulesV2
     */
    'backoffLimit'?: IntegerRules | null;
    /**
     * 
     * @type {RestartPolicyRule}
     * @memberof ReplicaRulesV2
     */
    'restartPolicy'?: RestartPolicyRule | null;
    /**
     * 
     * @type {PortsRules}
     * @memberof ReplicaRulesV2
     */
    'ports'?: PortsRules | null;
    /**
     * 
     * @type {ExposedUrlsRules}
     * @memberof ReplicaRulesV2
     */
    'exposedUrls'?: ExposedUrlsRules | null;
    /**
     * 
     * @type {RelatedUrlsRules}
     * @memberof ReplicaRulesV2
     */
    'relatedUrls'?: RelatedUrlsRules | null;
    /**
     * 
     * @type {SecurityFlatFieldsRules}
     * @memberof ReplicaRulesV2
     */
    'security'?: SecurityFlatFieldsRules | null;
    /**
     * 
     * @type {ComputeFieldsRules}
     * @memberof ReplicaRulesV2
     */
    'compute'?: ComputeFieldsRules | null;
    /**
     * 
     * @type {StorageFieldsRules}
     * @memberof ReplicaRulesV2
     */
    'storage'?: StorageFieldsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof ReplicaRulesV2
     */
    'tty'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof ReplicaRulesV2
     */
    'stdin'?: BooleanRules | null;
}
/**
 * Resource parameters.
 * @export
 * @interface ResourcesFlatFields
 */
export interface ResourcesFlatFields {
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof ResourcesFlatFields
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof ResourcesFlatFields
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof ResourcesFlatFields
     */
    'podAffinity'?: PodAffinity | null;
}
/**
 * Resource related parameters.
 * @export
 * @interface ResourcesFlatFieldsRules
 */
export interface ResourcesFlatFieldsRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ResourcesFlatFieldsRules
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof ResourcesFlatFieldsRules
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof ResourcesFlatFieldsRules
     */
    'podAffinity'?: PodAffinityRules | null;
}
/**
 * Specify the restart policy of the workload pods. Default is empty, which is determine by the framework default
 * @export
 * @enum {string}
 */

export const RestartPolicy = {
    Always: 'Always',
    Never: 'Never',
    OnFailure: 'OnFailure'
} as const;

export type RestartPolicy = typeof RestartPolicy[keyof typeof RestartPolicy];


/**
 * 
 * @export
 * @interface RestartPolicyOptions
 */
export interface RestartPolicyOptions {
    /**
     * Limit the permitted values for restartPolicy to a given set of values.
     * @type {Array<RestartPolicyOptionsOptionsInner>}
     * @memberof RestartPolicyOptions
     */
    'options'?: Array<RestartPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface RestartPolicyOptionsOptionsInner
 */
export interface RestartPolicyOptionsOptionsInner {
    /**
     * 
     * @type {RestartPolicy}
     * @memberof RestartPolicyOptionsOptionsInner
     */
    'value': RestartPolicy | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof RestartPolicyOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface RestartPolicyRule
 */
export interface RestartPolicyRule {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof RestartPolicyRule
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof RestartPolicyRule
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof RestartPolicyRule
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for restartPolicy to a given set of values.
     * @type {Array<RestartPolicyOptionsOptionsInner>}
     * @memberof RestartPolicyRule
     */
    'options'?: Array<RestartPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface S3AccessKey
 */
export interface S3AccessKey {
    /**
     * Name of the secret containing credentials of the S3 bucket. Used for private S3 buckets.
     * @type {string}
     * @memberof S3AccessKey
     */
    'accessKeySecret'?: string | null;
    /**
     * The key to use for loading the access key id from the secret. The default is `AccessKeyId`. For more information, see [Credentials access keys](https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_access-keys.html).
     * @type {string}
     * @memberof S3AccessKey
     */
    'secretKeyOfAccessKeyId'?: string | null;
    /**
     * The key to use for loading the secret key from the secret. The default is `SecretKey`. For more information, see [Credentials access keys](https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_access-keys.html).
     * @type {string}
     * @memberof S3AccessKey
     */
    'secretKeyOfSecretKey'?: string | null;
}
/**
 * 
 * @export
 * @interface S3Common
 */
export interface S3Common {
    /**
     * The name of the bucket. (mandatory)
     * @type {string}
     * @memberof S3Common
     */
    'bucket'?: string | null;
    /**
     * Local path within the workspace to which the S3 bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof S3Common
     */
    'path'?: string | null;
    /**
     * The url of the S3 service provider. The default is the URL of the Amazon AWS S3 service.
     * @type {string}
     * @memberof S3Common
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface S3Instance
 */
export interface S3Instance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof S3Instance
     */
    'name'?: string | null;
    /**
     * The name of the bucket. (mandatory)
     * @type {string}
     * @memberof S3Instance
     */
    'bucket'?: string | null;
    /**
     * Local path within the workspace to which the S3 bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof S3Instance
     */
    'path'?: string | null;
    /**
     * The url of the S3 service provider. The default is the URL of the Amazon AWS S3 service.
     * @type {string}
     * @memberof S3Instance
     */
    'url'?: string | null;
    /**
     * Name of the secret containing credentials of the S3 bucket. Used for private S3 buckets.
     * @type {string}
     * @memberof S3Instance
     */
    'accessKeySecret'?: string | null;
    /**
     * The key to use for loading the access key id from the secret. The default is `AccessKeyId`. For more information, see [Credentials access keys](https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_access-keys.html).
     * @type {string}
     * @memberof S3Instance
     */
    'secretKeyOfAccessKeyId'?: string | null;
    /**
     * The key to use for loading the secret key from the secret. The default is `SecretKey`. For more information, see [Credentials access keys](https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_access-keys.html).
     * @type {string}
     * @memberof S3Instance
     */
    'secretKeyOfSecretKey'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof S3Instance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface S3Rules
 */
export interface S3Rules {
    /**
     * 
     * @type {StringRules}
     * @memberof S3Rules
     */
    'bucket'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof S3Rules
     */
    'path'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof S3Rules
     */
    'url'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface S3sDefaults
 */
export interface S3sDefaults {
    /**
     * 
     * @type {S3Instance}
     * @memberof S3sDefaults
     */
    'attributes'?: S3Instance | null;
    /**
     * Set of s3 buckets to use in the workload.
     * @type {Array<S3Instance>}
     * @memberof S3sDefaults
     */
    'instances'?: Array<S3Instance> | null;
}
/**
 * 
 * @export
 * @interface S3sRules
 */
export interface S3sRules {
    /**
     * 
     * @type {S3Rules}
     * @memberof S3sRules
     */
    'attributes'?: S3Rules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof S3sRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ScopeType = {
    System: 'system',
    Tenant: 'tenant',
    Cluster: 'cluster',
    Department: 'department',
    Project: 'project'
} as const;

export type ScopeType = typeof ScopeType[keyof typeof ScopeType];


/**
 * Indicates which kind of seccomp profile will be applied to the container. The options are a. `RuntimeDefault` - the container runtime default profile should be used. b. `Unconfined` - no profile should be applied. c. `Localhost` is not yet supported by Run:ai.
 * @export
 * @enum {string}
 */

export const SeccompProfileType = {
    RuntimeDefault: 'RuntimeDefault',
    Unconfined: 'Unconfined',
    Localhost: 'Localhost'
} as const;

export type SeccompProfileType = typeof SeccompProfileType[keyof typeof SeccompProfileType];


/**
 * 
 * @export
 * @interface SeccompProfileTypeOptions
 */
export interface SeccompProfileTypeOptions {
    /**
     * Limit the permitted values for secompProfileType to a given set of values.
     * @type {Array<SeccompProfileTypeOptionsOptionsInner>}
     * @memberof SeccompProfileTypeOptions
     */
    'options'?: Array<SeccompProfileTypeOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface SeccompProfileTypeOptionsOptionsInner
 */
export interface SeccompProfileTypeOptionsOptionsInner {
    /**
     * 
     * @type {SeccompProfileType}
     * @memberof SeccompProfileTypeOptionsOptionsInner
     */
    'value': SeccompProfileType | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof SeccompProfileTypeOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface SeccompProfileTypeRules
 */
export interface SeccompProfileTypeRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof SeccompProfileTypeRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof SeccompProfileTypeRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof SeccompProfileTypeRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for secompProfileType to a given set of values.
     * @type {Array<SeccompProfileTypeOptionsOptionsInner>}
     * @memberof SeccompProfileTypeRules
     */
    'options'?: Array<SeccompProfileTypeOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface Secret
 */
export interface Secret {
    /**
     * Local path within the workspace to which the Secret will be mapped to. (mandatory)
     * @type {string}
     * @memberof Secret
     */
    'mountPath'?: string | null;
    /**
     * The name of the Secret resource. (mandatory)
     * @type {string}
     * @memberof Secret
     */
    'secret'?: string | null;
}
/**
 * 
 * @export
 * @interface SecretFieldsNonUpdatable
 */
export interface SecretFieldsNonUpdatable {
    /**
     * The name of the Secret resource. (mandatory)
     * @type {string}
     * @memberof SecretFieldsNonUpdatable
     */
    'secret'?: string | null;
}
/**
 * 
 * @export
 * @interface SecretFieldsUpdatable
 */
export interface SecretFieldsUpdatable {
    /**
     * Local path within the workspace to which the Secret will be mapped to. (mandatory)
     * @type {string}
     * @memberof SecretFieldsUpdatable
     */
    'mountPath'?: string | null;
}
/**
 * 
 * @export
 * @interface SecretInstance
 */
export interface SecretInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof SecretInstance
     */
    'name'?: string | null;
    /**
     * Local path within the workspace to which the Secret will be mapped to. (mandatory)
     * @type {string}
     * @memberof SecretInstance
     */
    'mountPath'?: string | null;
    /**
     * The name of the Secret resource. (mandatory)
     * @type {string}
     * @memberof SecretInstance
     */
    'secret'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof SecretInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface SecretRules
 */
export interface SecretRules {
    /**
     * 
     * @type {StringRules}
     * @memberof SecretRules
     */
    'secret'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SecretRules
     */
    'mountPath'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface SecretsDefaults
 */
export interface SecretsDefaults {
    /**
     * 
     * @type {SecretInstance}
     * @memberof SecretsDefaults
     */
    'attributes'?: SecretInstance | null;
    /**
     * Set of secret volumes to use in the workload
     * @type {Array<SecretInstance>}
     * @memberof SecretsDefaults
     */
    'instances'?: Array<SecretInstance> | null;
}
/**
 * 
 * @export
 * @interface SecretsRules
 */
export interface SecretsRules {
    /**
     * 
     * @type {SecretRules}
     * @memberof SecretsRules
     */
    'attributes'?: SecretRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof SecretsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface Security
 */
export interface Security {
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof Security
     */
    'security'?: SecurityFlatFields | null;
}
/**
 * 
 * @export
 * @interface SecurityFlatFields
 */
export interface SecurityFlatFields {
    /**
     * 
     * @type {UidGidSource}
     * @memberof SecurityFlatFields
     */
    'uidGidSource'?: UidGidSource | null;
    /**
     * Add POSIX capabilities to running containers. Defaults to the default set of capabilities granted by the container runtime.
     * @type {Array<Capability>}
     * @memberof SecurityFlatFields
     */
    'capabilities'?: Array<Capability> | null;
    /**
     * 
     * @type {SeccompProfileType}
     * @memberof SecurityFlatFields
     */
    'seccompProfileType'?: SeccompProfileType | null;
    /**
     * Force the container to run as a non-root user.
     * @type {boolean}
     * @memberof SecurityFlatFields
     */
    'runAsNonRoot'?: boolean | null;
    /**
     * If true, mounts the container\'s root filesystem as read-only.
     * @type {boolean}
     * @memberof SecurityFlatFields
     */
    'readOnlyRootFilesystem'?: boolean | null;
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof SecurityFlatFields
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof SecurityFlatFields
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof SecurityFlatFields
     */
    'supplementalGroups'?: string | null;
    /**
     * Allow the container running the workload and all launched processes to gain additional privileges after the workload starts. For more information consult the User Identity in Container guide at https://docs.run.ai/admin/runai-setup/config/non-root-containers/
     * @type {boolean}
     * @memberof SecurityFlatFields
     */
    'allowPrivilegeEscalation'?: boolean | null;
    /**
     * Whether to enable host IPC. Defaults to false.
     * @type {boolean}
     * @memberof SecurityFlatFields
     */
    'hostIpc'?: boolean | null;
    /**
     * Whether to enable host networking. Default to false.
     * @type {boolean}
     * @memberof SecurityFlatFields
     */
    'hostNetwork'?: boolean | null;
}
/**
 * 
 * @export
 * @interface SecurityFlatFieldsRules
 */
export interface SecurityFlatFieldsRules {
    /**
     * 
     * @type {UidGidSourceRules}
     * @memberof SecurityFlatFieldsRules
     */
    'uidGidSource'?: UidGidSourceRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof SecurityFlatFieldsRules
     */
    'capabilities'?: ArrayRules | null;
    /**
     * 
     * @type {SeccompProfileTypeRules}
     * @memberof SecurityFlatFieldsRules
     */
    'seccompProfileType'?: SeccompProfileTypeRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SecurityFlatFieldsRules
     */
    'runAsNonRoot'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SecurityFlatFieldsRules
     */
    'readOnlyRootFilesystem'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof SecurityFlatFieldsRules
     */
    'runAsUid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof SecurityFlatFieldsRules
     */
    'runAsGid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SecurityFlatFieldsRules
     */
    'supplementalGroups'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SecurityFlatFieldsRules
     */
    'allowPrivilegeEscalation'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SecurityFlatFieldsRules
     */
    'hostIpc'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SecurityFlatFieldsRules
     */
    'hostNetwork'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface SecurityRules
 */
export interface SecurityRules {
    /**
     * 
     * @type {SecurityFlatFieldsRules}
     * @memberof SecurityRules
     */
    'security'?: SecurityFlatFieldsRules | null;
}
/**
 * A port for accessing the inference service
 * @export
 * @interface ServingPort
 */
export interface ServingPort {
    /**
     * The port that the container running the inference service exposes (mandatory).
     * @type {number}
     * @memberof ServingPort
     */
    'container'?: number | null;
    /**
     * 
     * @type {ServingPortProtocol}
     * @memberof ServingPort
     */
    'protocol'?: ServingPortProtocol | null;
    /**
     * 
     * @type {ServingPortAccessAuthorizationTypeEnum}
     * @memberof ServingPort
     */
    'authorizationType'?: ServingPortAccessAuthorizationTypeEnum | null;
    /**
     * List of users that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ServingPort
     */
    'authorizedUsers'?: Array<string> | null;
    /**
     * List of groups that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ServingPort
     */
    'authorizedGroups'?: Array<string> | null;
    /**
     * Configure the serving port URL to be available only on the cluster-local network, and not externally. Defaults to false
     * @type {boolean}
     * @memberof ServingPort
     */
    'clusterLocalAccessOnly'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ServingPortAccess
 */
export interface ServingPortAccess {
    /**
     * 
     * @type {ServingPortAccessAuthorizationTypeEnum}
     * @memberof ServingPortAccess
     */
    'authorizationType'?: ServingPortAccessAuthorizationTypeEnum | null;
    /**
     * List of users that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ServingPortAccess
     */
    'authorizedUsers'?: Array<string> | null;
    /**
     * List of groups that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ServingPortAccess
     */
    'authorizedGroups'?: Array<string> | null;
    /**
     * Configure the serving port URL to be available only on the cluster-local network, and not externally. Defaults to false
     * @type {boolean}
     * @memberof ServingPortAccess
     */
    'clusterLocalAccessOnly'?: boolean | null;
}
/**
 * The authorization type for serving port URL access. Defaults to public, which means no authorization is required. If set to authenticatedUsers, only authenticated Run:ai users are allowed to access the URL. If set to authorizedUsersOrGroups, only users or groups specified in authorizedUsers or authorizedGroups are allowed to access the URL. Supported from cluster version 2.19.
 * @export
 * @enum {string}
 */

export const ServingPortAccessAuthorizationTypeEnum = {
    Public: 'public',
    AuthenticatedUsers: 'authenticatedUsers',
    AuthorizedUsersOrGroups: 'authorizedUsersOrGroups'
} as const;

export type ServingPortAccessAuthorizationTypeEnum = typeof ServingPortAccessAuthorizationTypeEnum[keyof typeof ServingPortAccessAuthorizationTypeEnum];


/**
 * 
 * @export
 * @interface ServingPortContainerAndProtocol
 */
export interface ServingPortContainerAndProtocol {
    /**
     * The port that the container running the inference service exposes (mandatory).
     * @type {number}
     * @memberof ServingPortContainerAndProtocol
     */
    'container'?: number | null;
    /**
     * 
     * @type {ServingPortProtocol}
     * @memberof ServingPortContainerAndProtocol
     */
    'protocol'?: ServingPortProtocol | null;
}
/**
 * The protocol used by the port, defaults to http
 * @export
 * @enum {string}
 */

export const ServingPortProtocol = {
    Http: 'http',
    Grpc: 'grpc'
} as const;

export type ServingPortProtocol = typeof ServingPortProtocol[keyof typeof ServingPortProtocol];


/**
 * 
 * @export
 * @interface ServingPortProtocolOptions
 */
export interface ServingPortProtocolOptions {
    /**
     * 
     * @type {Array<ServingPortProtocolOptionsOptionsInner>}
     * @memberof ServingPortProtocolOptions
     */
    'options'?: Array<ServingPortProtocolOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface ServingPortProtocolOptionsOptionsInner
 */
export interface ServingPortProtocolOptionsOptionsInner {
    /**
     * 
     * @type {ServingPortProtocol}
     * @memberof ServingPortProtocolOptionsOptionsInner
     */
    'value': ServingPortProtocol | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof ServingPortProtocolOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface ServingPortProtocolRules
 */
export interface ServingPortProtocolRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof ServingPortProtocolRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof ServingPortProtocolRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof ServingPortProtocolRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<ServingPortProtocolOptionsOptionsInner>}
     * @memberof ServingPortProtocolRules
     */
    'options'?: Array<ServingPortProtocolOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface ServingPortRules
 */
export interface ServingPortRules {
    /**
     * 
     * @type {IntegerRules}
     * @memberof ServingPortRules
     */
    'container'?: IntegerRules | null;
    /**
     * 
     * @type {ServingPortProtocolRules}
     * @memberof ServingPortRules
     */
    'protocol'?: ServingPortProtocolRules | null;
}
/**
 * This field is used by the system along with effective rules, in order to specify the org unit from which this effective rule has been derived. It should be left empty when sending apply policy requests.
 * @export
 * @interface SourceOfRule
 */
export interface SourceOfRule {
    /**
     * 
     * @type {ScopeType}
     * @memberof SourceOfRule
     */
    'scope': ScopeType;
    /**
     * The id of the project.
     * @type {number}
     * @memberof SourceOfRule
     */
    'projectId'?: number | null;
    /**
     * The id of the department.
     * @type {string}
     * @memberof SourceOfRule
     */
    'departmentId'?: string | null;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof SourceOfRule
     */
    'clusterId'?: string | null;
    /**
     * source of this rule is the fallback policy
     * @type {boolean}
     * @memberof SourceOfRule
     */
    'isFallback'?: boolean;
}
/**
 * 
 * @export
 * @interface StorageDefaults
 */
export interface StorageDefaults {
    /**
     * 
     * @type {StorageFieldsDefaults}
     * @memberof StorageDefaults
     */
    'storage'?: StorageFieldsDefaults | null;
}
/**
 * 
 * @export
 * @interface StorageFieldsDefaults
 */
export interface StorageFieldsDefaults {
    /**
     * 
     * @type {DataVolumesDefaults}
     * @memberof StorageFieldsDefaults
     */
    'dataVolume'?: DataVolumesDefaults | null;
    /**
     * 
     * @type {PvcsDefaults}
     * @memberof StorageFieldsDefaults
     */
    'pvc'?: PvcsDefaults | null;
    /**
     * 
     * @type {HostPathsDefaults}
     * @memberof StorageFieldsDefaults
     */
    'hostPath'?: HostPathsDefaults | null;
    /**
     * 
     * @type {NfssDefaults}
     * @memberof StorageFieldsDefaults
     */
    'nfs'?: NfssDefaults | null;
    /**
     * 
     * @type {GitsDefaults}
     * @memberof StorageFieldsDefaults
     */
    'git'?: GitsDefaults | null;
    /**
     * 
     * @type {ConfigMapsDefaults}
     * @memberof StorageFieldsDefaults
     */
    'configMapVolume'?: ConfigMapsDefaults | null;
    /**
     * 
     * @type {SecretsDefaults}
     * @memberof StorageFieldsDefaults
     */
    'secretVolume'?: SecretsDefaults | null;
    /**
     * 
     * @type {S3sDefaults}
     * @memberof StorageFieldsDefaults
     */
    's3'?: S3sDefaults | null;
}
/**
 * 
 * @export
 * @interface StorageFieldsRules
 */
export interface StorageFieldsRules {
    /**
     * 
     * @type {DataVolumesRules}
     * @memberof StorageFieldsRules
     */
    'dataVolume'?: DataVolumesRules | null;
    /**
     * 
     * @type {PvcsRules}
     * @memberof StorageFieldsRules
     */
    'pvc'?: PvcsRules | null;
    /**
     * 
     * @type {HostPathsRules}
     * @memberof StorageFieldsRules
     */
    'hostPath'?: HostPathsRules | null;
    /**
     * 
     * @type {NfssRules}
     * @memberof StorageFieldsRules
     */
    'nfs'?: NfssRules | null;
    /**
     * 
     * @type {GitsRules}
     * @memberof StorageFieldsRules
     */
    'git'?: GitsRules | null;
    /**
     * 
     * @type {ConfigMapsRules}
     * @memberof StorageFieldsRules
     */
    'configMapVolume'?: ConfigMapsRules | null;
    /**
     * 
     * @type {SecretsRules}
     * @memberof StorageFieldsRules
     */
    'secretVolume'?: SecretsRules | null;
    /**
     * 
     * @type {S3sRules}
     * @memberof StorageFieldsRules
     */
    's3'?: S3sRules | null;
}
/**
 * 
 * @export
 * @interface StorageInstanceName
 */
export interface StorageInstanceName {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof StorageInstanceName
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface StorageRules
 */
export interface StorageRules {
    /**
     * 
     * @type {StorageFieldsRules}
     * @memberof StorageRules
     */
    'storage'?: StorageFieldsRules | null;
}
/**
 * One of the values that the field can be assigned to, when options police is applied on the field.
 * @export
 * @interface StringOption
 */
export interface StringOption {
    /**
     * The value that the field should hold
     * @type {string}
     * @memberof StringOption
     */
    'value': string;
    /**
     * Textual description of the value. to be used by user interface applications.
     * @type {string}
     * @memberof StringOption
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface StringRules
 */
export interface StringRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof StringRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof StringRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof StringRules
     */
    'canEdit'?: boolean | null;
    /**
     * Set of options that the value of the field must be chosen from.
     * @type {Array<StringOption>}
     * @memberof StringRules
     */
    'options'?: Array<StringOption> | null;
}
/**
 * 
 * @export
 * @interface StringRulesCommon
 */
export interface StringRulesCommon {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof StringRulesCommon
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof StringRulesCommon
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof StringRulesCommon
     */
    'canEdit'?: boolean | null;
}
/**
 * 
 * @export
 * @interface StringRulesOptions
 */
export interface StringRulesOptions {
    /**
     * Set of options that the value of the field must be chosen from.
     * @type {Array<StringOption>}
     * @memberof StringRulesOptions
     */
    'options'?: Array<StringOption> | null;
}
/**
 * 
 * @export
 * @interface SupersetDefaults
 */
export interface SupersetDefaults {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof SupersetDefaults
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof SupersetDefaults
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof SupersetDefaults
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof SupersetDefaults
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof SupersetDefaults
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof SupersetDefaults
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof SupersetDefaults
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof SupersetDefaults
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof SupersetDefaults
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof SupersetDefaults
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof SupersetDefaults
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof SupersetDefaults
     */
    'stdin'?: boolean | null;
    /**
     * 
     * @type {EnvironmentVariablesDefaults}
     * @memberof SupersetDefaults
     */
    'environmentVariables'?: EnvironmentVariablesDefaults | null;
    /**
     * 
     * @type {AnnotationsDefaults}
     * @memberof SupersetDefaults
     */
    'annotations'?: AnnotationsDefaults | null;
    /**
     * 
     * @type {LabelsDefaults}
     * @memberof SupersetDefaults
     */
    'labels'?: LabelsDefaults | null;
    /**
     * 
     * @type {TolerationsDefaults}
     * @memberof SupersetDefaults
     */
    'tolerations'?: TolerationsDefaults | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof SupersetDefaults
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof SupersetDefaults
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof SupersetDefaults
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof SupersetDefaults
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof SupersetDefaults
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * 
     * @type {PortsDefaults}
     * @memberof SupersetDefaults
     */
    'ports'?: PortsDefaults | null;
    /**
     * 
     * @type {ExposedUrlsDefaults}
     * @memberof SupersetDefaults
     */
    'exposedUrls'?: ExposedUrlsDefaults | null;
    /**
     * 
     * @type {RelatedUrlsDefaults}
     * @memberof SupersetDefaults
     */
    'relatedUrls'?: RelatedUrlsDefaults | null;
    /**
     * 
     * @type {PriorityClass}
     * @memberof SupersetDefaults
     */
    'priorityClass'?: PriorityClass | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof SupersetDefaults
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof SupersetDefaults
     */
    'parallelism'?: number | null;
    /**
     * the number of workers that will be allocated for running the workload.
     * @type {number}
     * @memberof SupersetDefaults
     */
    'numWorkers'?: number | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof SupersetDefaults
     */
    'distributedFramework'?: DistributedFramework | null;
    /**
     * Specifies the number of slots per worker used in hostfile. Defaults to 1. (applicable only for MPI)
     * @type {number}
     * @memberof SupersetDefaults
     */
    'slotsPerWorker'?: number | null;
    /**
     * Specifies the directory where SSH keys are mounted. (applicable only for MPI)
     * @type {string}
     * @memberof SupersetDefaults
     */
    'sshAuthMountPath'?: string | null;
    /**
     * 
     * @type {DistributedMpiLauncherCreationPolicy}
     * @memberof SupersetDefaults
     */
    'mpiLauncherCreationPolicy'?: DistributedMpiLauncherCreationPolicy | null;
    /**
     * the lower limit for the number of worker pods to which the training job can scale down. (applicable only for PyTorch)
     * @type {number}
     * @memberof SupersetDefaults
     */
    'minReplicas'?: number | null;
    /**
     * the upper limit for the number of worker pods that can be set by the autoscaler. Cannot be smaller than MinReplicas. (applicable only for PyTorch)
     * @type {number}
     * @memberof SupersetDefaults
     */
    'maxReplicas'?: number | null;
    /**
     * 
     * @type {DistributedCleanPodPolicy}
     * @memberof SupersetDefaults
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicy | null;
    /**
     * 
     * @type {ServingPort}
     * @memberof SupersetDefaults
     */
    'servingPort'?: ServingPort | null;
    /**
     * 
     * @type {AutoScaling}
     * @memberof SupersetDefaults
     */
    'autoscaling'?: AutoScaling | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof SupersetDefaults
     */
    'security'?: SecurityFlatFields | null;
    /**
     * 
     * @type {ComputeFieldsDefaults}
     * @memberof SupersetDefaults
     */
    'compute'?: ComputeFieldsDefaults | null;
    /**
     * 
     * @type {StorageFieldsDefaults}
     * @memberof SupersetDefaults
     */
    'storage'?: StorageFieldsDefaults | null;
}
/**
 * 
 * @export
 * @interface SupersetPolicy
 */
export interface SupersetPolicy {
    /**
     * 
     * @type {FallbackPolicyDefaultsAndRulesDefaults}
     * @memberof SupersetPolicy
     */
    'defaults'?: FallbackPolicyDefaultsAndRulesDefaults | null;
    /**
     * 
     * @type {FallbackPolicyDefaultsAndRulesRules}
     * @memberof SupersetPolicy
     */
    'rules'?: FallbackPolicyDefaultsAndRulesRules | null;
}
/**
 * 
 * @export
 * @interface SupersetRules
 */
export interface SupersetRules {
    /**
     * 
     * @type {StringRules}
     * @memberof SupersetRules
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SupersetRules
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SupersetRules
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof SupersetRules
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SupersetRules
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SupersetRules
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof SupersetRules
     */
    'probes'?: ProbesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SupersetRules
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof SupersetRules
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof SupersetRules
     */
    'podAffinity'?: PodAffinityRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SupersetRules
     */
    'tty'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SupersetRules
     */
    'stdin'?: BooleanRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof SupersetRules
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof SupersetRules
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof SupersetRules
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof SupersetRules
     */
    'tolerations'?: TolerationsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SupersetRules
     */
    'terminateAfterPreemption'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'autoDeletionTimeAfterCompletionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'terminationGracePeriodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'backoffLimit'?: IntegerRules | null;
    /**
     * 
     * @type {RestartPolicyRule}
     * @memberof SupersetRules
     */
    'restartPolicy'?: RestartPolicyRule | null;
    /**
     * 
     * @type {PortsRules}
     * @memberof SupersetRules
     */
    'ports'?: PortsRules | null;
    /**
     * 
     * @type {ExposedUrlsRules}
     * @memberof SupersetRules
     */
    'exposedUrls'?: ExposedUrlsRules | null;
    /**
     * 
     * @type {RelatedUrlsRules}
     * @memberof SupersetRules
     */
    'relatedUrls'?: RelatedUrlsRules | null;
    /**
     * 
     * @type {PriorityClassRules}
     * @memberof SupersetRules
     */
    'priorityClass'?: PriorityClassRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'completions'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'parallelism'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'numWorkers'?: IntegerRules | null;
    /**
     * 
     * @type {DistributedFrameworkRules}
     * @memberof SupersetRules
     */
    'distributedFramework'?: DistributedFrameworkRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'slotsPerWorker'?: IntegerRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SupersetRules
     */
    'sshAuthMountPath'?: StringRules | null;
    /**
     * 
     * @type {DistributedMpiLauncherCreationPolicyRules}
     * @memberof SupersetRules
     */
    'mpiLauncherCreationPolicy'?: DistributedMpiLauncherCreationPolicyRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'minReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'maxReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {DistributedCleanPodPolicyRules}
     * @memberof SupersetRules
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicyRules | null;
    /**
     * 
     * @type {ServingPortRules}
     * @memberof SupersetRules
     */
    'servingPort'?: ServingPortRules | null;
    /**
     * 
     * @type {AutoScalingRules}
     * @memberof SupersetRules
     */
    'autoscaling'?: AutoScalingRules | null;
    /**
     * 
     * @type {SecurityFlatFieldsRules}
     * @memberof SupersetRules
     */
    'security'?: SecurityFlatFieldsRules | null;
    /**
     * 
     * @type {ComputeFieldsRules}
     * @memberof SupersetRules
     */
    'compute'?: ComputeFieldsRules | null;
    /**
     * 
     * @type {StorageFieldsRules}
     * @memberof SupersetRules
     */
    'storage'?: StorageFieldsRules | null;
}
/**
 * 
 * @export
 * @interface SyncStatusUpdate
 */
export interface SyncStatusUpdate {
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof SyncStatusUpdate
     */
    'clusterId'?: string;
    /**
     * 
     * @type {ScopeType}
     * @memberof SyncStatusUpdate
     */
    'scopeType'?: ScopeType;
    /**
     * cluster, department or project id, depending on the scope type
     * @type {string}
     * @memberof SyncStatusUpdate
     */
    'scopeId'?: string | null;
    /**
     * number which uniquely identifies the update. For deletion, the updateCounter holds the update count of the recent applied policy, rather than of the deletion.
     * @type {number}
     * @memberof SyncStatusUpdate
     */
    'updateCounter'?: number;
    /**
     * The action that the agent performed
     * @type {string}
     * @memberof SyncStatusUpdate
     */
    'action'?: SyncStatusUpdateActionEnum;
    /**
     * optional error indicating the update has failed.
     * @type {string}
     * @memberof SyncStatusUpdate
     */
    'errorMessage'?: string | null;
}

export const SyncStatusUpdateActionEnum = {
    Apply: 'apply',
    Delete: 'delete'
} as const;

export type SyncStatusUpdateActionEnum = typeof SyncStatusUpdateActionEnum[keyof typeof SyncStatusUpdateActionEnum];

/**
 * Toleration details.
 * @export
 * @interface Toleration
 */
export interface Toleration {
    /**
     * The name of the toleration.
     * @type {string}
     * @memberof Toleration
     */
    'name'?: string | null;
    /**
     * 
     * @type {TolerationOperator}
     * @memberof Toleration
     */
    'operator'?: TolerationOperator | null;
    /**
     * The taint key that the toleration applies to. (mandatory)
     * @type {string}
     * @memberof Toleration
     */
    'key'?: string | null;
    /**
     * The taint value the toleration matches to. Mandatory if operator is Exists, forbidden otherwise.
     * @type {string}
     * @memberof Toleration
     */
    'value'?: string | null;
    /**
     * 
     * @type {TolerationEffect}
     * @memberof Toleration
     */
    'effect'?: TolerationEffect | null;
    /**
     * The period of time the toleration tolerates the taint. Valid only if effect is NoExecute. taint.
     * @type {number}
     * @memberof Toleration
     */
    'seconds'?: number | null;
    /**
     * Use \'true\' in case the label is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof Toleration
     */
    'exclude'?: boolean | null;
}
/**
 * The taint effect to match. (mandatory)
 * @export
 * @enum {string}
 */

export const TolerationEffect = {
    NoSchedule: 'NoSchedule',
    NoExecute: 'NoExecute',
    PreferNoSchedule: 'PreferNoSchedule',
    Any: 'Any'
} as const;

export type TolerationEffect = typeof TolerationEffect[keyof typeof TolerationEffect];


/**
 * 
 * @export
 * @interface TolerationEffectOptions
 */
export interface TolerationEffectOptions {
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<TolerationEffectOptionsOptionsInner>}
     * @memberof TolerationEffectOptions
     */
    'options'?: Array<TolerationEffectOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface TolerationEffectOptionsOptionsInner
 */
export interface TolerationEffectOptionsOptionsInner {
    /**
     * 
     * @type {TolerationEffect}
     * @memberof TolerationEffectOptionsOptionsInner
     */
    'value': TolerationEffect | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof TolerationEffectOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface TolerationEffectRules
 */
export interface TolerationEffectRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof TolerationEffectRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof TolerationEffectRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof TolerationEffectRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<TolerationEffectOptionsOptionsInner>}
     * @memberof TolerationEffectRules
     */
    'options'?: Array<TolerationEffectOptionsOptionsInner> | null;
}
/**
 * A key\'s relationship to the value. Equal uses key and value. Exists is equivalent to wildcard for value, so that a workload can tolerate all taints of a particular category. (mandatory)
 * @export
 * @enum {string}
 */

export const TolerationOperator = {
    Equal: 'Equal',
    Exists: 'Exists'
} as const;

export type TolerationOperator = typeof TolerationOperator[keyof typeof TolerationOperator];


/**
 * 
 * @export
 * @interface TolerationOperatorOptions
 */
export interface TolerationOperatorOptions {
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<TolerationOperatorOptionsOptionsInner>}
     * @memberof TolerationOperatorOptions
     */
    'options'?: Array<TolerationOperatorOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface TolerationOperatorOptionsOptionsInner
 */
export interface TolerationOperatorOptionsOptionsInner {
    /**
     * 
     * @type {TolerationOperator}
     * @memberof TolerationOperatorOptionsOptionsInner
     */
    'value': TolerationOperator | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof TolerationOperatorOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface TolerationOperatorRules
 */
export interface TolerationOperatorRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof TolerationOperatorRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof TolerationOperatorRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof TolerationOperatorRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<TolerationOperatorOptionsOptionsInner>}
     * @memberof TolerationOperatorRules
     */
    'options'?: Array<TolerationOperatorOptionsOptionsInner> | null;
}
/**
 * Toleration details.
 * @export
 * @interface TolerationRules
 */
export interface TolerationRules {
    /**
     * 
     * @type {TolerationOperatorRules}
     * @memberof TolerationRules
     */
    'operator'?: TolerationOperatorRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof TolerationRules
     */
    'key'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof TolerationRules
     */
    'value'?: StringRules | null;
    /**
     * 
     * @type {TolerationEffectRules}
     * @memberof TolerationRules
     */
    'effect'?: TolerationEffectRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof TolerationRules
     */
    'seconds'?: IntegerRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof TolerationRules
     */
    'exclude'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface TolerationsDefaults
 */
export interface TolerationsDefaults {
    /**
     * 
     * @type {Toleration}
     * @memberof TolerationsDefaults
     */
    'attributes'?: Toleration | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof TolerationsDefaults
     */
    'instances'?: Array<Toleration> | null;
}
/**
 * 
 * @export
 * @interface TolerationsFieldDefaults
 */
export interface TolerationsFieldDefaults {
    /**
     * 
     * @type {TolerationsDefaults}
     * @memberof TolerationsFieldDefaults
     */
    'tolerations'?: TolerationsDefaults | null;
}
/**
 * 
 * @export
 * @interface TolerationsFieldRules
 */
export interface TolerationsFieldRules {
    /**
     * 
     * @type {TolerationsRules}
     * @memberof TolerationsFieldRules
     */
    'tolerations'?: TolerationsRules | null;
}
/**
 * 
 * @export
 * @interface TolerationsRules
 */
export interface TolerationsRules {
    /**
     * 
     * @type {TolerationRules}
     * @memberof TolerationsRules
     */
    'attributes'?: TolerationRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof TolerationsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface TrainingFields
 */
export interface TrainingFields {
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof TrainingFields
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof TrainingFields
     */
    'parallelism'?: number | null;
}
/**
 * 
 * @export
 * @interface TrainingFieldsRules
 */
export interface TrainingFieldsRules {
    /**
     * 
     * @type {IntegerRules}
     * @memberof TrainingFieldsRules
     */
    'completions'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof TrainingFieldsRules
     */
    'parallelism'?: IntegerRules | null;
}
/**
 * 
 * @export
 * @interface TrainingPolicyChangeRequestV2
 */
export interface TrainingPolicyChangeRequestV2 {
    /**
     * 
     * @type {PolicyCreationFields}
     * @memberof TrainingPolicyChangeRequestV2
     */
    'meta'?: PolicyCreationFields;
    /**
     * 
     * @type {TrainingPolicyDefaultsAndRulesV2}
     * @memberof TrainingPolicyChangeRequestV2
     */
    'policy'?: TrainingPolicyDefaultsAndRulesV2 | null;
    /**
     * set of fields in jsonpath format that is requested to clear their policy (default and rules)
     * @type {Array<string>}
     * @memberof TrainingPolicyChangeRequestV2
     */
    'reset'?: Array<string>;
}
/**
 * 
 * @export
 * @interface TrainingPolicyDefaultsAndRulesV2
 */
export interface TrainingPolicyDefaultsAndRulesV2 {
    /**
     * 
     * @type {TrainingPolicyDefaultsAndRulesV2Defaults}
     * @memberof TrainingPolicyDefaultsAndRulesV2
     */
    'defaults'?: TrainingPolicyDefaultsAndRulesV2Defaults | null;
    /**
     * 
     * @type {TrainingPolicyDefaultsAndRulesV2Rules}
     * @memberof TrainingPolicyDefaultsAndRulesV2
     */
    'rules'?: TrainingPolicyDefaultsAndRulesV2Rules | null;
    /**
     * a list of datasource assets to import into the policy. these datasources will be included in any workload that will be created in the scope of the policy.
     * @type {Array<string>}
     * @memberof TrainingPolicyDefaultsAndRulesV2
     */
    'imposedAssets'?: Array<string> | null;
    /**
     * 
     * @type {PolicyValidationStatus}
     * @memberof TrainingPolicyDefaultsAndRulesV2
     */
    'status'?: PolicyValidationStatus | null;
    /**
     * 
     * @type {DefaultFromOrder}
     * @memberof TrainingPolicyDefaultsAndRulesV2
     */
    'defaultFromOrder'?: DefaultFromOrder | null;
}
/**
 * 
 * @export
 * @interface TrainingPolicyDefaultsAndRulesV2Defaults
 */
export interface TrainingPolicyDefaultsAndRulesV2Defaults {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * 
     * @type {EnvironmentVariablesDefaults}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'environmentVariables'?: EnvironmentVariablesDefaults | null;
    /**
     * 
     * @type {AnnotationsDefaults}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'annotations'?: AnnotationsDefaults | null;
    /**
     * 
     * @type {LabelsDefaults}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'labels'?: LabelsDefaults | null;
    /**
     * 
     * @type {TolerationsDefaults}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'tolerations'?: TolerationsDefaults | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * 
     * @type {PortsDefaults}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'ports'?: PortsDefaults | null;
    /**
     * 
     * @type {ExposedUrlsDefaults}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'exposedUrls'?: ExposedUrlsDefaults | null;
    /**
     * 
     * @type {RelatedUrlsDefaults}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'relatedUrls'?: RelatedUrlsDefaults | null;
    /**
     * 
     * @type {PriorityClass}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'priorityClass'?: PriorityClass | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'parallelism'?: number | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'security'?: SecurityFlatFields | null;
    /**
     * 
     * @type {ComputeFieldsDefaults}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'compute'?: ComputeFieldsDefaults | null;
    /**
     * 
     * @type {StorageFieldsDefaults}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'storage'?: StorageFieldsDefaults | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof TrainingPolicyDefaultsAndRulesV2Defaults
     */
    'stdin'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TrainingPolicyDefaultsAndRulesV2Rules
 */
export interface TrainingPolicyDefaultsAndRulesV2Rules {
    /**
     * 
     * @type {StringRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'probes'?: ProbesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'podAffinity'?: PodAffinityRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'tolerations'?: TolerationsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'terminateAfterPreemption'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'autoDeletionTimeAfterCompletionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'terminationGracePeriodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'backoffLimit'?: IntegerRules | null;
    /**
     * 
     * @type {RestartPolicyRule}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'restartPolicy'?: RestartPolicyRule | null;
    /**
     * 
     * @type {PortsRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'ports'?: PortsRules | null;
    /**
     * 
     * @type {ExposedUrlsRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'exposedUrls'?: ExposedUrlsRules | null;
    /**
     * 
     * @type {RelatedUrlsRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'relatedUrls'?: RelatedUrlsRules | null;
    /**
     * 
     * @type {PriorityClassRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'priorityClass'?: PriorityClassRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'completions'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'parallelism'?: IntegerRules | null;
    /**
     * 
     * @type {SecurityFlatFieldsRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'security'?: SecurityFlatFieldsRules | null;
    /**
     * 
     * @type {ComputeFieldsRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'compute'?: ComputeFieldsRules | null;
    /**
     * 
     * @type {StorageFieldsRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'storage'?: StorageFieldsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'tty'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof TrainingPolicyDefaultsAndRulesV2Rules
     */
    'stdin'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface TrainingPolicyOverwriteRequestV2
 */
export interface TrainingPolicyOverwriteRequestV2 {
    /**
     * 
     * @type {PolicyCreationFields}
     * @memberof TrainingPolicyOverwriteRequestV2
     */
    'meta'?: PolicyCreationFields;
    /**
     * 
     * @type {TrainingPolicyDefaultsAndRulesV2}
     * @memberof TrainingPolicyOverwriteRequestV2
     */
    'policy'?: TrainingPolicyDefaultsAndRulesV2 | null;
}
/**
 * 
 * @export
 * @interface TrainingPolicyRulesV2
 */
export interface TrainingPolicyRulesV2 {
    /**
     * 
     * @type {StringRules}
     * @memberof TrainingPolicyRulesV2
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof TrainingPolicyRulesV2
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof TrainingPolicyRulesV2
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof TrainingPolicyRulesV2
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof TrainingPolicyRulesV2
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof TrainingPolicyRulesV2
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof TrainingPolicyRulesV2
     */
    'probes'?: ProbesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof TrainingPolicyRulesV2
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof TrainingPolicyRulesV2
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof TrainingPolicyRulesV2
     */
    'podAffinity'?: PodAffinityRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof TrainingPolicyRulesV2
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof TrainingPolicyRulesV2
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof TrainingPolicyRulesV2
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof TrainingPolicyRulesV2
     */
    'tolerations'?: TolerationsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof TrainingPolicyRulesV2
     */
    'terminateAfterPreemption'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof TrainingPolicyRulesV2
     */
    'autoDeletionTimeAfterCompletionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof TrainingPolicyRulesV2
     */
    'terminationGracePeriodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof TrainingPolicyRulesV2
     */
    'backoffLimit'?: IntegerRules | null;
    /**
     * 
     * @type {RestartPolicyRule}
     * @memberof TrainingPolicyRulesV2
     */
    'restartPolicy'?: RestartPolicyRule | null;
    /**
     * 
     * @type {PortsRules}
     * @memberof TrainingPolicyRulesV2
     */
    'ports'?: PortsRules | null;
    /**
     * 
     * @type {ExposedUrlsRules}
     * @memberof TrainingPolicyRulesV2
     */
    'exposedUrls'?: ExposedUrlsRules | null;
    /**
     * 
     * @type {RelatedUrlsRules}
     * @memberof TrainingPolicyRulesV2
     */
    'relatedUrls'?: RelatedUrlsRules | null;
    /**
     * 
     * @type {PriorityClassRules}
     * @memberof TrainingPolicyRulesV2
     */
    'priorityClass'?: PriorityClassRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof TrainingPolicyRulesV2
     */
    'completions'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof TrainingPolicyRulesV2
     */
    'parallelism'?: IntegerRules | null;
    /**
     * 
     * @type {SecurityFlatFieldsRules}
     * @memberof TrainingPolicyRulesV2
     */
    'security'?: SecurityFlatFieldsRules | null;
    /**
     * 
     * @type {ComputeFieldsRules}
     * @memberof TrainingPolicyRulesV2
     */
    'compute'?: ComputeFieldsRules | null;
    /**
     * 
     * @type {StorageFieldsRules}
     * @memberof TrainingPolicyRulesV2
     */
    'storage'?: StorageFieldsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof TrainingPolicyRulesV2
     */
    'tty'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof TrainingPolicyRulesV2
     */
    'stdin'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface TrainingPolicyV2
 */
export interface TrainingPolicyV2 {
    /**
     * 
     * @type {PolicyMeta}
     * @memberof TrainingPolicyV2
     */
    'meta'?: PolicyMeta;
    /**
     * 
     * @type {TrainingPolicyDefaultsAndRulesV2}
     * @memberof TrainingPolicyV2
     */
    'policy'?: TrainingPolicyDefaultsAndRulesV2 | null;
    /**
     * 
     * @type {TrainingPolicyDefaultsAndRulesV2}
     * @memberof TrainingPolicyV2
     */
    'effective'?: TrainingPolicyDefaultsAndRulesV2 | null;
    /**
     * The time at which an event occurred. e.g. the time an effective policy has been updated
     * @type {string}
     * @memberof TrainingPolicyV2
     */
    'effectiveUpdatedAt'?: string;
}
/**
 * Indicate the way to determine the user and group ids of the container. The options are a. `fromTheImage` - user and group ids are determined by the docker image that the container runs. this is the default option. b. `custom` - user and group ids can be specified in the environment asset and/or the workspace creation request. c. `idpToken` - user and group ids are determined according to the identity provider (idp) access token. This option is intended for internal use of the environment UI form. For more information, see [User Identity](https://docs.run.ai/latest/admin/runai-setup/config/non-root-containers/).
 * @export
 * @enum {string}
 */

export const UidGidSource = {
    FromTheImage: 'fromTheImage',
    FromIdpToken: 'fromIdpToken',
    Custom: 'custom'
} as const;

export type UidGidSource = typeof UidGidSource[keyof typeof UidGidSource];


/**
 * 
 * @export
 * @interface UidGidSourceOptions
 */
export interface UidGidSourceOptions {
    /**
     * Limit the permitted values for uidGidSource to a given set of values.
     * @type {Array<UidGidSourceOptionsOptionsInner>}
     * @memberof UidGidSourceOptions
     */
    'options'?: Array<UidGidSourceOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface UidGidSourceOptionsOptionsInner
 */
export interface UidGidSourceOptionsOptionsInner {
    /**
     * 
     * @type {UidGidSource}
     * @memberof UidGidSourceOptionsOptionsInner
     */
    'value': UidGidSource | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof UidGidSourceOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface UidGidSourceRules
 */
export interface UidGidSourceRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof UidGidSourceRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof UidGidSourceRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof UidGidSourceRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for uidGidSource to a given set of values.
     * @type {Array<UidGidSourceOptionsOptionsInner>}
     * @memberof UidGidSourceRules
     */
    'options'?: Array<UidGidSourceOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface WorkspacePolicyChangeRequestV2
 */
export interface WorkspacePolicyChangeRequestV2 {
    /**
     * 
     * @type {PolicyCreationFields}
     * @memberof WorkspacePolicyChangeRequestV2
     */
    'meta'?: PolicyCreationFields;
    /**
     * 
     * @type {WorkspacePolicyDefaultsAndRulesV2}
     * @memberof WorkspacePolicyChangeRequestV2
     */
    'policy'?: WorkspacePolicyDefaultsAndRulesV2 | null;
    /**
     * set of fields in jsonpath format that is requested to clear their policy (default and rules)
     * @type {Array<string>}
     * @memberof WorkspacePolicyChangeRequestV2
     */
    'reset'?: Array<string>;
}
/**
 * 
 * @export
 * @interface WorkspacePolicyDefaultsAndRulesV2
 */
export interface WorkspacePolicyDefaultsAndRulesV2 {
    /**
     * 
     * @type {WorkspacePolicyDefaultsAndRulesV2Defaults}
     * @memberof WorkspacePolicyDefaultsAndRulesV2
     */
    'defaults'?: WorkspacePolicyDefaultsAndRulesV2Defaults | null;
    /**
     * 
     * @type {WorkspacePolicyDefaultsAndRulesV2Rules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2
     */
    'rules'?: WorkspacePolicyDefaultsAndRulesV2Rules | null;
    /**
     * a list of datasource assets to import into the policy. these datasources will be included in any workload that will be created in the scope of the policy.
     * @type {Array<string>}
     * @memberof WorkspacePolicyDefaultsAndRulesV2
     */
    'imposedAssets'?: Array<string> | null;
    /**
     * 
     * @type {PolicyValidationStatus}
     * @memberof WorkspacePolicyDefaultsAndRulesV2
     */
    'status'?: PolicyValidationStatus | null;
    /**
     * 
     * @type {DefaultFromOrder}
     * @memberof WorkspacePolicyDefaultsAndRulesV2
     */
    'defaultFromOrder'?: DefaultFromOrder | null;
}
/**
 * 
 * @export
 * @interface WorkspacePolicyDefaultsAndRulesV2Defaults
 */
export interface WorkspacePolicyDefaultsAndRulesV2Defaults {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * 
     * @type {EnvironmentVariablesDefaults}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'environmentVariables'?: EnvironmentVariablesDefaults | null;
    /**
     * 
     * @type {AnnotationsDefaults}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'annotations'?: AnnotationsDefaults | null;
    /**
     * 
     * @type {LabelsDefaults}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'labels'?: LabelsDefaults | null;
    /**
     * 
     * @type {TolerationsDefaults}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'tolerations'?: TolerationsDefaults | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * 
     * @type {PortsDefaults}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'ports'?: PortsDefaults | null;
    /**
     * 
     * @type {ExposedUrlsDefaults}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'exposedUrls'?: ExposedUrlsDefaults | null;
    /**
     * 
     * @type {RelatedUrlsDefaults}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'relatedUrls'?: RelatedUrlsDefaults | null;
    /**
     * 
     * @type {PriorityClass}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'priorityClass'?: PriorityClass | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'security'?: SecurityFlatFields | null;
    /**
     * 
     * @type {ComputeFieldsDefaults}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'compute'?: ComputeFieldsDefaults | null;
    /**
     * 
     * @type {StorageFieldsDefaults}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'storage'?: StorageFieldsDefaults | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Defaults
     */
    'stdin'?: boolean | null;
}
/**
 * 
 * @export
 * @interface WorkspacePolicyDefaultsAndRulesV2Rules
 */
export interface WorkspacePolicyDefaultsAndRulesV2Rules {
    /**
     * 
     * @type {StringRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'probes'?: ProbesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'podAffinity'?: PodAffinityRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'tolerations'?: TolerationsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'terminateAfterPreemption'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'autoDeletionTimeAfterCompletionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'terminationGracePeriodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'backoffLimit'?: IntegerRules | null;
    /**
     * 
     * @type {RestartPolicyRule}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'restartPolicy'?: RestartPolicyRule | null;
    /**
     * 
     * @type {PortsRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'ports'?: PortsRules | null;
    /**
     * 
     * @type {ExposedUrlsRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'exposedUrls'?: ExposedUrlsRules | null;
    /**
     * 
     * @type {RelatedUrlsRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'relatedUrls'?: RelatedUrlsRules | null;
    /**
     * 
     * @type {PriorityClassRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'priorityClass'?: PriorityClassRules | null;
    /**
     * 
     * @type {SecurityFlatFieldsRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'security'?: SecurityFlatFieldsRules | null;
    /**
     * 
     * @type {ComputeFieldsRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'compute'?: ComputeFieldsRules | null;
    /**
     * 
     * @type {StorageFieldsRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'storage'?: StorageFieldsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'tty'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof WorkspacePolicyDefaultsAndRulesV2Rules
     */
    'stdin'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface WorkspacePolicyOverwriteRequestV2
 */
export interface WorkspacePolicyOverwriteRequestV2 {
    /**
     * 
     * @type {PolicyCreationFields}
     * @memberof WorkspacePolicyOverwriteRequestV2
     */
    'meta'?: PolicyCreationFields;
    /**
     * 
     * @type {WorkspacePolicyDefaultsAndRulesV2}
     * @memberof WorkspacePolicyOverwriteRequestV2
     */
    'policy'?: WorkspacePolicyDefaultsAndRulesV2 | null;
}
/**
 * 
 * @export
 * @interface WorkspacePolicyRulesV2
 */
export interface WorkspacePolicyRulesV2 {
    /**
     * 
     * @type {StringRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'probes'?: ProbesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'podAffinity'?: PodAffinityRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'tolerations'?: TolerationsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'terminateAfterPreemption'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'autoDeletionTimeAfterCompletionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'terminationGracePeriodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'backoffLimit'?: IntegerRules | null;
    /**
     * 
     * @type {RestartPolicyRule}
     * @memberof WorkspacePolicyRulesV2
     */
    'restartPolicy'?: RestartPolicyRule | null;
    /**
     * 
     * @type {PortsRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'ports'?: PortsRules | null;
    /**
     * 
     * @type {ExposedUrlsRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'exposedUrls'?: ExposedUrlsRules | null;
    /**
     * 
     * @type {RelatedUrlsRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'relatedUrls'?: RelatedUrlsRules | null;
    /**
     * 
     * @type {PriorityClassRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'priorityClass'?: PriorityClassRules | null;
    /**
     * 
     * @type {SecurityFlatFieldsRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'security'?: SecurityFlatFieldsRules | null;
    /**
     * 
     * @type {ComputeFieldsRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'compute'?: ComputeFieldsRules | null;
    /**
     * 
     * @type {StorageFieldsRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'storage'?: StorageFieldsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'tty'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof WorkspacePolicyRulesV2
     */
    'stdin'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface WorkspacePolicyV2
 */
export interface WorkspacePolicyV2 {
    /**
     * 
     * @type {PolicyMeta}
     * @memberof WorkspacePolicyV2
     */
    'meta'?: PolicyMeta;
    /**
     * 
     * @type {WorkspacePolicyDefaultsAndRulesV2}
     * @memberof WorkspacePolicyV2
     */
    'policy'?: WorkspacePolicyDefaultsAndRulesV2 | null;
    /**
     * 
     * @type {WorkspacePolicyDefaultsAndRulesV2}
     * @memberof WorkspacePolicyV2
     */
    'effective'?: WorkspacePolicyDefaultsAndRulesV2 | null;
    /**
     * The time at which an event occurred. e.g. the time an effective policy has been updated
     * @type {string}
     * @memberof WorkspacePolicyV2
     */
    'effectiveUpdatedAt'?: string;
}

/**
 * PolicyApi - axios parameter creator
 * @export
 */
export const PolicyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Hook for asset service to report a change in spec of a given asset
         * @summary Asset changed hook for asset service
         * @param {string} assetId Unique identifier of the asset.
         * @param {AssetChangeNotification} [assetChangeNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetChangedHook: async (assetId: string, assetChangeNotification?: AssetChangeNotification, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('assetChangedHook', 'assetId', assetId)
            const localVarPath = `/internal/policy/asset/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetChangeNotification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete a distributed policy for a given organizational unit.
         * @summary Delete a distributed policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDistributedPolicy: async (scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scope' is not null or undefined
            assertParamExists('deleteDistributedPolicy', 'scope', scope)
            const localVarPath = `/api/v2/policy/distributed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
         * @summary Delete a fallback policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFallbackPolicy: async (scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scope' is not null or undefined
            assertParamExists('deleteFallbackPolicy', 'scope', scope)
            const localVarPath = `/api/v2/policy/fallback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete an inference policy for a given organizational unit.
         * @summary Delete an inference policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInferencePolicy: async (scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scope' is not null or undefined
            assertParamExists('deleteInferencePolicy', 'scope', scope)
            const localVarPath = `/api/v2/policy/inferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete a training policy for a given organizational unit.
         * @summary Delete a training policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrainingPolicy: async (scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scope' is not null or undefined
            assertParamExists('deleteTrainingPolicy', 'scope', scope)
            const localVarPath = `/api/v2/policy/trainings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete a workspace policy for a given organizational unit.
         * @summary Delete a workspace policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspacePolicy: async (scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scope' is not null or undefined
            assertParamExists('deleteWorkspacePolicy', 'scope', scope)
            const localVarPath = `/api/v2/policy/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of a distributed policy for a given organizational unit.
         * @summary Get a distributed policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributedPolicyV2: async (scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scope' is not null or undefined
            assertParamExists('getDistributedPolicyV2', 'scope', scope)
            const localVarPath = `/api/v2/policy/distributed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (noCreationMode !== undefined) {
                localVarQueryParameter['noCreationMode'] = noCreationMode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
         * @summary Get a fallback policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFallbackPolicy: async (scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scope' is not null or undefined
            assertParamExists('getFallbackPolicy', 'scope', scope)
            const localVarPath = `/api/v2/policy/fallback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (noCreationMode !== undefined) {
                localVarQueryParameter['noCreationMode'] = noCreationMode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of an inference policy for a given organizational unit.
         * @summary Get an inference policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferencePolicyV2: async (scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scope' is not null or undefined
            assertParamExists('getInferencePolicyV2', 'scope', scope)
            const localVarPath = `/api/v2/policy/inferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (noCreationMode !== undefined) {
                localVarQueryParameter['noCreationMode'] = noCreationMode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of an training policy for a given organizational unit.
         * @summary Get a training policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingPolicyV2: async (scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scope' is not null or undefined
            assertParamExists('getTrainingPolicyV2', 'scope', scope)
            const localVarPath = `/api/v2/policy/trainings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (noCreationMode !== undefined) {
                localVarQueryParameter['noCreationMode'] = noCreationMode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of a workspace policy for a given organizational unit.
         * @summary Get a workspace policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacePolicyV2: async (scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scope' is not null or undefined
            assertParamExists('getWorkspacePolicyV2', 'scope', scope)
            const localVarPath = `/api/v2/policy/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (noCreationMode !== undefined) {
                localVarQueryParameter['noCreationMode'] = noCreationMode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of all the applied policies.
         * @summary List policies
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [workloadType] Policy for a specific workload type.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] filter by this scope.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [includeFallbackPolicies] whether to include fallback policies in the list. Default to false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicies: async (workloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', scope?: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, includeFallbackPolicies?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (workloadType !== undefined) {
                localVarQueryParameter['workloadType'] = workloadType;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (includeFallbackPolicies !== undefined) {
                localVarQueryParameter['includeFallbackPolicies'] = includeFallbackPolicies;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to apply a distributed policy for a given organizational unit.
         * @summary Overwrite a distributed policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {DistributedPolicyOverwriteRequestV2} [distributedPolicyOverwriteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteDistributedPolicyV2: async (validateOnly?: boolean, distributedPolicyOverwriteRequestV2?: DistributedPolicyOverwriteRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/policy/distributed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (validateOnly !== undefined) {
                localVarQueryParameter['validateOnly'] = validateOnly;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(distributedPolicyOverwriteRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
         * @summary Overwrite a fallback policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {FallbackPolicyOverwriteRequest} [fallbackPolicyOverwriteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteFallbackPolicy: async (validateOnly?: boolean, fallbackPolicyOverwriteRequest?: FallbackPolicyOverwriteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/policy/fallback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (validateOnly !== undefined) {
                localVarQueryParameter['validateOnly'] = validateOnly;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fallbackPolicyOverwriteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to apply an inference policy for a given organizational unit.
         * @summary Overwrite an inference policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {InferencePolicyOverwriteRequestV2} [inferencePolicyOverwriteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteInferencePolicyV2: async (validateOnly?: boolean, inferencePolicyOverwriteRequestV2?: InferencePolicyOverwriteRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/policy/inferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (validateOnly !== undefined) {
                localVarQueryParameter['validateOnly'] = validateOnly;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inferencePolicyOverwriteRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to apply a training policy for a given organizational unit.
         * @summary Overwrite a training policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {TrainingPolicyOverwriteRequestV2} [trainingPolicyOverwriteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteTrainingPolicyV2: async (validateOnly?: boolean, trainingPolicyOverwriteRequestV2?: TrainingPolicyOverwriteRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/policy/trainings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (validateOnly !== undefined) {
                localVarQueryParameter['validateOnly'] = validateOnly;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trainingPolicyOverwriteRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ue to apply a workspace policy for a given organizational unit.
         * @summary Overwrite a workspace policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {WorkspacePolicyOverwriteRequestV2} [workspacePolicyOverwriteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteWorkspacePolicyV2: async (validateOnly?: boolean, workspacePolicyOverwriteRequestV2?: WorkspacePolicyOverwriteRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/policy/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (validateOnly !== undefined) {
                localVarQueryParameter['validateOnly'] = validateOnly;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workspacePolicyOverwriteRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to apply changes to distributed policy for a given organizational unit.
         * @summary Update a distributed policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {DistributedPolicyChangeRequestV2} [distributedPolicyChangeRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDistributedPolicyV2: async (validateOnly?: boolean, distributedPolicyChangeRequestV2?: DistributedPolicyChangeRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/policy/distributed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (validateOnly !== undefined) {
                localVarQueryParameter['validateOnly'] = validateOnly;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(distributedPolicyChangeRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
         * @summary Update workloads fallback policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {FallbackPolicyChangeRequest} [fallbackPolicyChangeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFallbackPolicy: async (validateOnly?: boolean, fallbackPolicyChangeRequest?: FallbackPolicyChangeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/policy/fallback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (validateOnly !== undefined) {
                localVarQueryParameter['validateOnly'] = validateOnly;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fallbackPolicyChangeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to apply changes to inference policy for a given organizational unit.
         * @summary Update an inference policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {InferencePolicyChangeRequestV2} [inferencePolicyChangeRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInferencePolicyV2: async (validateOnly?: boolean, inferencePolicyChangeRequestV2?: InferencePolicyChangeRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/policy/inferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (validateOnly !== undefined) {
                localVarQueryParameter['validateOnly'] = validateOnly;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inferencePolicyChangeRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to apply changes to training policy for a given organizational unit.
         * @summary Update a training policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {TrainingPolicyChangeRequestV2} [trainingPolicyChangeRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrainingPolicyV2: async (validateOnly?: boolean, trainingPolicyChangeRequestV2?: TrainingPolicyChangeRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/policy/trainings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (validateOnly !== undefined) {
                localVarQueryParameter['validateOnly'] = validateOnly;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trainingPolicyChangeRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to apply changes to workspace policy for a given organizational unit.
         * @summary Update a workspace policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {WorkspacePolicyChangeRequestV2} [workspacePolicyChangeRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkspacePolicyV2: async (validateOnly?: boolean, workspacePolicyChangeRequestV2?: WorkspacePolicyChangeRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/policy/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (validateOnly !== undefined) {
                localVarQueryParameter['validateOnly'] = validateOnly;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workspacePolicyChangeRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PolicyApi - functional programming interface
 * @export
 */
export const PolicyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PolicyApiAxiosParamCreator(configuration)
    return {
        /**
         * Hook for asset service to report a change in spec of a given asset
         * @summary Asset changed hook for asset service
         * @param {string} assetId Unique identifier of the asset.
         * @param {AssetChangeNotification} [assetChangeNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetChangedHook(assetId: string, assetChangeNotification?: AssetChangeNotification, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetChangedHook(assetId, assetChangeNotification, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete a distributed policy for a given organizational unit.
         * @summary Delete a distributed policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDistributedPolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDistributedPolicy(scope, departmentId, projectId, clusterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
         * @summary Delete a fallback policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFallbackPolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFallbackPolicy(scope, departmentId, projectId, clusterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete an inference policy for a given organizational unit.
         * @summary Delete an inference policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInferencePolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInferencePolicy(scope, departmentId, projectId, clusterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete a training policy for a given organizational unit.
         * @summary Delete a training policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrainingPolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrainingPolicy(scope, departmentId, projectId, clusterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete a workspace policy for a given organizational unit.
         * @summary Delete a workspace policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkspacePolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkspacePolicy(scope, departmentId, projectId, clusterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of a distributed policy for a given organizational unit.
         * @summary Get a distributed policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDistributedPolicyV2(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistributedPolicyV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDistributedPolicyV2(scope, departmentId, projectId, clusterId, noCreationMode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
         * @summary Get a fallback policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFallbackPolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FallbackPolicy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFallbackPolicy(scope, departmentId, projectId, clusterId, noCreationMode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of an inference policy for a given organizational unit.
         * @summary Get an inference policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInferencePolicyV2(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InferencePolicyV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInferencePolicyV2(scope, departmentId, projectId, clusterId, noCreationMode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of an training policy for a given organizational unit.
         * @summary Get a training policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrainingPolicyV2(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingPolicyV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrainingPolicyV2(scope, departmentId, projectId, clusterId, noCreationMode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of a workspace policy for a given organizational unit.
         * @summary Get a workspace policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspacePolicyV2(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspacePolicyV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspacePolicyV2(scope, departmentId, projectId, clusterId, noCreationMode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of all the applied policies.
         * @summary List policies
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [workloadType] Policy for a specific workload type.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] filter by this scope.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [includeFallbackPolicies] whether to include fallback policies in the list. Default to false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPolicies(workloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', scope?: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, includeFallbackPolicies?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPolicies(workloadType, scope, departmentId, projectId, clusterId, includeFallbackPolicies, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to apply a distributed policy for a given organizational unit.
         * @summary Overwrite a distributed policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {DistributedPolicyOverwriteRequestV2} [distributedPolicyOverwriteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overwriteDistributedPolicyV2(validateOnly?: boolean, distributedPolicyOverwriteRequestV2?: DistributedPolicyOverwriteRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistributedPolicyV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overwriteDistributedPolicyV2(validateOnly, distributedPolicyOverwriteRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
         * @summary Overwrite a fallback policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {FallbackPolicyOverwriteRequest} [fallbackPolicyOverwriteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overwriteFallbackPolicy(validateOnly?: boolean, fallbackPolicyOverwriteRequest?: FallbackPolicyOverwriteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FallbackPolicy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overwriteFallbackPolicy(validateOnly, fallbackPolicyOverwriteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to apply an inference policy for a given organizational unit.
         * @summary Overwrite an inference policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {InferencePolicyOverwriteRequestV2} [inferencePolicyOverwriteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overwriteInferencePolicyV2(validateOnly?: boolean, inferencePolicyOverwriteRequestV2?: InferencePolicyOverwriteRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InferencePolicyV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overwriteInferencePolicyV2(validateOnly, inferencePolicyOverwriteRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to apply a training policy for a given organizational unit.
         * @summary Overwrite a training policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {TrainingPolicyOverwriteRequestV2} [trainingPolicyOverwriteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overwriteTrainingPolicyV2(validateOnly?: boolean, trainingPolicyOverwriteRequestV2?: TrainingPolicyOverwriteRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingPolicyV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overwriteTrainingPolicyV2(validateOnly, trainingPolicyOverwriteRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Ue to apply a workspace policy for a given organizational unit.
         * @summary Overwrite a workspace policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {WorkspacePolicyOverwriteRequestV2} [workspacePolicyOverwriteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overwriteWorkspacePolicyV2(validateOnly?: boolean, workspacePolicyOverwriteRequestV2?: WorkspacePolicyOverwriteRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspacePolicyV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overwriteWorkspacePolicyV2(validateOnly, workspacePolicyOverwriteRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to apply changes to distributed policy for a given organizational unit.
         * @summary Update a distributed policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {DistributedPolicyChangeRequestV2} [distributedPolicyChangeRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDistributedPolicyV2(validateOnly?: boolean, distributedPolicyChangeRequestV2?: DistributedPolicyChangeRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistributedPolicyV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDistributedPolicyV2(validateOnly, distributedPolicyChangeRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
         * @summary Update workloads fallback policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {FallbackPolicyChangeRequest} [fallbackPolicyChangeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFallbackPolicy(validateOnly?: boolean, fallbackPolicyChangeRequest?: FallbackPolicyChangeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FallbackPolicy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFallbackPolicy(validateOnly, fallbackPolicyChangeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to apply changes to inference policy for a given organizational unit.
         * @summary Update an inference policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {InferencePolicyChangeRequestV2} [inferencePolicyChangeRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInferencePolicyV2(validateOnly?: boolean, inferencePolicyChangeRequestV2?: InferencePolicyChangeRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InferencePolicyV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInferencePolicyV2(validateOnly, inferencePolicyChangeRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to apply changes to training policy for a given organizational unit.
         * @summary Update a training policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {TrainingPolicyChangeRequestV2} [trainingPolicyChangeRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrainingPolicyV2(validateOnly?: boolean, trainingPolicyChangeRequestV2?: TrainingPolicyChangeRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingPolicyV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrainingPolicyV2(validateOnly, trainingPolicyChangeRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to apply changes to workspace policy for a given organizational unit.
         * @summary Update a workspace policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {WorkspacePolicyChangeRequestV2} [workspacePolicyChangeRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkspacePolicyV2(validateOnly?: boolean, workspacePolicyChangeRequestV2?: WorkspacePolicyChangeRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspacePolicyV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkspacePolicyV2(validateOnly, workspacePolicyChangeRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PolicyApi - factory interface
 * @export
 */
export const PolicyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PolicyApiFp(configuration)
    return {
        /**
         * Hook for asset service to report a change in spec of a given asset
         * @summary Asset changed hook for asset service
         * @param {string} assetId Unique identifier of the asset.
         * @param {AssetChangeNotification} [assetChangeNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetChangedHook(assetId: string, assetChangeNotification?: AssetChangeNotification, options?: any): AxiosPromise<void> {
            return localVarFp.assetChangedHook(assetId, assetChangeNotification, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete a distributed policy for a given organizational unit.
         * @summary Delete a distributed policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDistributedPolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDistributedPolicy(scope, departmentId, projectId, clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
         * @summary Delete a fallback policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFallbackPolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteFallbackPolicy(scope, departmentId, projectId, clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete an inference policy for a given organizational unit.
         * @summary Delete an inference policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInferencePolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteInferencePolicy(scope, departmentId, projectId, clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete a training policy for a given organizational unit.
         * @summary Delete a training policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrainingPolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTrainingPolicy(scope, departmentId, projectId, clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete a workspace policy for a given organizational unit.
         * @summary Delete a workspace policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspacePolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWorkspacePolicy(scope, departmentId, projectId, clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of a distributed policy for a given organizational unit.
         * @summary Get a distributed policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributedPolicyV2(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options?: any): AxiosPromise<DistributedPolicyV2> {
            return localVarFp.getDistributedPolicyV2(scope, departmentId, projectId, clusterId, noCreationMode, options).then((request) => request(axios, basePath));
        },
        /**
         * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
         * @summary Get a fallback policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFallbackPolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options?: any): AxiosPromise<FallbackPolicy> {
            return localVarFp.getFallbackPolicy(scope, departmentId, projectId, clusterId, noCreationMode, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of an inference policy for a given organizational unit.
         * @summary Get an inference policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferencePolicyV2(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options?: any): AxiosPromise<InferencePolicyV2> {
            return localVarFp.getInferencePolicyV2(scope, departmentId, projectId, clusterId, noCreationMode, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of an training policy for a given organizational unit.
         * @summary Get a training policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingPolicyV2(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options?: any): AxiosPromise<TrainingPolicyV2> {
            return localVarFp.getTrainingPolicyV2(scope, departmentId, projectId, clusterId, noCreationMode, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of a workspace policy for a given organizational unit.
         * @summary Get a workspace policy.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspacePolicyV2(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options?: any): AxiosPromise<WorkspacePolicyV2> {
            return localVarFp.getWorkspacePolicyV2(scope, departmentId, projectId, clusterId, noCreationMode, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of all the applied policies.
         * @summary List policies
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [workloadType] Policy for a specific workload type.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] filter by this scope.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [projectId] project id to filter by
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [includeFallbackPolicies] whether to include fallback policies in the list. Default to false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicies(workloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', scope?: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, includeFallbackPolicies?: boolean, options?: any): AxiosPromise<PolicyListResponse> {
            return localVarFp.listPolicies(workloadType, scope, departmentId, projectId, clusterId, includeFallbackPolicies, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to apply a distributed policy for a given organizational unit.
         * @summary Overwrite a distributed policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {DistributedPolicyOverwriteRequestV2} [distributedPolicyOverwriteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteDistributedPolicyV2(validateOnly?: boolean, distributedPolicyOverwriteRequestV2?: DistributedPolicyOverwriteRequestV2, options?: any): AxiosPromise<DistributedPolicyV2> {
            return localVarFp.overwriteDistributedPolicyV2(validateOnly, distributedPolicyOverwriteRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
         * @summary Overwrite a fallback policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {FallbackPolicyOverwriteRequest} [fallbackPolicyOverwriteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteFallbackPolicy(validateOnly?: boolean, fallbackPolicyOverwriteRequest?: FallbackPolicyOverwriteRequest, options?: any): AxiosPromise<FallbackPolicy> {
            return localVarFp.overwriteFallbackPolicy(validateOnly, fallbackPolicyOverwriteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to apply an inference policy for a given organizational unit.
         * @summary Overwrite an inference policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {InferencePolicyOverwriteRequestV2} [inferencePolicyOverwriteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteInferencePolicyV2(validateOnly?: boolean, inferencePolicyOverwriteRequestV2?: InferencePolicyOverwriteRequestV2, options?: any): AxiosPromise<InferencePolicyV2> {
            return localVarFp.overwriteInferencePolicyV2(validateOnly, inferencePolicyOverwriteRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to apply a training policy for a given organizational unit.
         * @summary Overwrite a training policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {TrainingPolicyOverwriteRequestV2} [trainingPolicyOverwriteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteTrainingPolicyV2(validateOnly?: boolean, trainingPolicyOverwriteRequestV2?: TrainingPolicyOverwriteRequestV2, options?: any): AxiosPromise<TrainingPolicyV2> {
            return localVarFp.overwriteTrainingPolicyV2(validateOnly, trainingPolicyOverwriteRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Ue to apply a workspace policy for a given organizational unit.
         * @summary Overwrite a workspace policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {WorkspacePolicyOverwriteRequestV2} [workspacePolicyOverwriteRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteWorkspacePolicyV2(validateOnly?: boolean, workspacePolicyOverwriteRequestV2?: WorkspacePolicyOverwriteRequestV2, options?: any): AxiosPromise<WorkspacePolicyV2> {
            return localVarFp.overwriteWorkspacePolicyV2(validateOnly, workspacePolicyOverwriteRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to apply changes to distributed policy for a given organizational unit.
         * @summary Update a distributed policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {DistributedPolicyChangeRequestV2} [distributedPolicyChangeRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDistributedPolicyV2(validateOnly?: boolean, distributedPolicyChangeRequestV2?: DistributedPolicyChangeRequestV2, options?: any): AxiosPromise<DistributedPolicyV2> {
            return localVarFp.updateDistributedPolicyV2(validateOnly, distributedPolicyChangeRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
         * @summary Update workloads fallback policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {FallbackPolicyChangeRequest} [fallbackPolicyChangeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFallbackPolicy(validateOnly?: boolean, fallbackPolicyChangeRequest?: FallbackPolicyChangeRequest, options?: any): AxiosPromise<FallbackPolicy> {
            return localVarFp.updateFallbackPolicy(validateOnly, fallbackPolicyChangeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to apply changes to inference policy for a given organizational unit.
         * @summary Update an inference policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {InferencePolicyChangeRequestV2} [inferencePolicyChangeRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInferencePolicyV2(validateOnly?: boolean, inferencePolicyChangeRequestV2?: InferencePolicyChangeRequestV2, options?: any): AxiosPromise<InferencePolicyV2> {
            return localVarFp.updateInferencePolicyV2(validateOnly, inferencePolicyChangeRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to apply changes to training policy for a given organizational unit.
         * @summary Update a training policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {TrainingPolicyChangeRequestV2} [trainingPolicyChangeRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrainingPolicyV2(validateOnly?: boolean, trainingPolicyChangeRequestV2?: TrainingPolicyChangeRequestV2, options?: any): AxiosPromise<TrainingPolicyV2> {
            return localVarFp.updateTrainingPolicyV2(validateOnly, trainingPolicyChangeRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to apply changes to workspace policy for a given organizational unit.
         * @summary Update a workspace policy.
         * @param {boolean} [validateOnly] Validate the given policy payload without applying it
         * @param {WorkspacePolicyChangeRequestV2} [workspacePolicyChangeRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkspacePolicyV2(validateOnly?: boolean, workspacePolicyChangeRequestV2?: WorkspacePolicyChangeRequestV2, options?: any): AxiosPromise<WorkspacePolicyV2> {
            return localVarFp.updateWorkspacePolicyV2(validateOnly, workspacePolicyChangeRequestV2, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PolicyApi - object-oriented interface
 * @export
 * @class PolicyApi
 * @extends {BaseAPI}
 */
export class PolicyApi extends BaseAPI {
    /**
     * Hook for asset service to report a change in spec of a given asset
     * @summary Asset changed hook for asset service
     * @param {string} assetId Unique identifier of the asset.
     * @param {AssetChangeNotification} [assetChangeNotification] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public assetChangedHook(assetId: string, assetChangeNotification?: AssetChangeNotification, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).assetChangedHook(assetId, assetChangeNotification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete a distributed policy for a given organizational unit.
     * @summary Delete a distributed policy.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [projectId] project id to filter by
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public deleteDistributedPolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).deleteDistributedPolicy(scope, departmentId, projectId, clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
     * @summary Delete a fallback policy.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [projectId] project id to filter by
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public deleteFallbackPolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).deleteFallbackPolicy(scope, departmentId, projectId, clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete an inference policy for a given organizational unit.
     * @summary Delete an inference policy.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [projectId] project id to filter by
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public deleteInferencePolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).deleteInferencePolicy(scope, departmentId, projectId, clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete a training policy for a given organizational unit.
     * @summary Delete a training policy.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [projectId] project id to filter by
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public deleteTrainingPolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).deleteTrainingPolicy(scope, departmentId, projectId, clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete a workspace policy for a given organizational unit.
     * @summary Delete a workspace policy.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [projectId] project id to filter by
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public deleteWorkspacePolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).deleteWorkspacePolicy(scope, departmentId, projectId, clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of a distributed policy for a given organizational unit.
     * @summary Get a distributed policy.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [projectId] project id to filter by
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public getDistributedPolicyV2(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).getDistributedPolicyV2(scope, departmentId, projectId, clusterId, noCreationMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
     * @summary Get a fallback policy.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [projectId] project id to filter by
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public getFallbackPolicy(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).getFallbackPolicy(scope, departmentId, projectId, clusterId, noCreationMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of an inference policy for a given organizational unit.
     * @summary Get an inference policy.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [projectId] project id to filter by
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public getInferencePolicyV2(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).getInferencePolicyV2(scope, departmentId, projectId, clusterId, noCreationMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of an training policy for a given organizational unit.
     * @summary Get a training policy.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [projectId] project id to filter by
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public getTrainingPolicyV2(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).getTrainingPolicyV2(scope, departmentId, projectId, clusterId, noCreationMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of a workspace policy for a given organizational unit.
     * @summary Get a workspace policy.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} scope The scope that the policy relates to.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [projectId] project id to filter by
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [noCreationMode] Indicates that the policy should be returned only if the tenant has at least one given policy, otherwise it should not be created and instead return error 404. This is done for the frontend which needs the policy info also for tenants that are not using policy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public getWorkspacePolicyV2(scope: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, noCreationMode?: boolean, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).getWorkspacePolicyV2(scope, departmentId, projectId, clusterId, noCreationMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of all the applied policies.
     * @summary List policies
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [workloadType] Policy for a specific workload type.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] filter by this scope.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [projectId] project id to filter by
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [includeFallbackPolicies] whether to include fallback policies in the list. Default to false.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public listPolicies(workloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', scope?: 'tenant' | 'cluster' | 'department' | 'project', departmentId?: string, projectId?: string, clusterId?: string, includeFallbackPolicies?: boolean, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).listPolicies(workloadType, scope, departmentId, projectId, clusterId, includeFallbackPolicies, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to apply a distributed policy for a given organizational unit.
     * @summary Overwrite a distributed policy.
     * @param {boolean} [validateOnly] Validate the given policy payload without applying it
     * @param {DistributedPolicyOverwriteRequestV2} [distributedPolicyOverwriteRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public overwriteDistributedPolicyV2(validateOnly?: boolean, distributedPolicyOverwriteRequestV2?: DistributedPolicyOverwriteRequestV2, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).overwriteDistributedPolicyV2(validateOnly, distributedPolicyOverwriteRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
     * @summary Overwrite a fallback policy.
     * @param {boolean} [validateOnly] Validate the given policy payload without applying it
     * @param {FallbackPolicyOverwriteRequest} [fallbackPolicyOverwriteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public overwriteFallbackPolicy(validateOnly?: boolean, fallbackPolicyOverwriteRequest?: FallbackPolicyOverwriteRequest, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).overwriteFallbackPolicy(validateOnly, fallbackPolicyOverwriteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to apply an inference policy for a given organizational unit.
     * @summary Overwrite an inference policy.
     * @param {boolean} [validateOnly] Validate the given policy payload without applying it
     * @param {InferencePolicyOverwriteRequestV2} [inferencePolicyOverwriteRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public overwriteInferencePolicyV2(validateOnly?: boolean, inferencePolicyOverwriteRequestV2?: InferencePolicyOverwriteRequestV2, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).overwriteInferencePolicyV2(validateOnly, inferencePolicyOverwriteRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to apply a training policy for a given organizational unit.
     * @summary Overwrite a training policy.
     * @param {boolean} [validateOnly] Validate the given policy payload without applying it
     * @param {TrainingPolicyOverwriteRequestV2} [trainingPolicyOverwriteRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public overwriteTrainingPolicyV2(validateOnly?: boolean, trainingPolicyOverwriteRequestV2?: TrainingPolicyOverwriteRequestV2, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).overwriteTrainingPolicyV2(validateOnly, trainingPolicyOverwriteRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ue to apply a workspace policy for a given organizational unit.
     * @summary Overwrite a workspace policy.
     * @param {boolean} [validateOnly] Validate the given policy payload without applying it
     * @param {WorkspacePolicyOverwriteRequestV2} [workspacePolicyOverwriteRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public overwriteWorkspacePolicyV2(validateOnly?: boolean, workspacePolicyOverwriteRequestV2?: WorkspacePolicyOverwriteRequestV2, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).overwriteWorkspacePolicyV2(validateOnly, workspacePolicyOverwriteRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to apply changes to distributed policy for a given organizational unit.
     * @summary Update a distributed policy.
     * @param {boolean} [validateOnly] Validate the given policy payload without applying it
     * @param {DistributedPolicyChangeRequestV2} [distributedPolicyChangeRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public updateDistributedPolicyV2(validateOnly?: boolean, distributedPolicyChangeRequestV2?: DistributedPolicyChangeRequestV2, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).updateDistributedPolicyV2(validateOnly, distributedPolicyChangeRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The rules and defaults of this policy serves as fallback for fields that do not have rules or defaults in the policy of the specific workload-type (workspace, training, etc)
     * @summary Update workloads fallback policy.
     * @param {boolean} [validateOnly] Validate the given policy payload without applying it
     * @param {FallbackPolicyChangeRequest} [fallbackPolicyChangeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public updateFallbackPolicy(validateOnly?: boolean, fallbackPolicyChangeRequest?: FallbackPolicyChangeRequest, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).updateFallbackPolicy(validateOnly, fallbackPolicyChangeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to apply changes to inference policy for a given organizational unit.
     * @summary Update an inference policy.
     * @param {boolean} [validateOnly] Validate the given policy payload without applying it
     * @param {InferencePolicyChangeRequestV2} [inferencePolicyChangeRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public updateInferencePolicyV2(validateOnly?: boolean, inferencePolicyChangeRequestV2?: InferencePolicyChangeRequestV2, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).updateInferencePolicyV2(validateOnly, inferencePolicyChangeRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to apply changes to training policy for a given organizational unit.
     * @summary Update a training policy.
     * @param {boolean} [validateOnly] Validate the given policy payload without applying it
     * @param {TrainingPolicyChangeRequestV2} [trainingPolicyChangeRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public updateTrainingPolicyV2(validateOnly?: boolean, trainingPolicyChangeRequestV2?: TrainingPolicyChangeRequestV2, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).updateTrainingPolicyV2(validateOnly, trainingPolicyChangeRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to apply changes to workspace policy for a given organizational unit.
     * @summary Update a workspace policy.
     * @param {boolean} [validateOnly] Validate the given policy payload without applying it
     * @param {WorkspacePolicyChangeRequestV2} [workspacePolicyChangeRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyApi
     */
    public updateWorkspacePolicyV2(validateOnly?: boolean, workspacePolicyChangeRequestV2?: WorkspacePolicyChangeRequestV2, options?: AxiosRequestConfig) {
        return PolicyApiFp(this.configuration).updateWorkspacePolicyV2(validateOnly, workspacePolicyChangeRequestV2, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SynchronizationApi - axios parameter creator
 * @export
 */
export const SynchronizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get distributed policies that needs to be synced to the cluster
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDistributedPolicies: async (clusterId: string, after?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('syncDistributedPolicies', 'clusterId', clusterId)
            const localVarPath = `/api/v2/policy/distributed/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get inference policies that needs to be synced to the cluster
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncInferencePolicies: async (clusterId: string, after?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('syncInferencePolicies', 'clusterId', clusterId)
            const localVarPath = `/api/v2/policy/inferences/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request distributed policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRequestDistributedPolicies: async (clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('syncRequestDistributedPolicies', 'clusterId', clusterId)
            const localVarPath = `/api/v2/policy/distributed/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clusterSyncReport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request inference policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRequestInferencePolicies: async (clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('syncRequestInferencePolicies', 'clusterId', clusterId)
            const localVarPath = `/api/v2/policy/inferences/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clusterSyncReport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request training policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRequestTrainingPolicies: async (clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('syncRequestTrainingPolicies', 'clusterId', clusterId)
            const localVarPath = `/api/v2/policy/trainings/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clusterSyncReport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request workspace policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRequestWorkspacePolicies: async (clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('syncRequestWorkspacePolicies', 'clusterId', clusterId)
            const localVarPath = `/api/v2/policy/workspaces/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clusterSyncReport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get training policies that needs to be synced to the cluster
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTrainingPolicies: async (clusterId: string, after?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('syncTrainingPolicies', 'clusterId', clusterId)
            const localVarPath = `/api/v2/policy/trainings/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get workspace policies that needs to be synced to the cluster
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncWorkspacePolicies: async (clusterId: string, after?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('syncWorkspacePolicies', 'clusterId', clusterId)
            const localVarPath = `/api/v2/policy/workspaces/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API intended for the cluster sync to update the sync status of a given distributed policy
         * @summary Update the sync status of a distributed policy
         * @param {SyncStatusUpdate} [syncStatusUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncStatusDistributed: async (syncStatusUpdate?: SyncStatusUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/policy/distributed/sync/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncStatusUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API intended for the cluster sync to update the sync status of a given inference policy
         * @summary Update the sync status of an inference policy
         * @param {SyncStatusUpdate} [syncStatusUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncStatusInference: async (syncStatusUpdate?: SyncStatusUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/policy/inferences/sync/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncStatusUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API intended for the cluster sync to update the sync status of a given training policy
         * @summary Update the sync status of a training policy
         * @param {SyncStatusUpdate} [syncStatusUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncStatusTraining: async (syncStatusUpdate?: SyncStatusUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/policy/trainings/sync/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncStatusUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API intended for the cluster sync to update the sync status of a given workspace policy
         * @summary Update the sync status of a workspace policy
         * @param {SyncStatusUpdate} [syncStatusUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncStatusWorkspace: async (syncStatusUpdate?: SyncStatusUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/policy/workspaces/sync/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncStatusUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SynchronizationApi - functional programming interface
 * @export
 */
export const SynchronizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SynchronizationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get distributed policies that needs to be synced to the cluster
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncDistributedPolicies(clusterId: string, after?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicySyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncDistributedPolicies(clusterId, after, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get inference policies that needs to be synced to the cluster
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncInferencePolicies(clusterId: string, after?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicySyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncInferencePolicies(clusterId, after, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request distributed policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncRequestDistributedPolicies(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicySyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncRequestDistributedPolicies(clusterId, after, clusterSyncReport, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request inference policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncRequestInferencePolicies(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicySyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncRequestInferencePolicies(clusterId, after, clusterSyncReport, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request training policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncRequestTrainingPolicies(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicySyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncRequestTrainingPolicies(clusterId, after, clusterSyncReport, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request workspace policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncRequestWorkspacePolicies(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicySyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncRequestWorkspacePolicies(clusterId, after, clusterSyncReport, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get training policies that needs to be synced to the cluster
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncTrainingPolicies(clusterId: string, after?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicySyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncTrainingPolicies(clusterId, after, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get workspace policies that needs to be synced to the cluster
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncWorkspacePolicies(clusterId: string, after?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicySyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncWorkspacePolicies(clusterId, after, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API intended for the cluster sync to update the sync status of a given distributed policy
         * @summary Update the sync status of a distributed policy
         * @param {SyncStatusUpdate} [syncStatusUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSyncStatusDistributed(syncStatusUpdate?: SyncStatusUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSyncStatusDistributed(syncStatusUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API intended for the cluster sync to update the sync status of a given inference policy
         * @summary Update the sync status of an inference policy
         * @param {SyncStatusUpdate} [syncStatusUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSyncStatusInference(syncStatusUpdate?: SyncStatusUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSyncStatusInference(syncStatusUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API intended for the cluster sync to update the sync status of a given training policy
         * @summary Update the sync status of a training policy
         * @param {SyncStatusUpdate} [syncStatusUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSyncStatusTraining(syncStatusUpdate?: SyncStatusUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSyncStatusTraining(syncStatusUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API intended for the cluster sync to update the sync status of a given workspace policy
         * @summary Update the sync status of a workspace policy
         * @param {SyncStatusUpdate} [syncStatusUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSyncStatusWorkspace(syncStatusUpdate?: SyncStatusUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSyncStatusWorkspace(syncStatusUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SynchronizationApi - factory interface
 * @export
 */
export const SynchronizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SynchronizationApiFp(configuration)
    return {
        /**
         * 
         * @summary Get distributed policies that needs to be synced to the cluster
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDistributedPolicies(clusterId: string, after?: number, options?: any): AxiosPromise<PolicySyncResponse> {
            return localVarFp.syncDistributedPolicies(clusterId, after, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get inference policies that needs to be synced to the cluster
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncInferencePolicies(clusterId: string, after?: number, options?: any): AxiosPromise<PolicySyncResponse> {
            return localVarFp.syncInferencePolicies(clusterId, after, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request distributed policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRequestDistributedPolicies(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: any): AxiosPromise<PolicySyncResponse> {
            return localVarFp.syncRequestDistributedPolicies(clusterId, after, clusterSyncReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request inference policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRequestInferencePolicies(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: any): AxiosPromise<PolicySyncResponse> {
            return localVarFp.syncRequestInferencePolicies(clusterId, after, clusterSyncReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request training policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRequestTrainingPolicies(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: any): AxiosPromise<PolicySyncResponse> {
            return localVarFp.syncRequestTrainingPolicies(clusterId, after, clusterSyncReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request workspace policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRequestWorkspacePolicies(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: any): AxiosPromise<PolicySyncResponse> {
            return localVarFp.syncRequestWorkspacePolicies(clusterId, after, clusterSyncReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get training policies that needs to be synced to the cluster
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTrainingPolicies(clusterId: string, after?: number, options?: any): AxiosPromise<PolicySyncResponse> {
            return localVarFp.syncTrainingPolicies(clusterId, after, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get workspace policies that needs to be synced to the cluster
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncWorkspacePolicies(clusterId: string, after?: number, options?: any): AxiosPromise<PolicySyncResponse> {
            return localVarFp.syncWorkspacePolicies(clusterId, after, options).then((request) => request(axios, basePath));
        },
        /**
         * This API intended for the cluster sync to update the sync status of a given distributed policy
         * @summary Update the sync status of a distributed policy
         * @param {SyncStatusUpdate} [syncStatusUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncStatusDistributed(syncStatusUpdate?: SyncStatusUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.updateSyncStatusDistributed(syncStatusUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * This API intended for the cluster sync to update the sync status of a given inference policy
         * @summary Update the sync status of an inference policy
         * @param {SyncStatusUpdate} [syncStatusUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncStatusInference(syncStatusUpdate?: SyncStatusUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.updateSyncStatusInference(syncStatusUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * This API intended for the cluster sync to update the sync status of a given training policy
         * @summary Update the sync status of a training policy
         * @param {SyncStatusUpdate} [syncStatusUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncStatusTraining(syncStatusUpdate?: SyncStatusUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.updateSyncStatusTraining(syncStatusUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * This API intended for the cluster sync to update the sync status of a given workspace policy
         * @summary Update the sync status of a workspace policy
         * @param {SyncStatusUpdate} [syncStatusUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncStatusWorkspace(syncStatusUpdate?: SyncStatusUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.updateSyncStatusWorkspace(syncStatusUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SynchronizationApi - object-oriented interface
 * @export
 * @class SynchronizationApi
 * @extends {BaseAPI}
 */
export class SynchronizationApi extends BaseAPI {
    /**
     * 
     * @summary Get distributed policies that needs to be synced to the cluster
     * @param {string} clusterId The id of the cluster
     * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncDistributedPolicies(clusterId: string, after?: number, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncDistributedPolicies(clusterId, after, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get inference policies that needs to be synced to the cluster
     * @param {string} clusterId The id of the cluster
     * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncInferencePolicies(clusterId: string, after?: number, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncInferencePolicies(clusterId, after, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request distributed policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
     * @param {string} clusterId The id of the cluster
     * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
     * @param {ClusterSyncReport} [clusterSyncReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncRequestDistributedPolicies(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncRequestDistributedPolicies(clusterId, after, clusterSyncReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request inference policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
     * @param {string} clusterId The id of the cluster
     * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
     * @param {ClusterSyncReport} [clusterSyncReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncRequestInferencePolicies(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncRequestInferencePolicies(clusterId, after, clusterSyncReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request training policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
     * @param {string} clusterId The id of the cluster
     * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
     * @param {ClusterSyncReport} [clusterSyncReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncRequestTrainingPolicies(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncRequestTrainingPolicies(clusterId, after, clusterSyncReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request workspace policies that needs to be synced to the cluster and allow the cluster to report success/failure of previous updates
     * @param {string} clusterId The id of the cluster
     * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
     * @param {ClusterSyncReport} [clusterSyncReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncRequestWorkspacePolicies(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncRequestWorkspacePolicies(clusterId, after, clusterSyncReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get training policies that needs to be synced to the cluster
     * @param {string} clusterId The id of the cluster
     * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncTrainingPolicies(clusterId: string, after?: number, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncTrainingPolicies(clusterId, after, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get workspace policies that needs to be synced to the cluster
     * @param {string} clusterId The id of the cluster
     * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncWorkspacePolicies(clusterId: string, after?: number, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncWorkspacePolicies(clusterId, after, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API intended for the cluster sync to update the sync status of a given distributed policy
     * @summary Update the sync status of a distributed policy
     * @param {SyncStatusUpdate} [syncStatusUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public updateSyncStatusDistributed(syncStatusUpdate?: SyncStatusUpdate, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).updateSyncStatusDistributed(syncStatusUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API intended for the cluster sync to update the sync status of a given inference policy
     * @summary Update the sync status of an inference policy
     * @param {SyncStatusUpdate} [syncStatusUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public updateSyncStatusInference(syncStatusUpdate?: SyncStatusUpdate, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).updateSyncStatusInference(syncStatusUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API intended for the cluster sync to update the sync status of a given training policy
     * @summary Update the sync status of a training policy
     * @param {SyncStatusUpdate} [syncStatusUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public updateSyncStatusTraining(syncStatusUpdate?: SyncStatusUpdate, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).updateSyncStatusTraining(syncStatusUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API intended for the cluster sync to update the sync status of a given workspace policy
     * @summary Update the sync status of a workspace policy
     * @param {SyncStatusUpdate} [syncStatusUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public updateSyncStatusWorkspace(syncStatusUpdate?: SyncStatusUpdate, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).updateSyncStatusWorkspace(syncStatusUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}


